(window["webpackJsonp"] = window["webpackJsonp"] || []).push([["main"],{

/***/ "./node_modules/moment/locale sync recursive ^\\.\\/.*$":
/*!**************************************************!*\
  !*** ./node_modules/moment/locale sync ^\.\/.*$ ***!
  \**************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "./node_modules/moment/locale/af.js",
	"./af.js": "./node_modules/moment/locale/af.js",
	"./ar": "./node_modules/moment/locale/ar.js",
	"./ar-dz": "./node_modules/moment/locale/ar-dz.js",
	"./ar-dz.js": "./node_modules/moment/locale/ar-dz.js",
	"./ar-kw": "./node_modules/moment/locale/ar-kw.js",
	"./ar-kw.js": "./node_modules/moment/locale/ar-kw.js",
	"./ar-ly": "./node_modules/moment/locale/ar-ly.js",
	"./ar-ly.js": "./node_modules/moment/locale/ar-ly.js",
	"./ar-ma": "./node_modules/moment/locale/ar-ma.js",
	"./ar-ma.js": "./node_modules/moment/locale/ar-ma.js",
	"./ar-sa": "./node_modules/moment/locale/ar-sa.js",
	"./ar-sa.js": "./node_modules/moment/locale/ar-sa.js",
	"./ar-tn": "./node_modules/moment/locale/ar-tn.js",
	"./ar-tn.js": "./node_modules/moment/locale/ar-tn.js",
	"./ar.js": "./node_modules/moment/locale/ar.js",
	"./az": "./node_modules/moment/locale/az.js",
	"./az.js": "./node_modules/moment/locale/az.js",
	"./be": "./node_modules/moment/locale/be.js",
	"./be.js": "./node_modules/moment/locale/be.js",
	"./bg": "./node_modules/moment/locale/bg.js",
	"./bg.js": "./node_modules/moment/locale/bg.js",
	"./bm": "./node_modules/moment/locale/bm.js",
	"./bm.js": "./node_modules/moment/locale/bm.js",
	"./bn": "./node_modules/moment/locale/bn.js",
	"./bn.js": "./node_modules/moment/locale/bn.js",
	"./bo": "./node_modules/moment/locale/bo.js",
	"./bo.js": "./node_modules/moment/locale/bo.js",
	"./br": "./node_modules/moment/locale/br.js",
	"./br.js": "./node_modules/moment/locale/br.js",
	"./bs": "./node_modules/moment/locale/bs.js",
	"./bs.js": "./node_modules/moment/locale/bs.js",
	"./ca": "./node_modules/moment/locale/ca.js",
	"./ca.js": "./node_modules/moment/locale/ca.js",
	"./cs": "./node_modules/moment/locale/cs.js",
	"./cs.js": "./node_modules/moment/locale/cs.js",
	"./cv": "./node_modules/moment/locale/cv.js",
	"./cv.js": "./node_modules/moment/locale/cv.js",
	"./cy": "./node_modules/moment/locale/cy.js",
	"./cy.js": "./node_modules/moment/locale/cy.js",
	"./da": "./node_modules/moment/locale/da.js",
	"./da.js": "./node_modules/moment/locale/da.js",
	"./de": "./node_modules/moment/locale/de.js",
	"./de-at": "./node_modules/moment/locale/de-at.js",
	"./de-at.js": "./node_modules/moment/locale/de-at.js",
	"./de-ch": "./node_modules/moment/locale/de-ch.js",
	"./de-ch.js": "./node_modules/moment/locale/de-ch.js",
	"./de.js": "./node_modules/moment/locale/de.js",
	"./dv": "./node_modules/moment/locale/dv.js",
	"./dv.js": "./node_modules/moment/locale/dv.js",
	"./el": "./node_modules/moment/locale/el.js",
	"./el.js": "./node_modules/moment/locale/el.js",
	"./en-SG": "./node_modules/moment/locale/en-SG.js",
	"./en-SG.js": "./node_modules/moment/locale/en-SG.js",
	"./en-au": "./node_modules/moment/locale/en-au.js",
	"./en-au.js": "./node_modules/moment/locale/en-au.js",
	"./en-ca": "./node_modules/moment/locale/en-ca.js",
	"./en-ca.js": "./node_modules/moment/locale/en-ca.js",
	"./en-gb": "./node_modules/moment/locale/en-gb.js",
	"./en-gb.js": "./node_modules/moment/locale/en-gb.js",
	"./en-ie": "./node_modules/moment/locale/en-ie.js",
	"./en-ie.js": "./node_modules/moment/locale/en-ie.js",
	"./en-il": "./node_modules/moment/locale/en-il.js",
	"./en-il.js": "./node_modules/moment/locale/en-il.js",
	"./en-nz": "./node_modules/moment/locale/en-nz.js",
	"./en-nz.js": "./node_modules/moment/locale/en-nz.js",
	"./eo": "./node_modules/moment/locale/eo.js",
	"./eo.js": "./node_modules/moment/locale/eo.js",
	"./es": "./node_modules/moment/locale/es.js",
	"./es-do": "./node_modules/moment/locale/es-do.js",
	"./es-do.js": "./node_modules/moment/locale/es-do.js",
	"./es-us": "./node_modules/moment/locale/es-us.js",
	"./es-us.js": "./node_modules/moment/locale/es-us.js",
	"./es.js": "./node_modules/moment/locale/es.js",
	"./et": "./node_modules/moment/locale/et.js",
	"./et.js": "./node_modules/moment/locale/et.js",
	"./eu": "./node_modules/moment/locale/eu.js",
	"./eu.js": "./node_modules/moment/locale/eu.js",
	"./fa": "./node_modules/moment/locale/fa.js",
	"./fa.js": "./node_modules/moment/locale/fa.js",
	"./fi": "./node_modules/moment/locale/fi.js",
	"./fi.js": "./node_modules/moment/locale/fi.js",
	"./fo": "./node_modules/moment/locale/fo.js",
	"./fo.js": "./node_modules/moment/locale/fo.js",
	"./fr": "./node_modules/moment/locale/fr.js",
	"./fr-ca": "./node_modules/moment/locale/fr-ca.js",
	"./fr-ca.js": "./node_modules/moment/locale/fr-ca.js",
	"./fr-ch": "./node_modules/moment/locale/fr-ch.js",
	"./fr-ch.js": "./node_modules/moment/locale/fr-ch.js",
	"./fr.js": "./node_modules/moment/locale/fr.js",
	"./fy": "./node_modules/moment/locale/fy.js",
	"./fy.js": "./node_modules/moment/locale/fy.js",
	"./ga": "./node_modules/moment/locale/ga.js",
	"./ga.js": "./node_modules/moment/locale/ga.js",
	"./gd": "./node_modules/moment/locale/gd.js",
	"./gd.js": "./node_modules/moment/locale/gd.js",
	"./gl": "./node_modules/moment/locale/gl.js",
	"./gl.js": "./node_modules/moment/locale/gl.js",
	"./gom-latn": "./node_modules/moment/locale/gom-latn.js",
	"./gom-latn.js": "./node_modules/moment/locale/gom-latn.js",
	"./gu": "./node_modules/moment/locale/gu.js",
	"./gu.js": "./node_modules/moment/locale/gu.js",
	"./he": "./node_modules/moment/locale/he.js",
	"./he.js": "./node_modules/moment/locale/he.js",
	"./hi": "./node_modules/moment/locale/hi.js",
	"./hi.js": "./node_modules/moment/locale/hi.js",
	"./hr": "./node_modules/moment/locale/hr.js",
	"./hr.js": "./node_modules/moment/locale/hr.js",
	"./hu": "./node_modules/moment/locale/hu.js",
	"./hu.js": "./node_modules/moment/locale/hu.js",
	"./hy-am": "./node_modules/moment/locale/hy-am.js",
	"./hy-am.js": "./node_modules/moment/locale/hy-am.js",
	"./id": "./node_modules/moment/locale/id.js",
	"./id.js": "./node_modules/moment/locale/id.js",
	"./is": "./node_modules/moment/locale/is.js",
	"./is.js": "./node_modules/moment/locale/is.js",
	"./it": "./node_modules/moment/locale/it.js",
	"./it-ch": "./node_modules/moment/locale/it-ch.js",
	"./it-ch.js": "./node_modules/moment/locale/it-ch.js",
	"./it.js": "./node_modules/moment/locale/it.js",
	"./ja": "./node_modules/moment/locale/ja.js",
	"./ja.js": "./node_modules/moment/locale/ja.js",
	"./jv": "./node_modules/moment/locale/jv.js",
	"./jv.js": "./node_modules/moment/locale/jv.js",
	"./ka": "./node_modules/moment/locale/ka.js",
	"./ka.js": "./node_modules/moment/locale/ka.js",
	"./kk": "./node_modules/moment/locale/kk.js",
	"./kk.js": "./node_modules/moment/locale/kk.js",
	"./km": "./node_modules/moment/locale/km.js",
	"./km.js": "./node_modules/moment/locale/km.js",
	"./kn": "./node_modules/moment/locale/kn.js",
	"./kn.js": "./node_modules/moment/locale/kn.js",
	"./ko": "./node_modules/moment/locale/ko.js",
	"./ko.js": "./node_modules/moment/locale/ko.js",
	"./ku": "./node_modules/moment/locale/ku.js",
	"./ku.js": "./node_modules/moment/locale/ku.js",
	"./ky": "./node_modules/moment/locale/ky.js",
	"./ky.js": "./node_modules/moment/locale/ky.js",
	"./lb": "./node_modules/moment/locale/lb.js",
	"./lb.js": "./node_modules/moment/locale/lb.js",
	"./lo": "./node_modules/moment/locale/lo.js",
	"./lo.js": "./node_modules/moment/locale/lo.js",
	"./lt": "./node_modules/moment/locale/lt.js",
	"./lt.js": "./node_modules/moment/locale/lt.js",
	"./lv": "./node_modules/moment/locale/lv.js",
	"./lv.js": "./node_modules/moment/locale/lv.js",
	"./me": "./node_modules/moment/locale/me.js",
	"./me.js": "./node_modules/moment/locale/me.js",
	"./mi": "./node_modules/moment/locale/mi.js",
	"./mi.js": "./node_modules/moment/locale/mi.js",
	"./mk": "./node_modules/moment/locale/mk.js",
	"./mk.js": "./node_modules/moment/locale/mk.js",
	"./ml": "./node_modules/moment/locale/ml.js",
	"./ml.js": "./node_modules/moment/locale/ml.js",
	"./mn": "./node_modules/moment/locale/mn.js",
	"./mn.js": "./node_modules/moment/locale/mn.js",
	"./mr": "./node_modules/moment/locale/mr.js",
	"./mr.js": "./node_modules/moment/locale/mr.js",
	"./ms": "./node_modules/moment/locale/ms.js",
	"./ms-my": "./node_modules/moment/locale/ms-my.js",
	"./ms-my.js": "./node_modules/moment/locale/ms-my.js",
	"./ms.js": "./node_modules/moment/locale/ms.js",
	"./mt": "./node_modules/moment/locale/mt.js",
	"./mt.js": "./node_modules/moment/locale/mt.js",
	"./my": "./node_modules/moment/locale/my.js",
	"./my.js": "./node_modules/moment/locale/my.js",
	"./nb": "./node_modules/moment/locale/nb.js",
	"./nb.js": "./node_modules/moment/locale/nb.js",
	"./ne": "./node_modules/moment/locale/ne.js",
	"./ne.js": "./node_modules/moment/locale/ne.js",
	"./nl": "./node_modules/moment/locale/nl.js",
	"./nl-be": "./node_modules/moment/locale/nl-be.js",
	"./nl-be.js": "./node_modules/moment/locale/nl-be.js",
	"./nl.js": "./node_modules/moment/locale/nl.js",
	"./nn": "./node_modules/moment/locale/nn.js",
	"./nn.js": "./node_modules/moment/locale/nn.js",
	"./pa-in": "./node_modules/moment/locale/pa-in.js",
	"./pa-in.js": "./node_modules/moment/locale/pa-in.js",
	"./pl": "./node_modules/moment/locale/pl.js",
	"./pl.js": "./node_modules/moment/locale/pl.js",
	"./pt": "./node_modules/moment/locale/pt.js",
	"./pt-br": "./node_modules/moment/locale/pt-br.js",
	"./pt-br.js": "./node_modules/moment/locale/pt-br.js",
	"./pt.js": "./node_modules/moment/locale/pt.js",
	"./ro": "./node_modules/moment/locale/ro.js",
	"./ro.js": "./node_modules/moment/locale/ro.js",
	"./ru": "./node_modules/moment/locale/ru.js",
	"./ru.js": "./node_modules/moment/locale/ru.js",
	"./sd": "./node_modules/moment/locale/sd.js",
	"./sd.js": "./node_modules/moment/locale/sd.js",
	"./se": "./node_modules/moment/locale/se.js",
	"./se.js": "./node_modules/moment/locale/se.js",
	"./si": "./node_modules/moment/locale/si.js",
	"./si.js": "./node_modules/moment/locale/si.js",
	"./sk": "./node_modules/moment/locale/sk.js",
	"./sk.js": "./node_modules/moment/locale/sk.js",
	"./sl": "./node_modules/moment/locale/sl.js",
	"./sl.js": "./node_modules/moment/locale/sl.js",
	"./sq": "./node_modules/moment/locale/sq.js",
	"./sq.js": "./node_modules/moment/locale/sq.js",
	"./sr": "./node_modules/moment/locale/sr.js",
	"./sr-cyrl": "./node_modules/moment/locale/sr-cyrl.js",
	"./sr-cyrl.js": "./node_modules/moment/locale/sr-cyrl.js",
	"./sr.js": "./node_modules/moment/locale/sr.js",
	"./ss": "./node_modules/moment/locale/ss.js",
	"./ss.js": "./node_modules/moment/locale/ss.js",
	"./sv": "./node_modules/moment/locale/sv.js",
	"./sv.js": "./node_modules/moment/locale/sv.js",
	"./sw": "./node_modules/moment/locale/sw.js",
	"./sw.js": "./node_modules/moment/locale/sw.js",
	"./ta": "./node_modules/moment/locale/ta.js",
	"./ta.js": "./node_modules/moment/locale/ta.js",
	"./te": "./node_modules/moment/locale/te.js",
	"./te.js": "./node_modules/moment/locale/te.js",
	"./tet": "./node_modules/moment/locale/tet.js",
	"./tet.js": "./node_modules/moment/locale/tet.js",
	"./tg": "./node_modules/moment/locale/tg.js",
	"./tg.js": "./node_modules/moment/locale/tg.js",
	"./th": "./node_modules/moment/locale/th.js",
	"./th.js": "./node_modules/moment/locale/th.js",
	"./tl-ph": "./node_modules/moment/locale/tl-ph.js",
	"./tl-ph.js": "./node_modules/moment/locale/tl-ph.js",
	"./tlh": "./node_modules/moment/locale/tlh.js",
	"./tlh.js": "./node_modules/moment/locale/tlh.js",
	"./tr": "./node_modules/moment/locale/tr.js",
	"./tr.js": "./node_modules/moment/locale/tr.js",
	"./tzl": "./node_modules/moment/locale/tzl.js",
	"./tzl.js": "./node_modules/moment/locale/tzl.js",
	"./tzm": "./node_modules/moment/locale/tzm.js",
	"./tzm-latn": "./node_modules/moment/locale/tzm-latn.js",
	"./tzm-latn.js": "./node_modules/moment/locale/tzm-latn.js",
	"./tzm.js": "./node_modules/moment/locale/tzm.js",
	"./ug-cn": "./node_modules/moment/locale/ug-cn.js",
	"./ug-cn.js": "./node_modules/moment/locale/ug-cn.js",
	"./uk": "./node_modules/moment/locale/uk.js",
	"./uk.js": "./node_modules/moment/locale/uk.js",
	"./ur": "./node_modules/moment/locale/ur.js",
	"./ur.js": "./node_modules/moment/locale/ur.js",
	"./uz": "./node_modules/moment/locale/uz.js",
	"./uz-latn": "./node_modules/moment/locale/uz-latn.js",
	"./uz-latn.js": "./node_modules/moment/locale/uz-latn.js",
	"./uz.js": "./node_modules/moment/locale/uz.js",
	"./vi": "./node_modules/moment/locale/vi.js",
	"./vi.js": "./node_modules/moment/locale/vi.js",
	"./x-pseudo": "./node_modules/moment/locale/x-pseudo.js",
	"./x-pseudo.js": "./node_modules/moment/locale/x-pseudo.js",
	"./yo": "./node_modules/moment/locale/yo.js",
	"./yo.js": "./node_modules/moment/locale/yo.js",
	"./zh-cn": "./node_modules/moment/locale/zh-cn.js",
	"./zh-cn.js": "./node_modules/moment/locale/zh-cn.js",
	"./zh-hk": "./node_modules/moment/locale/zh-hk.js",
	"./zh-hk.js": "./node_modules/moment/locale/zh-hk.js",
	"./zh-tw": "./node_modules/moment/locale/zh-tw.js",
	"./zh-tw.js": "./node_modules/moment/locale/zh-tw.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./node_modules/moment/locale sync recursive ^\\.\\/.*$";

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html":
/*!**************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html ***!
  \**************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"loading-overlay\" *ngIf=\"loading.loading\">\n  <mat-spinner color=\"accent\"></mat-spinner>\n</div>\n<simple-notifications></simple-notifications>\n\n<div class=\"content\">\n  <router-outlet></router-outlet>\n</div>\n\n<footer class=\"footer\">\n  <mat-form-field appearance=\"standard\" class=\"lang\">\n    <mat-select (selectionChange)=\"changeLang($event)\" [formControl]=\"langControl\">\n      <mat-option *ngFor=\"let lang of langs\" [value]=\"lang\">\n        {{ lang }}\n      </mat-option>\n    </mat-select>\n  </mat-form-field>\n\n  <button *ngIf=\"auth.isLoggedIn()\" mat-stroked-button routerLink=\"/price/tickets\">\n    {{ 'GENERAL.price_adjust' | translate }}\n  </button>\n</footer>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/car-invoice-print/car-invoice-print.component.html":
/*!*********************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/car-invoice-print/car-invoice-print.component.html ***!
  \*********************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<mat-progress-bar *ngIf=\"!imgFile && !imgLoaded\" mode=\"indeterminate\"></mat-progress-bar>\n<div *ngIf=\"!imgFile && !imgLoaded\" style=\"margin-bottom: 24px; background-color: lightyellow; padding: 16px 6px;\">\n  {{ 'NOTI.generating_qr_code' | translate }}\n</div>\n\n<mat-dialog-content id=\"print-content\">\n  <div>DLS Wertkartenvertriebs GmbH</div>\n  <div>Autokinostrasse 2</div>\n  <div>2301 Groß Enzersdorf</div>\n  <div>Österreich</div>\n  <div>UID: ATU68017503</div>\n  <br>\n  <table>\n    <tr>\n      <td>Datum: {{ mymoment(data.created_at).format('DD.MM.YYYY.') }}</td>\n      <td>Zeit: {{ mymoment(data.created_at).format('HH:mm:ss') }}</td>\n    </tr>\n  </table>\n  <hr>\n  <table>\n    <tr *ngFor=\"let booking of data.carMarketBooking.booking_dates\">\n      <td>\n        {{ booking.date }}\n      </td>\n      <td>\n        €{{ (data.total / data.amount).toFixed(2) }}\n      </td>\n    </tr>\n  </table>\n  <hr>\n  <table>\n    <tr>\n      <td>Summe (inkl. MWSt)</td>\n      <td>€{{ data.total.toFixed(2) }}</td>\n    </tr>\n  </table>\n  <br>\n  <div>In der Summe enthalten:</div>\n  <div>MWSt 20%: €{{ data.vat_amount.toFixed(2) }}</div>\n  <div>Summe Netto: €{{ data.base_price.toFixed(2) }}</div>\n  <br>\n  <div>Rechnungsnr: {{ data.id }}</div>\n  <br>\n  <img [src]=\"imgFile\" (load)=\"printInvoice()\" *ngIf=\"imgFile\">\n  <p *ngIf=\"!imgFile\">\n    Signatureinheit offline\n  </p>\n</mat-dialog-content>\n\n<mat-dialog-actions>\n  <button mat-raised-button mat-dialog-close>{{ 'GENERAL.close' | translate }}</button>\n\n  <button mat-raised-button color=\"primary\" [disabled]=\"!imgLoaded\" (click)=\"printInvoice()\">{{ 'GENERAL.print_receipt' | translate }}</button>\n</mat-dialog-actions>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/car-market-booking/car-market-booking.component.html":
/*!***********************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/car-market-booking/car-market-booking.component.html ***!
  \***********************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<mat-toolbar color=\"primary\" class=\"mat-elevation-z4\">\n  <mat-toolbar-row>\n    <span class=\"nav-item\">\n      <button type=\"button\" mat-raised-button (click)=\"goBack()\">\n        <i class=\"fas fa-chevron-left\"></i>&nbsp; {{ 'GENERAL.back' | translate }}\n      </button>\n    </span>\n    <span class=\"spacer\"></span>\n    <span class=\"nav-item\">\n      <span>\n        {{ 'GENERAL.car_market_booking' | translate }}\n      </span>\n    </span>\n    <span class=\"spacer\"></span>\n    <span class=\"nav-item\">\n      <button [disabled]=\"imageUploading\" mat-raised-button color=\"accent\" (click)=\"submitForm()\">\n        {{ 'FORM.save_changes' | translate }}\n      </button>\n    </span>\n\n    <a mat-stroked-button style=\"min-width: 0;\" href=\"javascript:location.href = 'http://closekiosk'\">\n      <mat-icon>close</mat-icon>\n    </a>\n  </mat-toolbar-row>\n</mat-toolbar>\n\n<div *ngIf=\"loadingData\">\n  <br>\n  <mat-progress-bar color=\"primary\" mode=\"buffer\" value=\"0\"></mat-progress-bar>\n</div>\n\n<div class=\"container-fluid wrapper\" *ngIf=\"!loadingData\">\n  <!-- Dates and ticket form row -->\n  <div class=\"row\">\n    <!-- Dates form -->\n    <ng-container [formGroup]=\"datesForm\">\n      <mat-list class=\"col-sm-4\" formArrayName=\"dates\">\n        <ng-container *ngFor=\"let date_control of getDatesControls(); let i=index\">\n          <mat-list-item formGroupName=\"{{ i }}\">\n            <mat-form-field appearance=\"standard\" style=\"margin-right: 8px;\">\n              <mat-label>{{ 'GENERAL.date' | translate }}</mat-label>\n              <select matNativeControl formControlName=\"date\">\n                <option [value]=\"date\" *ngFor=\"let date of dates\">\n                  {{ date }}\n                </option>\n              </select>\n            </mat-form-field>\n            <button type=\"button\" mat-raised-button *ngIf=\"i !== 0 && !bookingID\" (click)=\"removeDate(i)\">\n              <i class=\"far fa-trash-alt\"></i>\n            </button>\n          </mat-list-item>\n        </ng-container>\n      </mat-list>\n    </ng-container>\n\n    <!-- Ticket price form -->\n    <form [formGroup]=\"ticketPriceForm\" class=\"col\">\n      <div class=\"row\">\n        <div class=\"col-sm-2\">\n          <mat-form-field appearance=\"standard\">\n            <mat-select #amount [value]=\"1\" [disabled]=\"bookingID\">\n              <mat-option *ngFor=\"let a of addAmountDropdown\" [value]=\"a\">\n                {{ a }}\n              </mat-option>\n            </mat-select>\n          </mat-form-field>\n        </div>\n        <div class=\"col flex-v-align-center\">\n          <button [disabled]=\"bookingID\" type=\"button\" mat-raised-button color=\"accent\" (click)=\"addNewDate(amount.value)\">{{ 'FORM.add' | translate }}</button>\n        </div>\n      </div>\n\n      <div class=\"row\">\n        <div class=\"col-sm-12 col-md-4 action-stack\">\n          <div class=\"date-action\">\n            <button [disabled]=\"bookingID\" (click)=\"addUntilEndOfMonth()\" type=\"button\" color=\"accent\" mat-raised-button>{{ 'BUTTON.until_the_end_of_the_month' | translate }}</button>\n          </div>\n          <div class=\"date-action\">\n            <button [disabled]=\"bookingID\" (click)=\"addUntilEndOfYear()\" type=\"button\" color=\"accent\" mat-raised-button>{{ 'BUTTON.until_the_end_of_the_year' | translate }}</button>\n          </div>\n          <div class=\"date-action\">\n            <button [disabled]=\"bookingID\" (click)=\"addOneYear()\" type=\"button\" color=\"accent\" mat-raised-button>{{ 'BUTTON.add_one_year' | translate }}</button>\n          </div>\n          <div class=\"discount\">\n            <mat-radio-group formControlName=\"price_type\" class=\"discount-radio-group\">\n              <mat-radio-button class=\"discount-button\" [value]=\"false\">\n                {{ 'FORM.regular_price' | translate }}\n              </mat-radio-button>\n              <mat-radio-button class=\"discount-button\" [value]=\"true\">\n                {{ 'FORM.discount_price' | translate }}\n              </mat-radio-button>\n            </mat-radio-group>\n          </div>\n          <div class=\"price\">\n            <div class=\"unit-price\">\n              <mat-form-field appearance=\"standard\">\n                <span matPrefix>\n                  <i class=\"fas fa-money-bill-wave\"></i>&nbsp;&nbsp;\n                </span>\n                <mat-label>{{ 'FORM.unit_price' | translate }}</mat-label>\n                <input formControlName=\"unit_price\" matInput min=\"0\" type=\"number\">\n              </mat-form-field>\n            </div>\n            <div class=\"sum\">\n              <mat-form-field appearance=\"standard\">\n                <span matPrefix>\n                  <i class=\"fas fa-money-bill-wave\"></i>&nbsp;&nbsp;\n                </span>\n                <mat-label>{{ 'TABLE.total' | translate }}</mat-label>\n                <input formControlName=\"sum\" matInput type=\"number\" min=\"0\" [value]=\"\">\n              </mat-form-field>\n            </div>\n          </div>\n        </div>\n      </div>\n    </form>\n  </div>\n\n  <!-- User info form -->\n  <form [formGroup]=\"userInfoForm\" class=\"row\">\n    <div class=\"col-sm-12 col-md-6\">\n      <div class=\"row\">\n        <div class=\"col-sm-6\">\n          <mat-form-field appearance=\"standard\">\n            <span matPrefix>\n              <i class=\"far fa-user\"></i>&nbsp;&nbsp;\n            </span>\n            <mat-label>{{ 'FORM.first_name' | translate }}</mat-label>\n            <input matInput formControlName=\"first_name\">\n          </mat-form-field>\n        </div>\n        <div class=\"col-sm-6\">\n          <mat-form-field appearance=\"standard\">\n            <span matPrefix>\n              <i class=\"far fa-user\"></i>&nbsp;&nbsp;\n            </span>\n            <mat-label>{{ 'FORM.last_name' | translate }}</mat-label>\n            <input matInput formControlName=\"last_name\">\n          </mat-form-field>\n        </div>\n      </div>\n      <div class=\"row\">\n        <div class=\"col-sm-12\">\n          <mat-form-field appearance=\"standard\">\n            <span matPrefix>\n              <i class=\"fas fa-at\"></i>&nbsp;&nbsp;\n            </span>\n            <mat-label>{{ 'FORM.email' | translate }}</mat-label>\n            <input type=\"email\" matInput formControlName=\"email\">\n            <mat-error *ngIf=\"userInfoForm.controls['email'].hasError('email')\">\n              {{ 'ERR.enter_valid_email' | translate }}\n            </mat-error>\n          </mat-form-field>\n        </div>\n      </div>\n      <div class=\"row\">\n        <div class=\"col-sm-12\">\n          <mat-form-field appearance=\"standard\">\n            <span matPrefix>\n              <i class=\"fas fa-mobile-alt\"></i>&nbsp;&nbsp;\n            </span>\n            <mat-label>{{ 'FORM.phone_number' | translate }}</mat-label>\n            <input type=\"tel\" matInput formControlName=\"phone_number\">\n          </mat-form-field>\n        </div>\n      </div>\n      <div class=\"row\">\n        <div class=\"col-sm-12\">\n          <mat-form-field appearance=\"standard\">\n            <span matPrefix>\n              <i class=\"far fa-building\"></i>&nbsp;&nbsp;\n            </span>\n            <mat-label>{{ 'FORM.company' | translate }}</mat-label>\n            <input matInput formControlName=\"company\">\n          </mat-form-field>\n        </div>\n      </div>\n      <div class=\"row\">\n        <div class=\"col-sm-8\">\n          <mat-form-field appearance=\"standard\">\n            <span matPrefix>\n              <i class=\"fas fa-road\"></i>&nbsp;&nbsp;\n            </span>\n            <mat-label>{{ 'FORM.street' | translate }}</mat-label>\n            <input matInput formControlName=\"street\">\n          </mat-form-field>\n        </div>\n        <div class=\"col-sm-4\">\n          <mat-form-field appearance=\"standard\">\n            <span matPrefix>\n              <i class=\"fas fa-home\"></i>&nbsp;&nbsp;\n            </span>\n            <mat-label>{{ 'FORM.number' | translate }}</mat-label>\n            <input matInput formControlName=\"street_number\">\n          </mat-form-field>\n        </div>\n      </div>\n      <div class=\"row\">\n        <div class=\"col-sm-8\">\n          <mat-form-field appearance=\"standard\">\n            <span matPrefix>\n              <i class=\"fas fa-home\"></i>&nbsp;&nbsp;\n            </span>\n            <mat-label>{{ 'FORM.place' | translate }}</mat-label>\n            <input matInput formControlName=\"place\">\n          </mat-form-field>\n        </div>\n        <div class=\"col-sm-4\">\n          <mat-form-field appearance=\"standard\">\n            <span matPrefix>\n              <i class=\"fas fa-home\"></i>&nbsp;&nbsp;\n            </span>\n            <mat-label>{{ 'FORM.post_code' | translate }}</mat-label>\n            <input matInput formControlName=\"post_code\">\n          </mat-form-field>\n        </div>\n      </div>\n\n    </div>\n  </form>\n\n  <!-- Car info form -->\n  <form [formGroup]=\"carInfoForm\" class=\"row car-info\">\n    <div class=\"col-sm-12 col-md-6\">\n      <!-- Price details -->\n      <div class=\"row\" *ngIf=\"booking\">\n        <div class=\"col-sm-12 status-boxes\">\n          <div class=\"box\">\n            <span>{{ 'STATUS.BOX.booking_for' | translate }}</span>\n            <span>{{ booking.booking_dates.length }}</span>\n            <span>{{ 'STATUS.BOX.weeks' | translate }}</span>\n          </div>\n          <div class=\"box\">\n            <span>{{ 'STATUS.BOX.rest' | translate }}</span>\n            <span>{{ remainingWeeks() }}</span>\n            <span>{{ 'STATUS.BOX.weeks' | translate }}</span>\n          </div>\n          <div class=\"box\">\n            <span>{{ 'STATUS.BOX.to_be_paid' | translate }}</span>\n            <span>{{ (booking.total - booking.payed_amount).toFixed(2) }}</span>\n            <span>{{ 'STATUS.BOX.euro' | translate }}</span>\n          </div>\n        </div>\n      </div>\n      <div class=\"row\" *ngIf=\"booking\">\n        <div class=\"col\">\n          <span class=\"subtitle\">\n            {{ 'FORM.features' | translate }}\n          </span>\n        </div>\n      </div>\n      <div class=\"row flex-v-align-center\" *ngIf=\"booking\">\n        <div class=\"col-sm-12\">\n          <button (click)=\"createStorno()\" type=\"button\" mat-raised-button color=\"accent\" [disabled]=\"booking.status === 5\">\n            {{ 'BUTTON.add_cancellation' | translate }}\n          </button>\n        </div>\n        <div class=\"col-sm-3\">\n          <mat-form-field appearance=\"standard\">\n            <input matInput type=\"number\" [formControl]=\"topayControl\">\n            <span matSuffix>\n              &nbsp;€\n            </span>\n            <mat-error *ngIf=\"topayControl.hasError('required') || topayControl.hasError('min')\">\n              {{ 'ERR.this_field_is_required' | translate }}\n            </mat-error>\n          </mat-form-field>\n        </div>\n        <div class=\"col\">\n          <button type=\"button\" mat-raised-button color=\"accent\" (click)=\"createInvoice()\" [disabled]=\"topayControl.invalid\">\n            {{ 'GENERAL.print_receipt' | translate }}\n          </button>\n        </div>\n      </div>\n      <div class=\"row\" *ngIf=\"booking && booking.invoices.length > 0\">\n        <div class=\"col-sm-12 section-title\">\n          {{ 'GENERAL.done' | translate }}\n        </div>\n        <div class=\"col-sm-12\">\n          <div *ngFor=\"let invoice of booking.invoices\" style=\"padding: 3px 0\">\n            {{ invoice.created_at | date:'dd.MM.yyyy. HH:mm' }} -- {{ 'TABLE.paid' | translate | lowercase }} -- €{{ invoice.total }}\n\n            <button mat-raised-button (click)=\"printInvoiceById(invoice.id)\" style=\"min-width: 0\">\n              <i class=\"fas fa-print\"></i>\n            </button>\n          </div>\n        </div>\n      </div>\n\n      <br>\n\n      <!-- Vehicle data -->\n      <div class=\"row\">\n        <div class=\"col\" style=\"margin-bottom: 16px\">\n          <span class=\"subtitle\">\n            {{ 'FORM.vehicle_data' | translate }}\n          </span>\n        </div>\n      </div>\n      <div class=\"row\">\n        <div class=\"col-sm-6\">\n          <mat-form-field appearance=\"standard\">\n            <mat-label>{{ 'FORM.vehicle_manufacturers' | translate }}</mat-label>\n            <input type=\"text\" matInput formControlName=\"vehicle_manufacturers\">\n          </mat-form-field>\n        </div>\n        <div class=\"col-sm-6\">\n          <mat-form-field appearance=\"standard\">\n            <mat-label>{{ 'FORM.vehicle_model' | translate }}</mat-label>\n            <input type=\"text\" matInput formControlName=\"vehicle_model\">\n          </mat-form-field>\n        </div>\n      </div>\n      <div class=\"row\">\n        <div class=\"col-sm-4\">\n          <mat-form-field appearance=\"standard\">\n            <mat-label>{{ 'FORM.price' | translate }} €</mat-label>\n            <input type=\"number\" matInput formControlName=\"vehicle_price\" min=\"0\">\n          </mat-form-field>\n        </div>\n      </div>\n      <div class=\"row\">\n        <div class=\"col-sm-12\">\n          <mat-progress-bar mode=\"buffer\" color=\"accent\" [value]=\"0\" *ngIf=\"imageUploading\"></mat-progress-bar>\n          <input #fileInput accept=\"image/*\" type=\"file\" name=\"image\" hidden (change)=\"onFileChanged($event.target.files)\">\n          <img [src]=\"image\" alt=\"Car picture\" *ngIf=\"image\" style=\"width: 100%\">\n          <img [src]=\"'https://autokinov2.q-tests.com/api/' + getCarFormControlValue('vehicle_url')\" alt=\"Car picture\" *ngIf=\"!image && getCarFormControlValue('vehicle_url') != ''\"\n            style=\"width: 100%; cursor: pointer;\" (click)=\"fileInput.click()\">\n\n          <div class=\"image_preview\" *ngIf=\"!image && getCarFormControlValue('vehicle_url') === ''\" (click)=\"fileInput.click()\">\n            <span>\n              {{ 'FORM.click_to_upload_photo' | translate }}\n            </span>\n          </div>\n        </div>\n      </div>\n      <div class=\"row\">\n        <div class=\"col-sm-12 online-ad\">\n          <span>\n            {{ 'GENERAL.online_ad' | translate }}\n          </span>\n          <p>\n            {{ 'GENERAL.online_ad_desc' | translate }}\n          </p>\n        </div>\n      </div>\n      <div class=\"row\">\n        <div class=\"col-sm-12\">\n          <mat-form-field appearance=\"standard\">\n            <mat-label>{{ 'FORM.description' | translate }}</mat-label>\n            <textarea matInput formControlName=\"ad_desc\"></textarea>\n          </mat-form-field>\n        </div>\n      </div>\n    </div>\n  </form>\n\n  <!-- Save changes button -->\n  <div class=\"row\">\n    <div class=\"col save-button\">\n      <button [disabled]=\"imageUploading\" mat-raised-button color=\"accent\" (click)=\"submitForm()\">\n        {{ 'FORM.save_changes' | translate }}\n      </button>\n    </div>\n  </div>\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/car-market/car-market.component.html":
/*!*******************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/car-market/car-market.component.html ***!
  \*******************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<mat-toolbar color=\"primary\" class=\"mat-elevation-z4\">\n  <mat-toolbar-row>\n    <span class=\"nav-item\">\n      <button mat-raised-button [routerLink]=\"[nav.navLinks.schedule_view.url]\" [routerLinkActive]=\"['mat-accent']\">\n        <span translate>{{ nav.navLinks.schedule_view.name }}</span>\n      </button>\n      <button mat-raised-button [routerLink]=\"[nav.navLinks.table_view.url]\" [routerLinkActive]=\"['mat-accent']\">\n        <span translate>{{ nav.navLinks.table_view.name }}</span>\n      </button>\n      <button mat-raised-button [routerLink]=\"[nav.navLinks.car_market.url]\" [routerLinkActive]=\"['mat-accent']\">\n        <span translate>{{ nav.navLinks.car_market.name }}</span>\n      </button>\n      <button mat-raised-button [routerLink]=\"[nav.navLinks.kino.url]\" [routerLinkActive]=\"['mat-accent']\">\n        <span translate>{{ nav.navLinks.kino.name }}</span>\n      </button>\n    </span>\n    <span class=\"spacer\"></span>\n    <span class=\"nav-item\">\n      <button mat-raised-button [routerLink]=\"['booking']\">\n        {{ 'GENERAL.add_booking' | translate }}\n      </button>\n    </span>\n    <span class=\"spacer\"></span>\n    <a mat-stroked-button style=\"min-width: 0;\" href=\"javascript:location.href = 'http://closekiosk'\">\n      <mat-icon>close</mat-icon>\n    </a>\n  </mat-toolbar-row>\n</mat-toolbar>\n\n<div class=\"container-fluid wrapper\">\n  <form>\n    <div class=\"row\">\n      <div class=\"col-sm-12 filter-row\">\n        <div class=\"date-filter\">\n          <mat-form-field appearance=\"standard\" color=\"accent\">\n            <mat-label>{{ 'FORM.date_from' | translate }}</mat-label>\n            <input [formControl]=\"date_from_Control\" [max]=\"date_to_Control.value\" name=\"date_from\" (click)=\"picker_from.open()\" matInput [matDatepicker]=\"picker_from\">\n            <mat-datepicker-toggle matSuffix [for]=\"picker_from\"></mat-datepicker-toggle>\n            <mat-datepicker (closed)=\"getData()\" touchUi=\"true\" #picker_from></mat-datepicker>\n          </mat-form-field>\n        </div>\n\n        <div class=\"date-filter\">\n          <mat-form-field appearance=\"standard\" color=\"accent\">\n            <mat-label>{{ 'FORM.date_to' | translate }}</mat-label>\n            <input [formControl]=\"date_to_Control\" [min]=\"date_from_Control.value\" name=\"date_to\" (click)=\"picker_to.open()\" matInput [matDatepicker]=\"picker_to\">\n            <mat-datepicker-toggle matSuffix [for]=\"picker_to\"></mat-datepicker-toggle>\n            <mat-datepicker (closed)=\"getData()\" touchUi=\"true\" #picker_to></mat-datepicker>\n          </mat-form-field>\n        </div>\n\n        <div class=\"status-filter\">\n          <mat-form-field appearance=\"standard\" style=\"width: 100%\">\n            <mat-label>{{ 'STATUS.status' | translate }}</mat-label>\n            <mat-select [formControl]=\"status_Control\" multiple (selectionChange)=\"filterResults()\">\n              <mat-option [value]=\"-1\" (click)=\"resetStatusSelection()\">\n                <span translate>{{ 'STATUS.all' }}</span>\n              </mat-option>\n              <mat-option *ngFor=\"let status of statuses\" [value]=\"status.id\">\n                <span translate>{{ status.name }}</span>\n              </mat-option>\n            </mat-select>\n            <mat-error *ngIf=\"status_Control.hasError('required')\">\n              {{ 'ERR.status_is_required' | translate }}\n            </mat-error>\n          </mat-form-field>\n        </div>\n\n        <!-- <div class=\"origin-filter\">\n          <mat-form-field appearance=\"standard\">\n            <mat-select placeholder=\"{{ 'ORIGIN.origin' | translate }}\" [formControl]=\"origin_Control\">\n              <mat-option *ngFor=\"let origin of origins\" [value]=\"origin.id\">\n                <span translate>{{ origin.name }}</span>\n              </mat-option>\n            </mat-select>\n            <mat-error *ngIf=\"origin_Control.hasError('required')\">\n              {{ 'ERR.origin_is_required' | translate }}\n            </mat-error>\n          </mat-form-field>\n        </div> -->\n\n        <div class=\"reset-filter\">\n          <button mat-raised-button color=\"warn\" (click)=\"resetFilters()\">{{ 'GENERAL.reset' | translate }}</button>\n        </div>\n      </div>\n    </div>\n  </form>\n\n  <div id=\"print\" class=\"table-wrapper mat-elevation-z8\" *ngIf=\"!loading; else spinner\">\n    <table mat-table #table [dataSource]=\"dataSource\" matSort>\n\n      <!-- ID Column -->\n      <ng-container matColumnDef=\"id\">\n        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'TABLE.id_number' | translate }} </th>\n        <td mat-cell *matCellDef=\"let element\"> {{element.id}} </td>\n      </ng-container>\n\n      <!-- Place number Column -->\n      <ng-container matColumnDef=\"spots\">\n        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'TABLE.place_number' | translate }} </th>\n        <td mat-cell *matCellDef=\"let element\"> {{element.spots}} </td>\n      </ng-container>\n\n      <!-- Date Column -->\n      <ng-container matColumnDef=\"date\">\n        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'TABLE.date' | translate }} </th>\n        <td mat-cell *matCellDef=\"let element\"> {{ element.date | date:'dd.MM.yyyy' }} </td>\n      </ng-container>\n\n      <!-- Paid Column -->\n      <ng-container matColumnDef=\"status\">\n        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'TABLE.paid' | translate }} </th>\n        <td mat-cell *matCellDef=\"let element\">\n          <span class=\"paid-status\"\n            [style.backgroundColor]=\"getStatusColor(element)\"\n            matTooltip=\"{{ getStatusTooltip(element) | translate }}\"></span>\n        </td>\n      </ng-container>\n\n      <!-- total Column -->\n      <ng-container matColumnDef=\"total\">\n        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'TABLE.earned_today' | translate }}({{ 'TABLE.total' | translate }}) </th>\n        <td mat-cell *matCellDef=\"let element\"> {{ element.earned_today }}({{element.total}}) </td>\n      </ng-container>\n\n      <!-- info Column -->\n      <ng-container matColumnDef=\"customer\">\n        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'TABLE.info' | translate }} </th>\n        <td mat-cell *matCellDef=\"let element\"> {{element.customer}} </td>\n      </ng-container>\n\n      <!-- edit Column -->\n      <ng-container matColumnDef=\"edit\">\n        <th mat-header-cell *matHeaderCellDef> {{ 'TABLE.edit' | translate }} </th>\n        <td mat-cell *matCellDef=\"let element\">\n          <button mat-button [routerLink]=\"['booking', element.id]\">\n            <i class=\"far fa-edit fa-2x\"></i>\n          </button>\n        </td>\n      </ng-container>\n\n      <tr mat-header-row *matHeaderRowDef=\"displayedColumns\"></tr>\n      <tr mat-row *matRowDef=\"let row; columns: displayedColumns;\"></tr>\n    </table>\n  </div>\n\n  <ng-template #spinner>\n    <div class=\"spiner\">\n      <mat-spinner></mat-spinner>\n    </div>\n  </ng-template>\n\n  <div class=\"row sum-report\">\n    <div class=\"col-sm-4\">\n      <h4>{{ 'TABLE.sum_of_the_data_above' | translate }}</h4>\n      <div class=\"sum-row\">\n        <span>{{ 'TABLE.sum_with_tax' | translate }}</span>\n        <span>€ {{ data?.earned.toFixed(2) || 0 }}</span>\n      </div>\n      <div class=\"sum-row\">\n        <span>{{ 'TABLE.total_20%' | translate }}</span>\n        <span>€ {{ data?.tax_amount.toFixed(2) || 0 }}</span>\n      </div>\n      <div class=\"sum-row\">\n        <span>{{ 'TABLE.sum_without_tax' | translate }}</span>\n        <span>€ {{ data?.earned_without_tax.toFixed(2) || 0 }}</span>\n      </div>\n      <div class=\"sum-row\">\n        <span>{{ 'TABLE.still_open' | translate }}</span>\n        <span>€ {{ data?.unpaid.toFixed(2) || 0 }}</span>\n      </div>\n    </div>\n\n    <div class=\"col-sm-8 sum-actions\">\n      <button [disabled]=\"tableData.length < 1\" (click)=\"pdf()\" color=\"accent\" mat-raised-button>\n        {{ 'GENERAL.download_all_invoices_from_above' | translate }}\n      </button>\n      <button [disabled]=\"tableData.length < 1\" (click)=\"excel()\" color=\"accent\" mat-raised-button>\n        {{ 'GENERAL.download_table_excel' | translate }}\n      </button>\n      <button [disabled]=\"tableData.length < 1\" (click)=\"print()\" color=\"accent\" mat-raised-button>\n        {{ 'GENERAL.print_table' | translate }}\n      </button>\n    </div>\n  </div>\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/changes-not-saved-dialog/changes-not-saved-dialog.component.html":
/*!***********************************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/changes-not-saved-dialog/changes-not-saved-dialog.component.html ***!
  \***********************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<h2 mat-dialog-title>\n  {{ 'NOTI.changes_not_saved' | translate }}\n</h2>\n<mat-dialog-content>\n  {{ 'NOTI.are_you_sure_you_want_to_leave' | translate }}\n</mat-dialog-content>\n<mat-dialog-actions>\n  <button color=\"warn\" mat-stroked-button mat-dialog-close>{{ 'BUTTON.no' | translate }}</button>\n  <span class=\"spacer\"></span>\n  <!-- The mat-dialog-close directive optionally accepts a value as a result for the dialog. -->\n  <button color=\"accent\" mat-stroked-button [mat-dialog-close]=\"true\">{{ 'BUTTON.yes' | translate }}</button>\n</mat-dialog-actions>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/event-log/event-log.component.html":
/*!*****************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/event-log/event-log.component.html ***!
  \*****************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<mat-list>\n  <mat-list-item *ngFor=\"let log of eventLog\">\n    {{ log.created_at | date:'dd.MM.yyyy. HH:mm' }} Uhr Platz {{ log.event_type }} € {{ log.total.toFixed(2) }}\n  </mat-list-item>\n</mat-list>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/flea-invoice-print/flea-invoice-print.component.html":
/*!***********************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/flea-invoice-print/flea-invoice-print.component.html ***!
  \***********************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<mat-progress-bar *ngIf=\"!imgFile && !imgLoaded\" mode=\"indeterminate\"></mat-progress-bar>\n<div *ngIf=\"!imgFile && !imgLoaded\" style=\"margin-bottom: 24px; background-color: lightyellow; padding: 16px 6px;\">\n  {{ 'NOTI.generating_qr_code' | translate }}\n</div>\n\n<mat-dialog-content id=\"print-content\">\n\n  <ng-container *ngIf=\"!data.canceled\">\n    <div>DLS Wertkartenvertriebs GmbH</div>\n    <div>Autokinostrasse 2</div>\n    <div>2301 Groß Enzersdorf</div>\n    <div>Österreich</div>\n    <div>UID: ATU68017503</div>\n    <br>\n    <table>\n      <tr>\n        <td>Datum: {{ mymoment(data.created_at).format('DD.MM.YYYY.') }}</td>\n        <td>Zeit: {{ mymoment(data.created_at).format('HH:mm:ss') }}</td>\n      </tr>\n    </table>\n    <hr>\n    <table>\n      <tr *ngFor=\"let booking of bookings\">\n        <td>\n          {{ booking.spotAmount }} Stück x\n          <br>Miete {{ booking.date }}\n        </td>\n        <td>\n          €{{ ((data.total / data.amount) * booking.spotAmount).toFixed(2) }}\n        </td>\n      </tr>\n    </table>\n    <hr>\n    <table>\n      <tr>\n        <td>Summe (inkl. MWSt)</td>\n        <td>€{{ data.total.toFixed(2) }}</td>\n      </tr>\n    </table>\n    <br>\n    <div>In der Summe enthalten:</div>\n    <div>MWSt 20%: €{{ data.vat_amount.toFixed(2) }}</div>\n    <div>Summe Netto: €{{ data.base_price.toFixed(2) }}</div>\n    <br>\n    <div>Rechnungsnr: {{ data.id }}</div>\n    <br>\n    <hr>\n    <div>\n      Platz # {{ bookedSpots }}\n    </div>\n  </ng-container>\n\n  <ng-container *ngIf=\"data.canceled\">\n    <div>{{ mymoment().format('DD.MM.YYYY') }}</div>\n    <div>Storno no.: {{ data.invoiceNumber }}</div>\n    <br>\n    <div *ngFor=\"let booking of bookings\">\n      <div>{{ booking.spotAmount }} x Leihgebühr {{ booking.date }} €{{ abs(booking.ticketPrice) }}</div>\n    </div>\n    <br>\n    <div>Summe mit Steuer €{{ abs(data.total.toFixed(2)) }}</div>\n    <br>\n    <div>Summe 20% Ust €{{ abs(data.vat_amount.toFixed(2)) }}</div>\n    <div>Summe ohne Steuer €{{ abs(data.base_price.toFixed(2)) }}</div>\n    <br>\n  </ng-container>\n\n  <img *ngIf=\"imgFile\" [src]=\"imgFile\" (load)=\"printInvoice()\">\n  <p *ngIf=\"!imgFile\">\n    Signatureinheit offline\n  </p>\n</mat-dialog-content>\n\n<mat-dialog-actions>\n  <button mat-raised-button mat-dialog-close>{{ 'GENERAL.close' | translate }}</button>\n\n  <button mat-raised-button color=\"primary\" [disabled]=\"!imgLoaded\" (click)=\"printInvoice()\">\n    {{ 'GENERAL.print_receipt' | translate }}\n  </button>\n</mat-dialog-actions>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/kino-booking/kino-booking.component.html":
/*!***********************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/kino-booking/kino-booking.component.html ***!
  \***********************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<mat-toolbar color=\"primary\" class=\"mat-elevation-z4\">\n  <mat-toolbar-row>\n    <span class=\"nav-item\">\n      <button mat-raised-button (click)=\"goBack()\">\n        <i class=\"fas fa-chevron-left\"></i>&nbsp; {{ 'GENERAL.back' | translate }}\n      </button>\n    </span>\n    <span class=\"spacer\"></span>\n    <span class=\"nav-item\">\n      <span>\n        {{ 'GENERAL.kino_booking' | translate }}\n      </span>\n    </span>\n    <span class=\"spacer\"></span>\n    <a mat-stroked-button style=\"min-width: 0;\" href=\"javascript:location.href = 'http://closekiosk'\">\n      <mat-icon>close</mat-icon>\n    </a>\n  </mat-toolbar-row>\n</mat-toolbar>\n\n<div class=\"container wrapper\">\n  <form [formGroup]=\"form\">\n    <div class=\"row\">\n      <div class=\"col-sm-3\">\n        <mat-form-field appearance=\"standard\" color=\"accent\">\n          <mat-label>{{ 'GENERAL.date' | translate }}</mat-label>\n          <input formControlName=\"date\" (click)=\"picker.open()\" matInput [matDatepicker]=\"picker\">\n          <mat-datepicker-toggle matSuffix [for]=\"picker\"></mat-datepicker-toggle>\n          <mat-datepicker touchUi=\"true\" #picker></mat-datepicker>\n        </mat-form-field>\n      </div>\n    </div>\n    <div class=\"row\">\n      <div class=\"col-sm-2\">\n        <mat-form-field appearance=\"standard\">\n          <span matPrefix>\n            <i class=\"fas fa-money-bill-wave\"></i>&nbsp;&nbsp;\n          </span>\n          <mat-label>{{ 'FORM.unit_price' | translate }}</mat-label>\n          <input formControlName=\"unit_price\" matInput min=\"0\" type=\"number\">\n        </mat-form-field>\n      </div>\n      <div class=\"col-sm-2\">\n        <mat-form-field appearance=\"standard\">\n          <mat-label>{{ 'FORM.tickets' | translate }}</mat-label>\n          <input formControlName=\"tickets\" matInput min=\"1\" type=\"number\">\n        </mat-form-field>\n      </div>\n      <div class=\"col-sm-2\">\n        <mat-form-field appearance=\"standard\">\n          <span matPrefix>\n            <i class=\"fas fa-money-bill-wave\"></i>&nbsp;&nbsp;\n          </span>\n          <mat-label>{{ 'TABLE.total' | translate }}</mat-label>\n          <input disabled matInput type=\"number\" [value]=\"total\">\n        </mat-form-field>\n      </div>\n    </div>\n    <div class=\"row\">\n      <div class=\"col\">\n        <button color=\"accent\" mat-raised-button (click)=\"save()\">{{ 'GENERAL.print_receipt' | translate }}</button>\n      </div>\n    </div>\n  </form>\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/kino-inovice-print/kino-inovice-print.component.html":
/*!***********************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/kino-inovice-print/kino-inovice-print.component.html ***!
  \***********************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<mat-progress-bar *ngIf=\"!imgFile && !imgLoaded\" mode=\"indeterminate\"></mat-progress-bar>\n<div *ngIf=\"!imgFile && !imgLoaded\" style=\"margin-bottom: 24px; background-color: lightyellow; padding: 16px 6px;\">\n  {{ 'NOTI.generating_qr_code' | translate }}\n</div>\n\n<mat-dialog-content *ngIf=\"data\" id=\"print-content\">\n  <div>DLS Wertkartenvertriebs GmbH</div>\n  <div>Autokinostrasse 2</div>\n  <div>2301 Groß Enzersdorf</div>\n  <div>Österreich</div>\n  <div>UID: ATU68017503</div>\n  <br>\n  <table>\n    <tr>\n      <td>Datum: {{ mymoment(data.created_at).format('DD.MM.YYYY.') }}</td>\n      <td>Zeit: {{ mymoment(data.created_at).format('HH:mm:ss') }}</td>\n    </tr>\n  </table>\n  <hr>\n  <table>\n    <tr>\n      <td>\n        {{ data.amount }} Kinoticket x\n      </td>\n      <td>\n        €{{ (data.total / data.amount).toFixed(2) }}\n      </td>\n    </tr>\n  </table>\n  <hr>\n  <table>\n    <tr>\n      <td>Summe (inkl. MWSt)</td>\n      <td>€{{ data.total.toFixed(2) }}</td>\n    </tr>\n  </table>\n  <br>\n  <div>In der Summe enthalten:</div>\n  <div>MWSt 13%: €{{ (data.total * 0.13).toFixed(2) }}</div>\n  <div>Summe Netto: €{{ (data.total * 0.87).toFixed(2) }}</div>\n  <br>\n  <div>Rechnungsnr: {{ data.id }}</div>\n  <br>\n  <img [src]=\"imgFile\" (load)=\"printInvoice()\" *ngIf=\"imgFile\">\n  <p *ngIf=\"!imgFile\">\n    Signatureinheit offline\n  </p>\n</mat-dialog-content>\n<mat-dialog-actions>\n  <button mat-raised-button mat-dialog-close>{{ 'GENERAL.close' | translate }}</button>\n\n  <button mat-raised-button color=\"primary\" [disabled]=\"!imgLoaded\" (click)=\"printInvoice()\">{{ 'GENERAL.print_receipt' | translate }}</button>\n</mat-dialog-actions>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/kino/kino.component.html":
/*!*******************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/kino/kino.component.html ***!
  \*******************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<mat-toolbar color=\"primary\" class=\"mat-elevation-z4\">\n  <mat-toolbar-row>\n    <span class=\"nav-item\">\n      <button mat-raised-button [routerLink]=\"[nav.navLinks.schedule_view.url]\" [routerLinkActive]=\"['mat-accent']\">\n        <span translate>{{ nav.navLinks.schedule_view.name }}</span>\n      </button>\n      <button mat-raised-button [routerLink]=\"[nav.navLinks.table_view.url]\" [routerLinkActive]=\"['mat-accent']\">\n        <span translate>{{ nav.navLinks.table_view.name }}</span>\n      </button>\n      <button mat-raised-button [routerLink]=\"[nav.navLinks.car_market.url]\" [routerLinkActive]=\"['mat-accent']\">\n        <span translate>{{ nav.navLinks.car_market.name }}</span>\n      </button>\n      <button mat-raised-button [routerLink]=\"[nav.navLinks.kino.url]\" [routerLinkActive]=\"['mat-accent']\">\n        <span translate>{{ nav.navLinks.kino.name }}</span>\n      </button>\n    </span>\n    <span class=\"spacer\"></span>\n    <span class=\"nav-item\">\n      <button mat-raised-button [routerLink]=\"['booking']\">\n        {{ 'GENERAL.add_booking' | translate }}\n      </button>\n    </span>\n    <span class=\"spacer\"></span>\n    <a mat-stroked-button style=\"min-width: 0;\" href=\"javascript:location.href = 'http://closekiosk'\">\n      <mat-icon>close</mat-icon>\n    </a>\n  </mat-toolbar-row>\n</mat-toolbar>\n\n<div class=\"container-fluid wrapper\">\n  <form>\n    <div class=\"row\">\n      <div class=\"col-sm-12 filter-row\">\n        <div class=\"date-filter\">\n          <mat-form-field appearance=\"standard\" color=\"accent\">\n            <mat-label>{{ 'FORM.date_from' | translate }}</mat-label>\n            <input [formControl]=\"date_from_Control\" [max]=\"date_to_Control.value\" name=\"date_from\" (click)=\"picker_from.open()\" matInput [matDatepicker]=\"picker_from\">\n            <mat-datepicker-toggle matSuffix [for]=\"picker_from\"></mat-datepicker-toggle>\n            <mat-datepicker (closed)=\"getData()\" touchUi=\"true\" #picker_from></mat-datepicker>\n          </mat-form-field>\n        </div>\n\n        <div class=\"date-filter\">\n          <mat-form-field appearance=\"standard\" color=\"accent\">\n            <mat-label>{{ 'FORM.date_to' | translate }}</mat-label>\n            <input [formControl]=\"date_to_Control\" [min]=\"date_from_Control.value\" name=\"date_to\" (click)=\"picker_to.open()\" matInput [matDatepicker]=\"picker_to\">\n            <mat-datepicker-toggle matSuffix [for]=\"picker_to\"></mat-datepicker-toggle>\n            <mat-datepicker (closed)=\"getData()\" touchUi=\"true\" #picker_to></mat-datepicker>\n          </mat-form-field>\n        </div>\n\n        <div class=\"status-filter\">\n          <mat-form-field appearance=\"standard\" style=\"width: 100%\">\n            <mat-label>{{ 'STATUS.status' | translate }}</mat-label>\n            <mat-select [formControl]=\"status_Control\" multiple (selectionChange)=\"filterResults()\">\n              <mat-option [value]=\"-1\" (click)=\"resetStatusSelection()\">\n                <span translate>{{ 'STATUS.all' }}</span>\n              </mat-option>\n              <mat-option *ngFor=\"let status of statuses\" [value]=\"status.id\">\n                <span translate>{{ status.name }}</span>\n              </mat-option>\n            </mat-select>\n            <mat-error *ngIf=\"status_Control.hasError('required')\">\n              {{ 'ERR.status_is_required' | translate }}\n            </mat-error>\n          </mat-form-field>\n        </div>\n\n        <!-- <div class=\"origin-filter\">\n              <mat-form-field appearance=\"standard\">\n                <mat-select placeholder=\"{{ 'ORIGIN.origin' | translate }}\" [formControl]=\"origin_Control\">\n                  <mat-option *ngFor=\"let origin of origins\" [value]=\"origin.id\">\n                    <span translate>{{ origin.name }}</span>\n                  </mat-option>\n                </mat-select>\n                <mat-error *ngIf=\"origin_Control.hasError('required')\">\n                  {{ 'ERR.origin_is_required' | translate }}\n                </mat-error>\n              </mat-form-field>\n            </div> -->\n\n        <div class=\"reset-filter\">\n          <button mat-raised-button color=\"warn\" (click)=\"resetFilters()\">{{ 'GENERAL.reset' | translate }}</button>\n        </div>\n      </div>\n    </div>\n  </form>\n\n  <div id=\"print\" class=\"table-wrapper mat-elevation-z8\" *ngIf=\"!loading; else spinner\">\n    <table mat-table #table [dataSource]=\"dataSource\" matSort>\n\n      <!-- ID Column -->\n      <ng-container matColumnDef=\"id\">\n        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'TABLE.id_number' | translate }} </th>\n        <td mat-cell *matCellDef=\"let element\"> {{element.id}} </td>\n      </ng-container>\n\n      <!-- Date Column -->\n      <ng-container matColumnDef=\"date\">\n        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'TABLE.date' | translate }} </th>\n        <td mat-cell *matCellDef=\"let element\"> {{ element.date | date:'dd.MM.yyyy' }} </td>\n      </ng-container>\n\n      <!-- Paid Column -->\n      <ng-container matColumnDef=\"status\">\n        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'TABLE.paid' | translate }} </th>\n        <td mat-cell *matCellDef=\"let element\">\n          <span class=\"paid-status\"\n            [style.backgroundColor]=\"getStatusColor(element)\"\n            matTooltip=\"{{ getStatusTooltip(element) | translate }}\"></span>\n        </td>\n      </ng-container>\n\n      <!-- total Column -->\n      <ng-container matColumnDef=\"total\">\n        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'TABLE.total' | translate }} </th>\n        <td mat-cell *matCellDef=\"let element\"> {{element.total}} </td>\n      </ng-container>\n\n      <!-- ticket_number Column -->\n      <ng-container matColumnDef=\"amount\">\n        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'TABLE.ticket_number' | translate }} </th>\n        <td mat-cell *matCellDef=\"let element\"> {{element.amount}} </td>\n      </ng-container>\n\n      <!-- edit Column -->\n      <ng-container matColumnDef=\"edit\">\n        <th mat-header-cell *matHeaderCellDef> {{ 'TABLE.edit' | translate }} </th>\n        <td mat-cell *matCellDef=\"let element\">\n          <button [disabled]=\"invoiceLoadingID.includes(element.id)\" mat-raised-button (click)=\"printReceipt(element)\">\n            {{ 'GENERAL.print_receipt' | translate }}\n            <span *ngIf=\"invoiceLoadingID.includes(element.id)\" style=\"margin-left: 16px;\">\n              <i class=\"fas fa-spinner fa-spin\"></i>\n            </span>\n          </button>\n          <button [disabled]=\"stornoLoadingID.includes(element.id)\" mat-raised-button *ngIf=\"element.status !== 5\" style=\"margin-left: 16px\"\n            (click)=\"storno(element)\">\n            {{ 'GENERAL.cancel' | translate }}\n            <span *ngIf=\"stornoLoadingID.includes(element.id)\" style=\"margin-left: 16px;\">\n              <i class=\"fas fa-spinner fa-spin\"></i>\n            </span>\n          </button>\n        </td>\n      </ng-container>\n\n      <tr mat-header-row *matHeaderRowDef=\"displayedColumns\"></tr>\n      <tr mat-row *matRowDef=\"let row; columns: displayedColumns;\"></tr>\n    </table>\n  </div>\n\n  <ng-template #spinner>\n    <div class=\"spiner\">\n      <mat-spinner></mat-spinner>\n    </div>\n  </ng-template>\n\n  <div class=\"row sum-report\">\n    <div class=\"col-sm-4\">\n      <h4>{{ 'TABLE.sum_of_the_data_above' | translate }}</h4>\n      <div class=\"sum-row\">\n        <span>{{ 'TABLE.sum_with_tax' | translate }}</span>\n        <span>€ {{ data?.earned.toFixed(2) || 0 }}</span>\n      </div>\n      <div class=\"sum-row\">\n        <span>{{ 'TABLE.total_20%' | translate }}</span>\n        <span>€ {{ data?.tax_amount.toFixed(2) || 0 }}</span>\n      </div>\n      <div class=\"sum-row\">\n        <span>{{ 'TABLE.sum_without_tax' | translate }}</span>\n        <span>€ {{ data?.earned_without_tax.toFixed(2) || 0 }}</span>\n      </div>\n      <div class=\"sum-row\">\n        <span>{{ 'TABLE.still_open' | translate }}</span>\n        <span>€ {{ data?.unpaid.toFixed(2) || 0 }}</span>\n      </div>\n    </div>\n\n    <div class=\"col-sm-8 sum-actions\">\n      <button [disabled]=\"tableData.length < 1\" (click)=\"pdf()\" color=\"accent\" mat-raised-button>\n        {{ 'GENERAL.download_all_invoices_from_above' | translate }}\n      </button>\n      <button [disabled]=\"tableData.length < 1\" (click)=\"excel()\" color=\"accent\" mat-raised-button>\n        {{ 'GENERAL.download_table_excel' | translate }}\n      </button>\n      <button [disabled]=\"tableData.length < 1\" (click)=\"print()\" color=\"accent\" mat-raised-button>\n        {{ 'GENERAL.print_table' | translate }}\n      </button>\n    </div>\n  </div>\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/login/login.component.html":
/*!*********************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/login/login.component.html ***!
  \*********************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"wrapper\">\n  <mat-card class=\"card\">\n    <mat-progress-bar mode=\"buffer\" color=\"accent\" *ngIf=\"loading\" value=\"0\"></mat-progress-bar>\n    <mat-card-header>\n      <mat-card-title>{{ 'GENERAL.login' | translate }}</mat-card-title>\n    </mat-card-header>\n    <mat-card-content>\n      <form [formGroup]=\"form\">\n\n        <mat-form-field appearance=\"outline\">\n          <mat-label>Username</mat-label>\n          <mat-icon matPrefix>person_outline</mat-icon>\n          <input matInput type=\"text\" formControlName=\"username\" autocomplete=\"off\">\n          <mat-error *ngIf=\"form.controls['username'].hasError('required')\">\n            This field is required\n          </mat-error>\n        </mat-form-field>\n        <mat-form-field appearance=\"outline\">\n          <mat-label>Password</mat-label>\n          <mat-icon matPrefix>lock</mat-icon>\n          <input matInput type=\"password\" formControlName=\"password\" autocomplete=\"off\">\n          <mat-error *ngIf=\"form.controls['password'].hasError('required')\">\n            This field is required\n          </mat-error>\n        </mat-form-field>\n\n      </form>\n    </mat-card-content>\n    <mat-card-actions align=\"end\">\n      <button mat-raised-button color=\"accent\" [disabled]=\"form.invalid || loading\" (click)=\"login()\">Login</button>\n    </mat-card-actions>\n  </mat-card>\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/price-adjust/price-adjust.component.html":
/*!***********************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/price-adjust/price-adjust.component.html ***!
  \***********************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<mat-toolbar color=\"primary\" class=\"mat-elevation-z4\">\n  <mat-toolbar-row>\n    <span class=\"nav-item\">\n      <button mat-raised-button [routerLink]=\"[nav.navLinks.schedule_view.url]\" [routerLinkActive]=\"['mat-accent']\">\n        <span translate>{{ nav.navLinks.schedule_view.name }}</span>\n      </button>\n      <button mat-raised-button [routerLink]=\"[nav.navLinks.table_view.url]\" [routerLinkActive]=\"['mat-accent']\">\n        <span translate>{{ nav.navLinks.table_view.name }}</span>\n      </button>\n      <button mat-raised-button [routerLink]=\"[nav.navLinks.car_market.url]\" [routerLinkActive]=\"['mat-accent']\">\n        <span translate>{{ nav.navLinks.car_market.name }}</span>\n      </button>\n      <button mat-raised-button [routerLink]=\"[nav.navLinks.kino.url]\" [routerLinkActive]=\"['mat-accent']\">\n        <span translate>{{ nav.navLinks.kino.name }}</span>\n      </button>\n    </span>\n    <span class=\"spacer\"></span>\n    <a mat-stroked-button style=\"min-width: 0;\" href=\"javascript:location.href = 'http://closekiosk'\">\n      <mat-icon>close</mat-icon>\n    </a>\n  </mat-toolbar-row>\n</mat-toolbar>\n\n<mat-progress-bar color=\"accent\" mode=\"indeterminate\" *ngIf=\"loading\"></mat-progress-bar>\n\n<div class=\"wrapper\" [formGroup]=\"form\" *ngIf=\"!loading\">\n\n  <h1>{{ 'FORM.regular_price' | translate }}</h1>\n  <div class=\"grid\">\n    <mat-form-field appearance=\"standard\">\n      <mat-label>{{ 'GENERAL.car_market_price' | translate }}</mat-label>\n      <span matPrefix><i class=\"fas fa-euro-sign\"></i>&nbsp;&nbsp;</span>\n      <input type=\"number\" autocomplete=\"off\" matInput formControlName=\"car_market_ticket_price\">\n      <mat-error *ngIf=\"getControl('car_market_ticket_price').hasError('required')\">\n        {{ 'ERR.this_field_is_required' | translate }}\n      </mat-error>\n      <mat-error *ngIf=\"!getControl('car_market_ticket_price').hasError('required') && getControl('car_market_ticket_price').hasError('pattern')\">\n        {{ 'ERR.enter_a_valid_number' | translate }}\n      </mat-error>\n    </mat-form-field>\n\n    <button mat-raised-button color=\"accent\" [disabled]=\"form.invalid\" (click)=\"savePrice()\">\n      {{ 'BUTTON.change_price' | translate }}\n    </button>\n\n    <mat-form-field appearance=\"standard\">\n      <mat-label>{{ 'GENERAL.flea_market_spot_price' | translate }}</mat-label>\n      <span matPrefix><i class=\"fas fa-euro-sign\"></i>&nbsp;&nbsp;</span>\n      <input type=\"number\" autocomplete=\"off\" matInput formControlName=\"flea_market_ticket_price\">\n      <mat-error *ngIf=\"getControl('flea_market_ticket_price').hasError('required')\">\n        {{ 'ERR.this_field_is_required' | translate }}\n      </mat-error>\n      <mat-error *ngIf=\"!getControl('flea_market_ticket_price').hasError('required') && getControl('flea_market_ticket_price').hasError('pattern')\">\n        {{ 'ERR.enter_a_valid_number' | translate }}\n      </mat-error>\n    </mat-form-field>\n\n    <button mat-raised-button color=\"accent\" [disabled]=\"form.invalid\" (click)=\"savePrice()\">\n      {{ 'BUTTON.change_price' | translate }}\n    </button>\n  </div>\n\n  <h1>{{ 'FORM.discount_price' | translate }}</h1>\n  <div class=\"grid\">\n    <mat-form-field appearance=\"standard\">\n      <mat-label>{{ 'GENERAL.car_market_price' | translate }}</mat-label>\n      <span matPrefix><i class=\"fas fa-euro-sign\"></i>&nbsp;&nbsp;</span>\n      <input type=\"number\" autocomplete=\"off\" matInput formControlName=\"car_market_discount_ticket_price\">\n      <mat-error *ngIf=\"getControl('car_market_discount_ticket_price').hasError('required')\">\n        {{ 'ERR.this_field_is_required' | translate }}\n      </mat-error>\n      <mat-error *ngIf=\"!getControl('car_market_discount_ticket_price').hasError('required') && getControl('car_market_discount_ticket_price').hasError('pattern')\">\n        {{ 'ERR.enter_a_valid_number' | translate }}\n      </mat-error>\n    </mat-form-field>\n\n    <button mat-raised-button color=\"accent\" [disabled]=\"form.invalid\" (click)=\"savePrice()\">\n      {{ 'BUTTON.change_price' | translate }}\n    </button>\n\n    <mat-form-field appearance=\"standard\">\n      <mat-label>{{ 'GENERAL.flea_market_spot_price' | translate }}</mat-label>\n      <span matPrefix><i class=\"fas fa-euro-sign\"></i>&nbsp;&nbsp;</span>\n      <input type=\"number\" autocomplete=\"off\" matInput formControlName=\"flea_market_discount_ticket_price\">\n      <mat-error *ngIf=\"getControl('flea_market_discount_ticket_price').hasError('required')\">\n        {{ 'ERR.this_field_is_required' | translate }}\n      </mat-error>\n      <mat-error *ngIf=\"!getControl('flea_market_discount_ticket_price').hasError('required') && getControl('flea_market_discount_ticket_price').hasError('pattern')\">\n        {{ 'ERR.enter_a_valid_number' | translate }}\n      </mat-error>\n    </mat-form-field>\n\n    <button mat-raised-button color=\"accent\" [disabled]=\"form.invalid\" (click)=\"savePrice()\">\n      {{ 'BUTTON.change_price' | translate }}\n    </button>\n  </div>\n\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/schedule-view/booking-details-dialog/booking-details-dialog.component.html":
/*!*********************************************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/schedule-view/booking-details-dialog/booking-details-dialog.component.html ***!
  \*********************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<h2 mat-dialog-title>\n  {{ 'GENERAL.booked_spots' | translate }}:\n  <mat-chip-list>\n    <mat-chip *ngFor=\"let spot of currentSpots\">\n      {{ spot }}\n    </mat-chip>\n  </mat-chip-list>\n</h2>\n<h2 mat-dialog-title>\n  {{ 'GENERAL.booked_dates' | translate }}:\n  <mat-chip-list>\n    <mat-chip *ngFor=\"let date of currentDates\">\n      {{ date }}\n    </mat-chip>\n  </mat-chip-list>\n</h2>\n\n<mat-dialog-content>\n  <div *ngIf=\"data.customer\">\n    <span>\n      {{ data.customer.first_name }} {{ data.customer.last_name }}\n    </span>\n    <span *ngIf=\"data.customer.streetname\">\n      , {{ data.customer.streetname }}\n    </span>\n    <span *ngIf=\"data.customer.post_code\">\n      , {{ data.customer.post_code }}\n    </span>\n    <span>\n      {{ data.customer.city }}\n    </span>\n  </div>\n\n  <div class=\"options\">\n    <div class=\"actions\">\n      <button type=\"button\" mat-raised-button color=\"accent\" [routerLink]=\"['/booking/details', data.id]\" mat-dialog-close>\n        {{ 'GENERAL.booking_details' | translate }}\n      </button>\n      <button type=\"button\" mat-raised-button color=\"accent\" (click)=\"printPlaceNumber()\">\n        {{ 'BUTTON.print_location_number' | translate }}\n      </button>\n    </div>\n    <div class=\"notes\">\n      <mat-form-field appearance=\"outline\">\n        <mat-label>{{ 'FORM.notes' | translate }}</mat-label>\n        <textarea matInput [(ngModel)]=\"note\" autocomplete=\"off\"></textarea>\n      </mat-form-field>\n      <button mat-raised-button color=\"accent\" (click)=\"saveNotes()\">\n        {{ 'BUTTON.save_notes' | translate }}\n      </button>\n    </div>\n  </div>\n</mat-dialog-content>\n<mat-dialog-actions align=\"end\">\n  <button mat-stroked-button mat-dialog-close>{{ 'GENERAL.close' | translate }}</button>\n</mat-dialog-actions>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/schedule-view/booking-details/booking-details.component.html":
/*!*******************************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/schedule-view/booking-details/booking-details.component.html ***!
  \*******************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<mat-toolbar color=\"primary\" class=\"mat-elevation-z4\">\n  <mat-toolbar-row>\n    <span class=\"nav-item\">\n      <button type=\"button\" mat-raised-button (click)=\"goBack()\">\n        <i class=\"fas fa-chevron-left\"></i>&nbsp; {{ 'GENERAL.back' | translate }}\n      </button>\n    </span>\n    <span class=\"spacer\"></span>\n    <span class=\"nav-item\">\n      <span>\n        {{ 'GENERAL.booking_details' | translate }}\n      </span>\n    </span>\n    <span class=\"spacer\"></span>\n    <span class=\"nav-item\">\n      <button type=\"button\" mat-raised-button color=\"accent\" (click)=\"submitForm()\">\n        {{ 'FORM.save_changes' | translate }}\n      </button>\n    </span>\n\n    <a mat-stroked-button style=\"min-width: 0;\" href=\"javascript:location.href = 'http://closekiosk'\">\n      <mat-icon>close</mat-icon>\n    </a>\n  </mat-toolbar-row>\n</mat-toolbar>\n\n<div class=\"container-fluid wrapper\" *ngIf=\"!loadingData\">\n  <div class=\"row\">\n    <div class=\"col-sm-12 col-md-6\">\n      <!-- Ticket and spot details -->\n      <div class=\"row\" [formGroup]=\"ticketPriceForm\">\n        <div class=\"col-sm-4 place-number\">\n          <mat-form-field appearance=\"standard\">\n            <mat-label>{{ 'FORM.place_number' | translate }}</mat-label>\n            <input type=\"string\" matInput formControlName=\"place_number\">\n          </mat-form-field>\n          <button type=\"button\" mat-raised-button color=\"accent\" (click)=\"changePlaces()\" [disabled]=\"isReservation\">\n            {{ 'BUTTON.change_places' | translate }}\n          </button>\n        </div>\n        <div class=\"col-sm-4 discount\">\n          <mat-radio-group formControlName=\"price_type\" class=\"discount-radio-group\">\n            <mat-radio-button class=\"discount-button\" [value]=\"false\">\n              {{ 'FORM.regular_price' | translate }}\n            </mat-radio-button>\n            <mat-radio-button class=\"discount-button\" [value]=\"true\">\n              {{ 'FORM.discount_price' | translate }}\n            </mat-radio-button>\n          </mat-radio-group>\n        </div>\n        <div class=\"col-sm-4 price\">\n          <div class=\"unit-price\">\n            <mat-form-field appearance=\"standard\">\n              <span matPrefix>\n                <i class=\"fas fa-money-bill-wave\"></i>&nbsp;&nbsp;\n              </span>\n              <mat-label>{{ 'FORM.unit_price' | translate }}</mat-label>\n              <input formControlName=\"unit_price\" matInput min=\"0\" type=\"number\">\n            </mat-form-field>\n          </div>\n          <div class=\"sum\">\n            <mat-form-field appearance=\"standard\">\n              <span matPrefix>\n                <i class=\"fas fa-money-bill-wave\"></i>&nbsp;&nbsp;\n              </span>\n              <mat-label>{{ 'TABLE.total' | translate }}</mat-label>\n              <input formControlName=\"sum\" matInput type=\"number\" [value]=\"\" min=\"0\">\n            </mat-form-field>\n          </div>\n        </div>\n      </div>\n      <!-- Dates form -->\n      <div class=\"row\">\n        <ng-container [formGroup]=\"datesForm\">\n          <mat-list class=\"col-sm-7\" formArrayName=\"dates\">\n            <ng-container *ngFor=\"let date_control of getDatesControls(); let i=index\">\n              <mat-list-item formGroupName=\"{{ i }}\">\n                <mat-form-field appearance=\"standard\" style=\"margin-right: 8px\">\n                  <mat-label>{{ 'GENERAL.date' | translate }}</mat-label>\n                  <select formControlName=\"date\" disableRipple matNativeControl>\n                    <option [value]=\"date\" *ngFor=\"let date of dates\">\n                      {{ date }}\n                    </option>\n                  </select>\n                </mat-form-field>\n                <button type=\"button\" mat-raised-button *ngIf=\"i !== 0 && !bookingID\" (click)=\"removeDate(i)\">\n                  <i class=\"far fa-trash-alt\"></i>\n                </button>\n              </mat-list-item>\n            </ng-container>\n          </mat-list>\n        </ng-container>\n\n        <!-- Date add buttons -->\n        <div class=\"col-sm-5\">\n          <div class=\"row\">\n            <div class=\"col-sm-4\">\n              <mat-form-field appearance=\"standard\">\n                <mat-select #amount [value]=\"1\">\n                  <mat-option *ngFor=\"let a of addAmountDropdown\" [value]=\"a\">\n                    {{ a }}\n                  </mat-option>\n                </mat-select>\n              </mat-form-field>\n            </div>\n            <div class=\"col flex-v-align-center\">\n              <button [disabled]=\"bookingID && !isReservation\" type=\"button\" mat-raised-button color=\"accent\" (click)=\"addNewDate(amount.value)\">\n                {{ 'FORM.add' | translate }}\n              </button>\n            </div>\n          </div>\n\n          <div class=\"row\">\n            <div class=\"col-sm-12 action-stack\">\n              <div class=\"date-action\">\n                <button [disabled]=\"bookingID && !isReservation\" (click)=\"addUntilEndOfMonth()\" type=\"button\" color=\"accent\" mat-raised-button>\n                  {{ 'BUTTON.until_the_end_of_the_month' | translate }}\n                </button>\n              </div>\n              <div class=\"date-action\">\n                <button [disabled]=\"bookingID && !isReservation\" (click)=\"addUntilEndOfYear()\" type=\"button\" color=\"accent\" mat-raised-button>\n                  {{ 'BUTTON.until_the_end_of_the_year' | translate }}\n                </button>\n              </div>\n              <div class=\"date-action\">\n                <button [disabled]=\"bookingID && !isReservation\" (click)=\"addOneYear()\" type=\"button\" color=\"accent\" mat-raised-button>\n                  {{ 'BUTTON.add_one_year' | translate }}\n                </button>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n\n      <!-- User info form -->\n      <form [formGroup]=\"userInfoForm\" class=\"row\">\n        <div class=\"col-sm-12\">\n          <div class=\"row\">\n            <div class=\"col-sm-6\">\n              <mat-form-field appearance=\"standard\">\n                <span matPrefix>\n                  <i class=\"far fa-user\"></i>&nbsp;&nbsp;\n                </span>\n                <mat-label>{{ 'FORM.first_name' | translate }}</mat-label>\n                <input matInput formControlName=\"first_name\">\n                <mat-error *ngIf=\"getUserinfoControl('first_name').hasError('required')\">\n                  {{ 'ERR.this_field_is_required' | translate }}\n                </mat-error>\n              </mat-form-field>\n            </div>\n            <div class=\"col-sm-6\">\n              <mat-form-field appearance=\"standard\">\n                <span matPrefix>\n                  <i class=\"far fa-user\"></i>&nbsp;&nbsp;\n                </span>\n                <mat-label>{{ 'FORM.last_name' | translate }}</mat-label>\n                <input matInput formControlName=\"last_name\">\n                <mat-error *ngIf=\"getUserinfoControl('last_name').hasError('required')\">\n                  {{ 'ERR.this_field_is_required' | translate }}\n                </mat-error>\n              </mat-form-field>\n            </div>\n          </div>\n          <div class=\"row\">\n            <div class=\"col-sm-12\">\n              <mat-form-field appearance=\"standard\">\n                <span matPrefix>\n                  <i class=\"fas fa-at\"></i>&nbsp;&nbsp;\n                </span>\n                <mat-label>{{ 'FORM.email' | translate }}</mat-label>\n                <input type=\"email\" matInput formControlName=\"email\">\n                <mat-error *ngIf=\"getUserinfoControl('email').hasError('email') && !getUserinfoControl('email').hasError('required')\">\n                  {{ 'ERR.enter_valid_email' | translate }}\n                </mat-error>\n                <mat-error *ngIf=\"getUserinfoControl('email').hasError('required')\">\n                  {{ 'ERR.this_field_is_required' | translate }}\n                </mat-error>\n              </mat-form-field>\n            </div>\n          </div>\n          <div class=\"row\">\n            <div class=\"col-sm-12\">\n              <mat-form-field appearance=\"standard\">\n                <span matPrefix>\n                  <i class=\"fas fa-mobile-alt\"></i>&nbsp;&nbsp;\n                </span>\n                <mat-label>{{ 'FORM.phone_number' | translate }}</mat-label>\n                <input type=\"tel\" matInput formControlName=\"phone_number\">\n              </mat-form-field>\n            </div>\n          </div>\n          <div class=\"row\">\n            <div class=\"col-sm-12\">\n              <mat-form-field appearance=\"standard\">\n                <span matPrefix>\n                  <i class=\"far fa-building\"></i>&nbsp;&nbsp;\n                </span>\n                <mat-label>{{ 'FORM.company' | translate }}</mat-label>\n                <input matInput formControlName=\"company\">\n              </mat-form-field>\n            </div>\n          </div>\n          <div class=\"row\">\n            <div class=\"col-sm-8\">\n              <mat-form-field appearance=\"standard\">\n                <span matPrefix>\n                  <i class=\"fas fa-road\"></i>&nbsp;&nbsp;\n                </span>\n                <mat-label>{{ 'FORM.street' | translate }}</mat-label>\n                <input matInput formControlName=\"street\">\n              </mat-form-field>\n            </div>\n            <div class=\"col-sm-4\">\n              <mat-form-field appearance=\"standard\">\n                <span matPrefix>\n                  <i class=\"fas fa-home\"></i>&nbsp;&nbsp;\n                </span>\n                <mat-label>{{ 'FORM.number' | translate }}</mat-label>\n                <input matInput formControlName=\"street_number\">\n              </mat-form-field>\n            </div>\n          </div>\n          <div class=\"row\">\n            <div class=\"col-sm-8\">\n              <mat-form-field appearance=\"standard\">\n                <span matPrefix>\n                  <i class=\"fas fa-home\"></i>&nbsp;&nbsp;\n                </span>\n                <mat-label>{{ 'FORM.place' | translate }}</mat-label>\n                <input matInput formControlName=\"place\">\n              </mat-form-field>\n            </div>\n            <div class=\"col-sm-4\">\n              <mat-form-field appearance=\"standard\">\n                <span matPrefix>\n                  <i class=\"fas fa-home\"></i>&nbsp;&nbsp;\n                </span>\n                <mat-label>{{ 'FORM.post_code' | translate }}</mat-label>\n                <input matInput formControlName=\"post_code\">\n              </mat-form-field>\n            </div>\n          </div>\n          <div class=\"row\">\n            <div class=\"col\">\n              <mat-form-field appearance=\"standard\">\n                <mat-label>{{ 'FORM.category' | translate }}</mat-label>\n                <mat-select formControlName=\"category\">\n                  <mat-option *ngFor=\"let item of categories\" [value]=\"item.id\" [class.group-option]=\"item.isGroup ? true : false\">\n                    {{ item.name }}\n                  </mat-option>\n                </mat-select>\n              </mat-form-field>\n            </div>\n          </div>\n        </div>\n      </form>\n    </div>\n\n    <!-- Status column -->\n    <div class=\"col-sm-12 col-md-6\" *ngIf=\"booking\">\n      <div class=\"row\">\n        <div class=\"col-sm-12 status-boxes\">\n          <div class=\"box\">\n            <span>{{ 'STATUS.BOX.booking_for' | translate }}</span>\n            <span>{{ booking.booking_dates.length }}</span>\n            <span>{{ 'STATUS.BOX.weeks' | translate }}</span>\n          </div>\n          <div class=\"box\">\n            <span>{{ 'STATUS.BOX.rest' | translate }}</span>\n            <span>{{ remainingWeeks() }}</span>\n            <span>{{ 'STATUS.BOX.weeks' | translate }}</span>\n          </div>\n          <div class=\"box\">\n            <span>{{ 'STATUS.BOX.to_be_paid' | translate }}</span>\n            <span>{{ (booking.total - booking.payed_amount).toFixed(2) }}</span>\n            <span>{{ 'STATUS.BOX.euro' | translate }}</span>\n          </div>\n          <div class=\"box\">\n            <span>{{ 'STATUS.status' | translate }}</span>\n            <span class=\"status\" [style.backgroundColor]=\"status.color\" matTooltip=\"{{ status.name | translate }}\"></span>\n            <span translate>{{ status.name }}</span>\n          </div>\n        </div>\n      </div>\n      <div class=\"row\">\n        <div class=\"col-sm-12 section-title\">\n          {{ 'TABLE.edit' | translate }}\n        </div>\n        <div class=\"col-sm-12\">\n          <button [disabled]=\"booking.status === status_free || booking.status === 5 || booking.status === 0\"\n                  (click)=\"stornoBooking()\" type=\"button\" mat-raised-button color=\"accent\">\n            {{ 'BUTTON.add_cancellation' | translate }}\n          </button>\n        </div>\n      </div>\n      <div class=\"row flex-v-align-center\">\n        <div class=\"col-sm-4\">\n          <mat-form-field appearance=\"standard\">\n            <input type=\"number\" min=\"1\" matInput [formControl]=\"topayControl\">\n            <span matPrefix>\n              €&nbsp;&nbsp;\n            </span>\n            <mat-error *ngIf=\"topayControl.hasError('required') || topayControl.hasError('min')\">\n              {{ 'ERR.this_field_is_required' | translate }}\n            </mat-error>\n          </mat-form-field>\n        </div>\n        <div class=\"col-sm-8\">\n          <button [disabled]=\"booking.status === status_free || topayControl.invalid\" (click)=\"createInvoice()\" type=\"button\" mat-raised-button color=\"accent\" style=\"margin-right: 6px\">\n            {{ 'GENERAL.print_receipt' | translate }}\n          </button>\n          <button type=\"button\" mat-raised-button color=\"accent\" (click)=\"printPlaceNumber()\">\n            {{ 'BUTTON.print_location_number' | translate }}\n          </button>\n        </div>\n      </div>\n      <div class=\"row\" *ngIf=\"booking.invoices.length > 0\">\n        <div class=\"col-sm-12 section-title\">\n          {{ 'GENERAL.bills' | translate }}\n        </div>\n        <div class=\"col-sm-12\">\n          <mat-list>\n            <mat-list-item *ngFor=\"let invoice of booking.invoices.reverse()\">\n              {{ invoice.created_at | date:'dd.MM.yyyy. HH:mm' }} --\n              {{ (invoice.canceled ? 'TABLE.cancellation' : 'TABLE.paid') | translate | lowercase }} --\n              €{{ abs(invoice.total) }}\n              <button mat-raised-button (click)=\"printInvoiceById(invoice.id)\" style=\"min-width: 0; margin-left: 6px\">\n                <i class=\"fas fa-print\"></i>\n              </button>\n            </mat-list-item>\n          </mat-list>\n        </div>\n      </div>\n      <div class=\"row\" *ngIf=\"booking.event_log && booking.event_log.length > 0\">\n        <div class=\"col-sm-12 section-title\">\n          {{ 'GENERAL.done' | translate }}\n        </div>\n        <div class=\"col-sm-12\">\n          <app-event-log [eventLog]=\"booking.event_log\"></app-event-log>\n        </div>\n      </div>\n      <div class=\"row\">\n        <div class=\"col-sm-12\">\n          <mat-form-field appearance=\"standard\">\n            <mat-label>{{ 'FORM.notes' | translate }}</mat-label>\n            <textarea [(ngModel)]=\"booking_notes\" matInput></textarea>\n          </mat-form-field>\n        </div>\n      </div>\n    </div>\n  </div>\n\n\n  <!-- Save changes button -->\n  <div class=\"row\">\n    <div class=\"col save-button\">\n      <button type=\"button\" mat-raised-button color=\"accent\" (click)=\"submitForm()\">\n        {{ 'FORM.save_changes' | translate }}\n      </button>\n    </div>\n  </div>\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/schedule-view/change-booking-type-dialog/change-booking-type-dialog.component.html":
/*!*****************************************************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/schedule-view/change-booking-type-dialog/change-booking-type-dialog.component.html ***!
  \*****************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<h2 mat-dialog-title>\n  {{ 'GENERAL.booked_spots' | translate }}:\n  <mat-chip-list>\n    <mat-chip *ngFor=\"let spot of currentSpots\">\n      {{ spot }}\n    </mat-chip>\n  </mat-chip-list>\n</h2>\n<h2 mat-dialog-title>\n  {{ 'GENERAL.booked_dates' | translate }}:\n  <mat-chip-list>\n    <mat-chip *ngFor=\"let date of currentDates\">\n      {{ date }}\n    </mat-chip>\n  </mat-chip-list>\n</h2>\n<mat-dialog-content>\n  <div class=\"booking-type\">\n    <button mat-raised-button color=\"accent\" style=\"margin-right: 8px;\">\n      {{ 'STATUS.reserved' | translate }}\n    </button>\n    <button mat-raised-button (click)=\"changeBookingStatus(-1)\">\n      {{ 'STATUS.not_reserved' | translate }}\n    </button>\n    <button mat-raised-button [ngClass]=\"{ 'mat-accent': status_not_paid === data.status }\" (click)=\"changeBookingStatus(1)\">\n      {{ 'STATUS.not_paid' | translate }}\n    </button>\n    <button mat-raised-button [ngClass]=\"{ 'mat-accent': status_free === data.status }\" (click)=\"changeBookingStatus(7)\">\n      {{ 'STATUS.free' | translate }}\n    </button>\n  </div>\n\n  <div class=\"charge\">\n    <mat-form-field appearance=\"standard\">\n      <input type=\"number\" min=\"0\" matInput [formControl]=\"topayControl\">\n      <span matPrefix>\n        €&nbsp;&nbsp;\n      </span>\n      <mat-error *ngIf=\"topayControl.hasError('required') || topayControl.hasError('min')\">\n        {{ 'ERR.this_field_is_required' | translate }}\n      </mat-error>\n    </mat-form-field>\n    <button [disabled]=\"data.status === status_free || topayControl.invalid\"\n            (click)=\"createInvoice()\" type=\"button\" mat-raised-button color=\"accent\">\n      {{ 'GENERAL.print_receipt' | translate }}\n    </button>\n  </div>\n\n  <div *ngIf=\"data.customer\">\n    <span>\n      {{ data.customer.first_name }} {{ data.customer.last_name }}\n    </span>\n    <span *ngIf=\"data.customer.streetname\">\n      , {{ data.customer.streetname }}\n    </span>\n    <span *ngIf=\"data.customer.post_code\">\n      , {{ data.customer.post_code }}\n    </span>\n    <span>\n      {{ data.customer.city }}\n    </span>\n  </div>\n\n  <div class=\"options\">\n    <div class=\"actions\">\n      <button type=\"button\" mat-raised-button color=\"accent\" [routerLink]=\"['/booking/details', data.id]\" mat-dialog-close>\n        {{ 'GENERAL.booking_details' | translate }}\n      </button>\n      <button type=\"button\" mat-raised-button color=\"accent\" (click)=\"printPlaceNumber()\">\n        {{ 'BUTTON.print_location_number' | translate }}\n      </button>\n    </div>\n    <div class=\"notes\">\n      <mat-form-field appearance=\"outline\">\n        <mat-label>{{ 'FORM.notes' | translate }}</mat-label>\n        <textarea matInput [(ngModel)]=\"note\"></textarea>\n      </mat-form-field>\n      <button mat-raised-button color=\"accent\" (click)=\"saveNote()\">\n        {{ 'BUTTON.save_notes' | translate }}\n      </button>\n    </div>\n  </div>\n</mat-dialog-content>\n<mat-dialog-actions align=\"end\">\n  <button mat-stroked-button mat-dialog-close>{{ 'GENERAL.close' | translate }}</button>\n</mat-dialog-actions>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/schedule-view/change-places-dialog/change-places-dialog.component.html":
/*!*****************************************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/schedule-view/change-places-dialog/change-places-dialog.component.html ***!
  \*****************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<h2 mat-dialog-title>{{ 'GENERAL.change_places' | translate }}</h2>\n<mat-dialog-content *ngIf=\"!loading\">\n\n  <form [formGroup]=\"form\" class=\"spot-wrapper\">\n    <ng-container formArrayName=\"spots\">\n      <div class=\"place-dropdown\" *ngFor=\"let spot_control of getSpotsFormGroups(); let i=index\">\n        <ng-container formGroupName=\"{{ i }}\">\n          <mat-form-field appearance=\"standard\">\n            <mat-select formControlName=\"spot\">\n              <mat-option *ngFor=\"let spot of spots\" [value]=\"spot\">\n                {{ spot }}\n              </mat-option>\n            </mat-select>\n          </mat-form-field>\n        </ng-container>\n      </div>\n    </ng-container>\n  </form>\n\n</mat-dialog-content>\n<mat-dialog-actions align=\"end\">\n  <button mat-raised-button color=\"accent\" (click)=\"save()\">{{ 'FORM.save_changes' | translate }}</button>\n</mat-dialog-actions>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/schedule-view/informal-reservation-dialog/informal-reservation-dialog.component.html":
/*!*******************************************************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/schedule-view/informal-reservation-dialog/informal-reservation-dialog.component.html ***!
  \*******************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<h2 mat-dialog-title>{{ 'STATUS.informal_reservation' | translate }}</h2>\n<mat-dialog-content>\n\n  <h5>{{ 'FORM.selected_spots' | translate }}</h5>\n  <div class=\"spots-wrapper\">\n    <span *ngFor=\"let spot of data.spots\" class=\"spot\">\n      {{ spot }}\n    </span>\n  </div>\n\n\n  <div class=\"date-controls-wrapper\">\n    <ng-container [formGroup]=\"datesForm\">\n      <mat-list class=\"date-list\" formArrayName=\"dates\">\n        <ng-container *ngFor=\"let date_control of getDatesControls(); let i=index\">\n          <mat-list-item formGroupName=\"{{ i }}\">\n            <mat-form-field appearance=\"standard\" style=\"margin-right: 8px;\">\n              <mat-label>{{ 'GENERAL.date' | translate }}</mat-label>\n              <select formControlName=\"date\" disableRipple matNativeControl>\n                <option [value]=\"date\" *ngFor=\"let date of dates\">\n                  {{ date }}\n                </option>\n              </select>\n            </mat-form-field>\n            <button type=\"button\" mat-raised-button *ngIf=\"i !== 0 && !bookingID\" (click)=\"removeDate(i)\">\n              <i class=\"far fa-trash-alt\"></i>\n            </button>\n          </mat-list-item>\n        </ng-container>\n      </mat-list>\n    </ng-container>\n\n    <div class=\"controls\">\n      <mat-form-field appearance=\"standard\">\n        <mat-select #amount [value]=\"1\">\n          <mat-option [value]=\"1\">1</mat-option>\n          <mat-option [value]=\"2\">2</mat-option>\n          <mat-option [value]=\"3\">3</mat-option>\n          <mat-option [value]=\"4\">4</mat-option>\n          <mat-option [value]=\"5\">5</mat-option>\n          <mat-option [value]=\"10\">10</mat-option>\n        </mat-select>\n      </mat-form-field>\n\n      <button mat-raised-button color=\"accent\" (click)=\"addNewDate(amount.value)\">{{ 'FORM.add' | translate }}</button>\n      <button mat-raised-button color=\"accent\" (click)=\"addUntilEndOfMonth()\">{{ 'BUTTON.until_the_end_of_the_month' | translate }}</button>\n      <button mat-raised-button color=\"accent\" (click)=\"addUntilEndOfYear()\">{{ 'BUTTON.until_the_end_of_the_year' | translate }}</button>\n      <button mat-raised-button color=\"accent\" (click)=\"addOneYear()\">{{ 'BUTTON.add_one_year' | translate }}</button>\n    </div>\n\n    <div class=\"informal-colors\">\n      <mat-radio-group class=\"color-group\" [formControl]=\"selected_color\">\n        <mat-radio-button class=\"color-buttons\" *ngFor=\"let color of informal_colors\" [value]=\"color.value\">\n          <span class=\"color-box\" [style.backgroundColor]=\"color.color\">&nbsp;</span>\n        </mat-radio-button>\n      </mat-radio-group>\n    </div>\n  </div>\n\n\n</mat-dialog-content>\n<mat-dialog-actions align=\"end\">\n  <button mat-raised-button color=\"accent\" (click)=\"save()\">{{ 'BUTTON.save_booking' | translate }}</button>\n</mat-dialog-actions>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/schedule-view/quick-booking-dialog/quick-booking-dialog.component.html":
/*!*****************************************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/schedule-view/quick-booking-dialog/quick-booking-dialog.component.html ***!
  \*****************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<mat-progress-bar mode=\"buffer\" color=\"accent\" *ngIf=\"processing\"></mat-progress-bar>\n\n<h2 mat-dialog-title>{{ 'GENERAL.quick_booking' | translate }}</h2>\n<mat-dialog-content>\n\n  <h5>{{ 'FORM.selected_spots' | translate }}</h5>\n  <div class=\"spots-wrapper\">\n    <span *ngFor=\"let spot of data.spots\" class=\"spot\">\n      {{ spot }}\n    </span>\n  </div>\n\n  <br>\n  <div class=\"price-form\" [formGroup]=\"form\">\n    <mat-form-field appearance=\"standard\">\n      <span matPrefix><i class=\"fas fa-euro-sign\"></i>&nbsp;&nbsp;</span>\n      <mat-label>{{ 'TABLE.paid' | translate }}</mat-label>\n      <input type=\"number\" min=\"0\" matInput formControlName=\"paid\" autocomplete=\"off\">\n      <mat-error *ngIf=\"paid_amount_control.hasError('required') || paid_amount_control.hasError('min')\">\n        {{ 'ERR.this_field_is_required' | translate }}\n      </mat-error>\n    </mat-form-field>\n\n    <mat-radio-group formControlName=\"discount\" class=\"discount-radio-group\">\n      <mat-radio-button class=\"discount-button\" [value]=\"false\">\n        {{ 'FORM.regular_price' | translate }}\n      </mat-radio-button>\n      <mat-radio-button class=\"discount-button\" [value]=\"true\">\n        {{ 'FORM.discount_price' | translate }}\n      </mat-radio-button>\n    </mat-radio-group>\n\n    <mat-form-field appearance=\"standard\">\n      <span matPrefix><i class=\"fas fa-euro-sign\"></i>&nbsp;&nbsp;</span>\n      <mat-label>{{ 'TABLE.total' | translate }}</mat-label>\n      <input type=\"number\" min=\"0\" matInput formControlName=\"total\" autocomplete=\"off\">\n      <mat-error *ngIf=\"total_control.hasError('required') || total_control.hasError('min')\">\n        {{ 'ERR.this_field_is_required' | translate }}\n      </mat-error>\n      <mat-hint>\n        {{ 'FORM.unit_price' | translate }}: {{ getTicketPrice().toFixed(2) }}€\n      </mat-hint>\n    </mat-form-field>\n  </div>\n\n</mat-dialog-content>\n<mat-dialog-actions align=\"end\">\n  <button [disabled]=\"processing || form.invalid\" mat-raised-button color=\"accent\" (click)=\"saveBooking()\">\n    {{ 'BUTTON.save_booking' | translate }}\n  </button>\n</mat-dialog-actions>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/schedule-view/schedule-view.component.html":
/*!*************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/schedule-view/schedule-view.component.html ***!
  \*************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<mat-toolbar color=\"primary\" class=\"mat-elevation-z4\">\n  <mat-toolbar-row>\n    <span class=\"nav-item\">\n      <button mat-raised-button [routerLink]=\"[nav.navLinks.schedule_view.url]\" [routerLinkActive]=\"['mat-accent']\">\n        <span translate>{{ nav.navLinks.schedule_view.name }}</span>\n      </button>\n      <button mat-raised-button [routerLink]=\"[nav.navLinks.table_view.url]\" [routerLinkActive]=\"['mat-accent']\">\n        <span translate>{{ nav.navLinks.table_view.name }}</span>\n      </button>\n      <button mat-raised-button [routerLink]=\"[nav.navLinks.car_market.url]\" [routerLinkActive]=\"['mat-accent']\">\n        <span translate>{{ nav.navLinks.car_market.name }}</span>\n      </button>\n      <button mat-raised-button [routerLink]=\"[nav.navLinks.kino.url]\" [routerLinkActive]=\"['mat-accent']\">\n        <span translate>{{ nav.navLinks.kino.name }}</span>\n      </button>\n    </span>\n    <span class=\"spacer\"></span>\n    <span class=\"nav-item\">\n      <button class=\"quick-reservation\" mat-raised-button (click)=\"quickReservation()\" [disabled]=\"selectedSpots.length < 1\">\n        {{ 'GENERAL.quick_reservation' | translate }}\n      </button>\n      <button class=\"quick-booking\" mat-raised-button (click)=\"quickBooking()\" [disabled]=\"selectedSpots.length < 1\">\n        {{ 'GENERAL.quick_booking' | translate }}\n      </button>\n      <button class=\"booking\" mat-raised-button (click)=\"addBooking()\" [disabled]=\"selectedSpots.length < 1\">\n        {{ 'GENERAL.add_booking' | translate }}\n      </button>\n      <button class=\"informal-booking\" mat-raised-button (click)=\"informalReservation()\" [disabled]=\"selectedSpots.length < 1\">\n        {{ 'GENERAL.informal_res' | translate }}\n      </button>\n    </span>\n    <span class=\"spacer\"></span>\n    <span class=\"nav-item\">\n      <mat-form-field appearance=\"standard\" color=\"accent\">\n        <mat-label>{{ 'GENERAL.show_date' | translate }}</mat-label>\n        <input [formControl]=\"date_Control\" (click)=\"picker.open()\" matInput [matDatepicker]=\"picker\" [matDatepickerFilter]=\"dateFilter\">\n        <mat-datepicker-toggle style=\"color: white\" matSuffix [for]=\"picker\"></mat-datepicker-toggle>\n        <mat-datepicker touchUi=\"true\" #picker></mat-datepicker>\n      </mat-form-field>\n    </span>\n    <a mat-stroked-button style=\"min-width: 48px; padding: 0; margin-left: 16px;\" href=\"javascript:location.href = 'http://closekiosk'\">\n      <mat-icon>close</mat-icon>\n    </a>\n  </mat-toolbar-row>\n</mat-toolbar>\n\n<div class=\"spiner\" *ngIf=\"loadingData\">\n  <mat-spinner></mat-spinner>\n</div>\n\n<button mat-raised-button class=\"print-button\" (click)=\"print()\">\n  <i class=\"fas fa-print\"></i>\n</button>\n\n<div class=\"container-fluid\" *ngIf=\"!loadingData\"style=\"width: 100vw; overflow: auto;\">\n  <div class=\"spots-wrapper\">\n\n    <div class=\"flea-row\" *ngFor=\"let row of spots\">\n      <div [class]=\"spot.class\" *ngFor=\"let spot of row.spots\" (click)=\"selectSpot(spot)\"\n        [ngClass]=\"{\n          'selected': selectedSpots.includes(spot.name),\n\n          'reserved': (spot.status == 0 && !spot.discount),\n          'reserved-discount': (spot.status == 0 && spot.discount),\n\n          'not-paid': (spot.status == 1 && !spot.discount),\n          'not-paid-discount': (spot.status == 1 && spot.discount),\n\n          'paid-partly': (spot.status == 2 && !spot.discount),\n          'paid-partly-discount': (spot.status == 2 && spot.discount),\n\n          'paid': (spot.status == 3 && !spot.discount),\n          'paid-discount': (spot.status == 3 && spot.discount),\n\n          'informal1': (spot.status == 4 && spot.informalColor === 'purple'),\n          'informal2': (spot.status == 4 && spot.informalColor === 'red'),\n          'informal3': (spot.status == 4 && spot.informalColor === 'blue'),\n\n          'free-spot': (spot.status == 7)\n         }\">\n        {{ spot.name }}\n      </div>\n    </div>\n\n  </div>\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/table-view/table-view.component.html":
/*!*******************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/table-view/table-view.component.html ***!
  \*******************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<mat-toolbar color=\"primary\" class=\"mat-elevation-z4\">\n  <mat-toolbar-row>\n    <span class=\"nav-item\">\n      <button mat-raised-button [routerLink]=\"[nav.navLinks.schedule_view.url]\" [routerLinkActive]=\"['mat-accent']\">\n        <span translate>{{ nav.navLinks.schedule_view.name }}</span>\n      </button>\n      <button mat-raised-button [routerLink]=\"[nav.navLinks.table_view.url]\" [routerLinkActive]=\"['mat-accent']\">\n        <span translate>{{ nav.navLinks.table_view.name }}</span>\n      </button>\n      <button mat-raised-button [routerLink]=\"[nav.navLinks.car_market.url]\" [routerLinkActive]=\"['mat-accent']\">\n        <span translate>{{ nav.navLinks.car_market.name }}</span>\n      </button>\n      <button mat-raised-button [routerLink]=\"[nav.navLinks.kino.url]\" [routerLinkActive]=\"['mat-accent']\">\n        <span translate>{{ nav.navLinks.kino.name }}</span>\n      </button>\n    </span>\n    <span class=\"spacer\"></span>\n    <a mat-stroked-button style=\"min-width: 0;\" href=\"javascript:location.href = 'http://closekiosk'\">\n      <mat-icon>close</mat-icon>\n    </a>\n  </mat-toolbar-row>\n</mat-toolbar>\n\n<div class=\"container-fluid wrapper\">\n  <form>\n    <div class=\"row\">\n      <div class=\"col-sm-12 filter-row\">\n        <div class=\"date-filter\">\n          <mat-form-field appearance=\"standard\" color=\"accent\">\n            <mat-label>{{ 'FORM.date_from' | translate }}</mat-label>\n            <input [formControl]=\"date_from_Control\" [max]=\"date_to_Control.value\" name=\"date_from\" (click)=\"picker_from.open()\" matInput [matDatepicker]=\"picker_from\">\n            <mat-datepicker-toggle matSuffix [for]=\"picker_from\"></mat-datepicker-toggle>\n            <mat-datepicker (closed)=\"getData()\" touchUi=\"true\" #picker_from></mat-datepicker>\n          </mat-form-field>\n        </div>\n\n        <div class=\"date-filter\">\n          <mat-form-field appearance=\"standard\" color=\"accent\">\n            <mat-label>{{ 'FORM.date_to' | translate }}</mat-label>\n            <input [formControl]=\"date_to_Control\" [min]=\"date_from_Control.value\" name=\"date_to\" (click)=\"picker_to.open()\" matInput [matDatepicker]=\"picker_to\">\n            <mat-datepicker-toggle matSuffix [for]=\"picker_to\"></mat-datepicker-toggle>\n            <mat-datepicker (closed)=\"getData()\" touchUi=\"true\" #picker_to></mat-datepicker>\n          </mat-form-field>\n        </div>\n\n        <div class=\"status-filter\">\n          <mat-form-field appearance=\"standard\" style=\"width: 100%\">\n            <mat-label>{{ 'STATUS.status' | translate }}</mat-label>\n            <mat-select [formControl]=\"status_Control\" multiple (selectionChange)=\"filterResults()\">\n              <mat-option [value]=\"-1\" (click)=\"resetStatusSelection()\">\n                <span translate>{{ 'STATUS.all' }}</span>\n              </mat-option>\n              <mat-option *ngFor=\"let status of statuses\" [value]=\"status.id\">\n                <span translate>{{ status.name }}</span>\n              </mat-option>\n            </mat-select>\n            <mat-error *ngIf=\"status_Control.hasError('required')\">\n              {{ 'ERR.status_is_required' | translate }}\n            </mat-error>\n          </mat-form-field>\n        </div>\n\n        <!-- <div class=\"origin-filter\">\n          <mat-form-field appearance=\"standard\">\n            <mat-select placeholder=\"{{ 'ORIGIN.origin' | translate }}\" [formControl]=\"origin_Control\">\n              <mat-option *ngFor=\"let origin of origins\" [value]=\"origin.id\">\n                <span translate>{{ origin.name }}</span>\n              </mat-option>\n            </mat-select>\n            <mat-error *ngIf=\"origin_Control.hasError('required')\">\n              {{ 'ERR.origin_is_required' | translate }}\n            </mat-error>\n          </mat-form-field>\n        </div> -->\n\n        <div class=\"reset-filter\">\n          <button mat-raised-button color=\"warn\" (click)=\"resetFilters()\">{{ 'GENERAL.reset' | translate }}</button>\n        </div>\n      </div>\n    </div>\n  </form>\n\n  <div id=\"print\" class=\"table-wrapper mat-elevation-z8\" *ngIf=\"!loading; else spinner\">\n    <table mat-table #table [dataSource]=\"dataSource\" matSort>\n\n      <!-- ID Column -->\n      <ng-container matColumnDef=\"id\">\n        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'TABLE.id_number' | translate }} </th>\n        <td mat-cell *matCellDef=\"let element\"> {{element.id}} </td>\n      </ng-container>\n\n      <!-- Place number Column -->\n      <ng-container matColumnDef=\"spots\">\n        <th mat-header-cell *matHeaderCellDef mat-sort-header style=\"max-width: 200px;\"> {{ 'TABLE.place_number' | translate }} </th>\n        <td mat-cell *matCellDef=\"let element\" style=\"max-width: 200px; overflow: hidden; text-overflow: ellipsis\">\n          {{element.spots}}\n        </td>\n      </ng-container>\n\n      <!-- Date Column -->\n      <ng-container matColumnDef=\"date\">\n        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'TABLE.date' | translate }} </th>\n        <td mat-cell *matCellDef=\"let element\"> {{ element.date | date:'dd.MM.yyyy' }} </td>\n      </ng-container>\n\n      <!-- invoice number Column -->\n      <ng-container matColumnDef=\"invoice\">\n        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'TABLE.invoice_number' | translate }} </th>\n        <td mat-cell *matCellDef=\"let element\"> {{element.invoice}} </td>\n      </ng-container>\n\n      <!-- Cancellation Column -->\n      <ng-container matColumnDef=\"storno\">\n        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'TABLE.cancellation' | translate }} </th>\n        <td mat-cell *matCellDef=\"let element\"> {{element.storno}} </td>\n      </ng-container>\n\n      <!-- Paid Column -->\n      <ng-container matColumnDef=\"status\">\n        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'TABLE.paid' | translate }} </th>\n        <td mat-cell *matCellDef=\"let element\">\n          <span class=\"paid-status\"\n            [style.backgroundColor]=\"getStatusColor(element)\"\n            matTooltip=\"{{ getStatusTooltip(element) | translate }}\"></span>\n        </td>\n      </ng-container>\n\n      <!-- total Column -->\n      <ng-container matColumnDef=\"total\">\n        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'TABLE.earned_today' | translate }}({{ 'TABLE.total' | translate }}) </th>\n        <td mat-cell *matCellDef=\"let element\"> {{ element.earned_today }}({{element.total}}) </td>\n      </ng-container>\n\n      <!-- info Column -->\n      <ng-container matColumnDef=\"customer\">\n        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'TABLE.info' | translate }} </th>\n        <td mat-cell *matCellDef=\"let element\"> {{element.customer}} </td>\n      </ng-container>\n\n      <!-- edit Column -->\n      <ng-container matColumnDef=\"edit\">\n        <th mat-header-cell *matHeaderCellDef> {{ 'TABLE.edit' | translate }} </th>\n        <td mat-cell *matCellDef=\"let element\">\n          <button mat-button [routerLink]=\"['/booking/details', element.id]\">\n            <i class=\"far fa-edit fa-2x\"></i>\n          </button>\n        </td>\n      </ng-container>\n\n      <tr mat-header-row *matHeaderRowDef=\"displayedColumns\"></tr>\n      <tr mat-row *matRowDef=\"let row; columns: displayedColumns;\"></tr>\n    </table>\n  </div>\n\n  <ng-template #spinner>\n    <div class=\"spiner\">\n      <mat-spinner></mat-spinner>\n    </div>\n  </ng-template>\n\n  <div class=\"row sum-report\">\n    <div class=\"col-sm-4\">\n      <h4>{{ 'TABLE.sum_of_the_data_above' | translate }}</h4>\n      <div class=\"sum-row\">\n        <span>{{ 'TABLE.sum_with_tax' | translate }}</span>\n        <span>€ {{ data?.earned.toFixed(2) || 0 }}</span>\n      </div>\n      <div class=\"sum-row\">\n        <span>{{ 'TABLE.total_20%' | translate }}</span>\n        <span>€ {{ data?.tax_amount.toFixed(2) || 0 }}</span>\n      </div>\n      <div class=\"sum-row\">\n        <span>{{ 'TABLE.sum_without_tax' | translate }}</span>\n        <span>€ {{ data?.earned_without_tax.toFixed(2) || 0 }}</span>\n      </div>\n      <div class=\"sum-row\">\n        <span>{{ 'TABLE.still_open' | translate }}</span>\n        <span>€ {{ data?.unpaid.toFixed(2) || 0 }}</span>\n      </div>\n      <mat-divider></mat-divider>\n      <div class=\"sum-row\">\n        <span>{{ 'STATUS.paid' | translate }}:</span>\n        <span>{{ numberOfPaid }}</span>\n      </div>\n      <div class=\"sum-row\">\n        <span>{{ 'STATUS.not_paid' | translate }}:</span>\n        <span>{{ numberOfNotPaid }}</span>\n      </div>\n      <div class=\"sum-row\">\n        <span>{{ 'STATUS.partially_paid' | translate }}:</span>\n        <span>{{ numberOfPartiallyPaid }}</span>\n      </div>\n      <div class=\"sum-row\">\n        <span>{{ 'STATUS.cancellation' | translate }}:</span>\n        <span>{{ numberOfStornos }}</span>\n      </div>\n    </div>\n\n    <div class=\"col-sm-8 sum-actions\">\n      <button [disabled]=\"tableData.length < 1\" (click)=\"pdf()\" color=\"accent\" mat-raised-button>\n        {{ 'GENERAL.download_all_invoices_from_above' | translate }}\n      </button>\n      <button [disabled]=\"tableData.length < 1\" (click)=\"excel()\" color=\"accent\" mat-raised-button>\n        {{ 'GENERAL.download_table_excel' | translate }}\n      </button>\n      <button [disabled]=\"tableData.length < 1\" (click)=\"print()\" color=\"accent\" mat-raised-button>\n        {{ 'GENERAL.print_table' | translate }}\n      </button>\n    </div>\n  </div>\n</div>\n");

/***/ }),

/***/ "./node_modules/tslib/tslib.es6.js":
/*!*****************************************!*\
  !*** ./node_modules/tslib/tslib.es6.js ***!
  \*****************************************/
/*! exports provided: __extends, __assign, __rest, __decorate, __param, __metadata, __awaiter, __generator, __exportStar, __values, __read, __spread, __spreadArrays, __await, __asyncGenerator, __asyncDelegator, __asyncValues, __makeTemplateObject, __importStar, __importDefault */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__extends", function() { return __extends; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__assign", function() { return __assign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__rest", function() { return __rest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__decorate", function() { return __decorate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__param", function() { return __param; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__metadata", function() { return __metadata; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__awaiter", function() { return __awaiter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__generator", function() { return __generator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__exportStar", function() { return __exportStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__values", function() { return __values; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__read", function() { return __read; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spread", function() { return __spread; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spreadArrays", function() { return __spreadArrays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__await", function() { return __await; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncGenerator", function() { return __asyncGenerator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncDelegator", function() { return __asyncDelegator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncValues", function() { return __asyncValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__makeTemplateObject", function() { return __makeTemplateObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importStar", function() { return __importStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importDefault", function() { return __importDefault; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),

/***/ "./src/$$_lazy_route_resource lazy recursive":
/*!**********************************************************!*\
  !*** ./src/$$_lazy_route_resource lazy namespace object ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function webpackEmptyAsyncContext(req) {
	// Here Promise.resolve().then() is used instead of new Promise() to prevent
	// uncaught exception popping up in devtools
	return Promise.resolve().then(function() {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	});
}
webpackEmptyAsyncContext.keys = function() { return []; };
webpackEmptyAsyncContext.resolve = webpackEmptyAsyncContext;
module.exports = webpackEmptyAsyncContext;
webpackEmptyAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";

/***/ }),

/***/ "./src/app/app.component.scss":
/*!************************************!*\
  !*** ./src/app/app.component.scss ***!
  \************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".loading-overlay {\n  display: flex;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 9999;\n  background-color: rgba(0, 0, 0, 0.8);\n  justify-items: center;\n  justify-content: center;\n  align-items: center;\n}\n\n.content {\n  flex: 1 0 auto;\n}\n\n.footer {\n  display: flex;\n  padding: 0 32px;\n  flex-shrink: 0;\n  background-color: lightgray;\n  overflow: hidden;\n  height: 66px;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.footer .lang {\n  max-width: 50px;\n}\n\n@media print {\n  .footer {\n    display: none;\n  }\n}\n/*# sourceMappingURL=data:application/json;base64,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 */");

/***/ }),

/***/ "./src/app/app.component.ts":
/*!**********************************!*\
  !*** ./src/app/app.component.ts ***!
  \**********************************/
/*! exports provided: AppComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppComponent", function() { return AppComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _ngx_translate_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @ngx-translate/core */ "./node_modules/@ngx-translate/core/fesm2015/ngx-translate-core.js");
/* harmony import */ var _angular_material_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/material/core */ "./node_modules/@angular/material/esm2015/core.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _services_loading_service__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./services/loading.service */ "./src/app/services/loading.service.ts");
/* harmony import */ var _services_auth_service__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./services/auth.service */ "./src/app/services/auth.service.ts");
/* harmony import */ var _services_price_service__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./services/price.service */ "./src/app/services/price.service.ts");









let AppComponent = class AppComponent {
    constructor(translate, dateAdapter, router, loading, auth, priceService) {
        this.translate = translate;
        this.dateAdapter = dateAdapter;
        this.router = router;
        this.loading = loading;
        this.auth = auth;
        this.priceService = priceService;
        translate.addLangs(['en', 'de']); // Add languages to the service
        translate.setDefaultLang('de'); // Set default language
        this.langs = translate.getLangs(); // Get currently loaded languages for select list
        const pref_lang = this.getStoredLang();
        this.langControl = new _angular_forms__WEBPACK_IMPORTED_MODULE_4__["FormControl"](pref_lang ? pref_lang : translate.defaultLang);
        translate.use(pref_lang ? pref_lang : translate.defaultLang);
        this.dateAdapter.setLocale(pref_lang ? pref_lang : translate.defaultLang);
    }
    ngOnInit() {
        this.subscribeToRouterEvent();
        this.priceService.getPrices().subscribe(res => {
            this.priceService.setPrices(res);
        }, err => {
            console.log('Error getting prices');
            this.auth.logout();
        });
    }
    changeLang(event) {
        this.translate.use(event.value);
        localStorage.setItem('pref_lang', event.value);
        this.dateAdapter.setLocale(event.value);
    }
    /**
     * Get the language stored in local storage
     */
    getStoredLang() {
        return localStorage.getItem('pref_lang');
    }
    /**
     * Enables the loading screen on router navigation
     */
    subscribeToRouterEvent() {
        this.router.events.subscribe((event) => {
            if (event instanceof _angular_router__WEBPACK_IMPORTED_MODULE_5__["NavigationStart"]) {
                this.loading.loading = true;
            }
            else {
                this.loading.loading = false;
            }
        });
    }
};
AppComponent.ctorParameters = () => [
    { type: _ngx_translate_core__WEBPACK_IMPORTED_MODULE_2__["TranslateService"] },
    { type: _angular_material_core__WEBPACK_IMPORTED_MODULE_3__["DateAdapter"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_5__["Router"] },
    { type: _services_loading_service__WEBPACK_IMPORTED_MODULE_6__["LoadingService"] },
    { type: _services_auth_service__WEBPACK_IMPORTED_MODULE_7__["AuthService"] },
    { type: _services_price_service__WEBPACK_IMPORTED_MODULE_8__["PriceService"] }
];
AppComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-root',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./app.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./app.component.scss */ "./src/app/app.component.scss")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_ngx_translate_core__WEBPACK_IMPORTED_MODULE_2__["TranslateService"],
        _angular_material_core__WEBPACK_IMPORTED_MODULE_3__["DateAdapter"],
        _angular_router__WEBPACK_IMPORTED_MODULE_5__["Router"],
        _services_loading_service__WEBPACK_IMPORTED_MODULE_6__["LoadingService"],
        _services_auth_service__WEBPACK_IMPORTED_MODULE_7__["AuthService"],
        _services_price_service__WEBPACK_IMPORTED_MODULE_8__["PriceService"]])
], AppComponent);



/***/ }),

/***/ "./src/app/app.module.ts":
/*!*******************************!*\
  !*** ./src/app/app.module.ts ***!
  \*******************************/
/*! exports provided: HttpLoaderFactory, AppModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HttpLoaderFactory", function() { return HttpLoaderFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppModule", function() { return AppModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_platform_browser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/platform-browser */ "./node_modules/@angular/platform-browser/fesm2015/platform-browser.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _app_component__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./app.component */ "./src/app/app.component.ts");
/* harmony import */ var _angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/platform-browser/animations */ "./node_modules/@angular/platform-browser/fesm2015/animations.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var _shared_shared_module__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./shared/shared.module */ "./src/app/shared/shared.module.ts");
/* harmony import */ var _components_schedule_view_schedule_view_component__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./components/schedule-view/schedule-view.component */ "./src/app/components/schedule-view/schedule-view.component.ts");
/* harmony import */ var _ngx_translate_core__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @ngx-translate/core */ "./node_modules/@ngx-translate/core/fesm2015/ngx-translate-core.js");
/* harmony import */ var _ngx_translate_http_loader__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @ngx-translate/http-loader */ "./node_modules/@ngx-translate/http-loader/fesm2015/ngx-translate-http-loader.js");
/* harmony import */ var _components_table_view_table_view_component__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./components/table-view/table-view.component */ "./src/app/components/table-view/table-view.component.ts");
/* harmony import */ var _components_car_market_car_market_component__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./components/car-market/car-market.component */ "./src/app/components/car-market/car-market.component.ts");
/* harmony import */ var _components_kino_kino_component__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./components/kino/kino.component */ "./src/app/components/kino/kino.component.ts");
/* harmony import */ var _angular_material_moment_adapter__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! @angular/material-moment-adapter */ "./node_modules/@angular/material-moment-adapter/esm2015/material-moment-adapter.js");
/* harmony import */ var _angular_material_core__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! @angular/material/core */ "./node_modules/@angular/material/esm2015/core.js");
/* harmony import */ var _components_kino_booking_kino_booking_component__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./components/kino-booking/kino-booking.component */ "./src/app/components/kino-booking/kino-booking.component.ts");
/* harmony import */ var _components_car_market_booking_car_market_booking_component__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./components/car-market-booking/car-market-booking.component */ "./src/app/components/car-market-booking/car-market-booking.component.ts");
/* harmony import */ var angular2_notifications__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! angular2-notifications */ "./node_modules/angular2-notifications/angular2-notifications.umd.js");
/* harmony import */ var angular2_notifications__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(angular2_notifications__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _components_schedule_view_booking_details_booking_details_component__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./components/schedule-view/booking-details/booking-details.component */ "./src/app/components/schedule-view/booking-details/booking-details.component.ts");
/* harmony import */ var _components_schedule_view_change_places_dialog_change_places_dialog_component__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ./components/schedule-view/change-places-dialog/change-places-dialog.component */ "./src/app/components/schedule-view/change-places-dialog/change-places-dialog.component.ts");
/* harmony import */ var _components_schedule_view_quick_booking_dialog_quick_booking_dialog_component__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ./components/schedule-view/quick-booking-dialog/quick-booking-dialog.component */ "./src/app/components/schedule-view/quick-booking-dialog/quick-booking-dialog.component.ts");
/* harmony import */ var _components_login_login_component__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ./components/login/login.component */ "./src/app/components/login/login.component.ts");
/* harmony import */ var _guards_auth_guard__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ./guards/auth.guard */ "./src/app/guards/auth.guard.ts");
/* harmony import */ var _components_schedule_view_informal_reservation_dialog_informal_reservation_dialog_component__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ./components/schedule-view/informal-reservation-dialog/informal-reservation-dialog.component */ "./src/app/components/schedule-view/informal-reservation-dialog/informal-reservation-dialog.component.ts");
/* harmony import */ var _components_price_adjust_price_adjust_component__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ./components/price-adjust/price-adjust.component */ "./src/app/components/price-adjust/price-adjust.component.ts");
/* harmony import */ var _components_kino_inovice_print_kino_inovice_print_component__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ./components/kino-inovice-print/kino-inovice-print.component */ "./src/app/components/kino-inovice-print/kino-inovice-print.component.ts");
/* harmony import */ var _components_car_invoice_print_car_invoice_print_component__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ./components/car-invoice-print/car-invoice-print.component */ "./src/app/components/car-invoice-print/car-invoice-print.component.ts");
/* harmony import */ var _components_flea_invoice_print_flea_invoice_print_component__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! ./components/flea-invoice-print/flea-invoice-print.component */ "./src/app/components/flea-invoice-print/flea-invoice-print.component.ts");
/* harmony import */ var _components_schedule_view_booking_details_dialog_booking_details_dialog_component__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! ./components/schedule-view/booking-details-dialog/booking-details-dialog.component */ "./src/app/components/schedule-view/booking-details-dialog/booking-details-dialog.component.ts");
/* harmony import */ var _components_schedule_view_change_booking_type_dialog_change_booking_type_dialog_component__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! ./components/schedule-view/change-booking-type-dialog/change-booking-type-dialog.component */ "./src/app/components/schedule-view/change-booking-type-dialog/change-booking-type-dialog.component.ts");
/* harmony import */ var _components_changes_not_saved_dialog_changes_not_saved_dialog_component__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! ./components/changes-not-saved-dialog/changes-not-saved-dialog.component */ "./src/app/components/changes-not-saved-dialog/changes-not-saved-dialog.component.ts");
/* harmony import */ var _components_event_log_event_log_component__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! ./components/event-log/event-log.component */ "./src/app/components/event-log/event-log.component.ts");

































const routes = [
    { path: 'schedule', component: _components_schedule_view_schedule_view_component__WEBPACK_IMPORTED_MODULE_8__["ScheduleViewComponent"], canActivate: [_guards_auth_guard__WEBPACK_IMPORTED_MODULE_23__["AuthGuard"]] },
    { path: 'table-view', component: _components_table_view_table_view_component__WEBPACK_IMPORTED_MODULE_11__["TableViewComponent"], canActivate: [_guards_auth_guard__WEBPACK_IMPORTED_MODULE_23__["AuthGuard"]] },
    { path: 'booking/add', component: _components_schedule_view_booking_details_booking_details_component__WEBPACK_IMPORTED_MODULE_19__["BookingDetailsComponent"], canActivate: [_guards_auth_guard__WEBPACK_IMPORTED_MODULE_23__["AuthGuard"]] },
    { path: 'booking/details/:id', component: _components_schedule_view_booking_details_booking_details_component__WEBPACK_IMPORTED_MODULE_19__["BookingDetailsComponent"], canActivate: [_guards_auth_guard__WEBPACK_IMPORTED_MODULE_23__["AuthGuard"]] },
    { path: 'car-market', component: _components_car_market_car_market_component__WEBPACK_IMPORTED_MODULE_12__["CarMarketComponent"], canActivate: [_guards_auth_guard__WEBPACK_IMPORTED_MODULE_23__["AuthGuard"]] },
    { path: 'car-market/booking', component: _components_car_market_booking_car_market_booking_component__WEBPACK_IMPORTED_MODULE_17__["CarMarketBookingComponent"], canActivate: [_guards_auth_guard__WEBPACK_IMPORTED_MODULE_23__["AuthGuard"]] },
    { path: 'car-market/booking/:id', component: _components_car_market_booking_car_market_booking_component__WEBPACK_IMPORTED_MODULE_17__["CarMarketBookingComponent"], canActivate: [_guards_auth_guard__WEBPACK_IMPORTED_MODULE_23__["AuthGuard"]] },
    { path: 'kino', component: _components_kino_kino_component__WEBPACK_IMPORTED_MODULE_13__["KinoComponent"], canActivate: [_guards_auth_guard__WEBPACK_IMPORTED_MODULE_23__["AuthGuard"]] },
    { path: 'kino/booking', component: _components_kino_booking_kino_booking_component__WEBPACK_IMPORTED_MODULE_16__["KinoBookingComponent"], canActivate: [_guards_auth_guard__WEBPACK_IMPORTED_MODULE_23__["AuthGuard"]] },
    { path: 'login', component: _components_login_login_component__WEBPACK_IMPORTED_MODULE_22__["LoginComponent"] },
    { path: 'price/tickets', component: _components_price_adjust_price_adjust_component__WEBPACK_IMPORTED_MODULE_25__["PriceAdjustComponent"], canActivate: [_guards_auth_guard__WEBPACK_IMPORTED_MODULE_23__["AuthGuard"]] },
    { path: 'external', loadChildren: () => __webpack_require__.e(/*! import() | components-external-external-module */ "components-external-external-module").then(__webpack_require__.bind(null, /*! ./components/external/external.module */ "./src/app/components/external/external.module.ts")).then(m => m.ExternalModule) },
    { path: 'sqldump', loadChildren: () => __webpack_require__.e(/*! import() | components-sqldump-sqldump-module */ "components-sqldump-sqldump-module").then(__webpack_require__.bind(null, /*! ./components/sqldump/sqldump.module */ "./src/app/components/sqldump/sqldump.module.ts")).then(m => m.SqldumpModule) },
    { path: '**', redirectTo: '/login' },
];
// AoT requires an exported function for factories
function HttpLoaderFactory(http) {
    return new _ngx_translate_http_loader__WEBPACK_IMPORTED_MODULE_10__["TranslateHttpLoader"](http);
}
let AppModule = class AppModule {
};
AppModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["NgModule"])({
        declarations: [
            _app_component__WEBPACK_IMPORTED_MODULE_3__["AppComponent"],
            _components_schedule_view_schedule_view_component__WEBPACK_IMPORTED_MODULE_8__["ScheduleViewComponent"],
            _components_table_view_table_view_component__WEBPACK_IMPORTED_MODULE_11__["TableViewComponent"],
            _components_car_market_car_market_component__WEBPACK_IMPORTED_MODULE_12__["CarMarketComponent"],
            _components_kino_kino_component__WEBPACK_IMPORTED_MODULE_13__["KinoComponent"],
            _components_kino_booking_kino_booking_component__WEBPACK_IMPORTED_MODULE_16__["KinoBookingComponent"],
            _components_car_market_booking_car_market_booking_component__WEBPACK_IMPORTED_MODULE_17__["CarMarketBookingComponent"],
            _components_schedule_view_booking_details_booking_details_component__WEBPACK_IMPORTED_MODULE_19__["BookingDetailsComponent"],
            _components_schedule_view_change_places_dialog_change_places_dialog_component__WEBPACK_IMPORTED_MODULE_20__["ChangePlacesDialogComponent"],
            _components_schedule_view_quick_booking_dialog_quick_booking_dialog_component__WEBPACK_IMPORTED_MODULE_21__["QuickBookingDialogComponent"],
            _components_login_login_component__WEBPACK_IMPORTED_MODULE_22__["LoginComponent"],
            _components_schedule_view_informal_reservation_dialog_informal_reservation_dialog_component__WEBPACK_IMPORTED_MODULE_24__["InformalReservationDialogComponent"],
            _components_price_adjust_price_adjust_component__WEBPACK_IMPORTED_MODULE_25__["PriceAdjustComponent"],
            _components_kino_inovice_print_kino_inovice_print_component__WEBPACK_IMPORTED_MODULE_26__["KinoInovicePrintComponent"],
            _components_car_invoice_print_car_invoice_print_component__WEBPACK_IMPORTED_MODULE_27__["CarInvoicePrintComponent"],
            _components_flea_invoice_print_flea_invoice_print_component__WEBPACK_IMPORTED_MODULE_28__["FleaInvoicePrintComponent"],
            _components_schedule_view_booking_details_dialog_booking_details_dialog_component__WEBPACK_IMPORTED_MODULE_29__["BookingDetailsDialogComponent"],
            _components_schedule_view_change_booking_type_dialog_change_booking_type_dialog_component__WEBPACK_IMPORTED_MODULE_30__["ChangeBookingTypeDialogComponent"],
            _components_changes_not_saved_dialog_changes_not_saved_dialog_component__WEBPACK_IMPORTED_MODULE_31__["ChangesNotSavedDialogComponent"],
            _components_event_log_event_log_component__WEBPACK_IMPORTED_MODULE_32__["EventLogComponent"],
        ],
        imports: [
            _angular_platform_browser__WEBPACK_IMPORTED_MODULE_1__["BrowserModule"],
            _angular_router__WEBPACK_IMPORTED_MODULE_5__["RouterModule"].forRoot(routes),
            _angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_4__["BrowserAnimationsModule"],
            _angular_common_http__WEBPACK_IMPORTED_MODULE_6__["HttpClientModule"],
            _shared_shared_module__WEBPACK_IMPORTED_MODULE_7__["SharedModule"],
            _ngx_translate_core__WEBPACK_IMPORTED_MODULE_9__["TranslateModule"].forRoot({
                loader: {
                    provide: _ngx_translate_core__WEBPACK_IMPORTED_MODULE_9__["TranslateLoader"],
                    useFactory: HttpLoaderFactory,
                    deps: [_angular_common_http__WEBPACK_IMPORTED_MODULE_6__["HttpClient"]]
                }
            }),
            angular2_notifications__WEBPACK_IMPORTED_MODULE_18__["SimpleNotificationsModule"].forRoot({
                position: ['top', 'right'],
                timeOut: 3000,
                showProgressBar: true,
                pauseOnHover: true
            })
        ],
        providers: [
            { provide: _angular_material_core__WEBPACK_IMPORTED_MODULE_15__["DateAdapter"], useClass: _angular_material_moment_adapter__WEBPACK_IMPORTED_MODULE_14__["MomentDateAdapter"], deps: [_angular_material_core__WEBPACK_IMPORTED_MODULE_15__["MAT_DATE_LOCALE"]] },
            { provide: _angular_material_core__WEBPACK_IMPORTED_MODULE_15__["MAT_DATE_FORMATS"], useValue: _angular_material_moment_adapter__WEBPACK_IMPORTED_MODULE_14__["MAT_MOMENT_DATE_FORMATS"] }
        ],
        bootstrap: [_app_component__WEBPACK_IMPORTED_MODULE_3__["AppComponent"]],
        entryComponents: [
            _components_schedule_view_change_places_dialog_change_places_dialog_component__WEBPACK_IMPORTED_MODULE_20__["ChangePlacesDialogComponent"],
            _components_schedule_view_quick_booking_dialog_quick_booking_dialog_component__WEBPACK_IMPORTED_MODULE_21__["QuickBookingDialogComponent"],
            _components_schedule_view_informal_reservation_dialog_informal_reservation_dialog_component__WEBPACK_IMPORTED_MODULE_24__["InformalReservationDialogComponent"],
            _components_kino_inovice_print_kino_inovice_print_component__WEBPACK_IMPORTED_MODULE_26__["KinoInovicePrintComponent"],
            _components_car_invoice_print_car_invoice_print_component__WEBPACK_IMPORTED_MODULE_27__["CarInvoicePrintComponent"],
            _components_flea_invoice_print_flea_invoice_print_component__WEBPACK_IMPORTED_MODULE_28__["FleaInvoicePrintComponent"],
            _components_schedule_view_booking_details_dialog_booking_details_dialog_component__WEBPACK_IMPORTED_MODULE_29__["BookingDetailsDialogComponent"],
            _components_schedule_view_change_booking_type_dialog_change_booking_type_dialog_component__WEBPACK_IMPORTED_MODULE_30__["ChangeBookingTypeDialogComponent"],
            _components_changes_not_saved_dialog_changes_not_saved_dialog_component__WEBPACK_IMPORTED_MODULE_31__["ChangesNotSavedDialogComponent"]
        ]
    })
], AppModule);



/***/ }),

/***/ "./src/app/components/car-invoice-print/car-invoice-print.component.scss":
/*!*******************************************************************************!*\
  !*** ./src/app/components/car-invoice-print/car-invoice-print.component.scss ***!
  \*******************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("table {\n  width: 100%;\n}\n\n@media print {\n  button {\n    display: none;\n  }\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9Vc2Vycy9jaHJpc3RvcGhlbmdlbG1heWVyL0NvZGUvZmxvaG1hcmt0L2F1dG9raW5vdjItZmUtYmUvYW5ndWxhci1mcm9udGVuZC9zcmMvYXBwL2NvbXBvbmVudHMvY2FyLWludm9pY2UtcHJpbnQvY2FyLWludm9pY2UtcHJpbnQuY29tcG9uZW50LnNjc3MiLCJzcmMvYXBwL2NvbXBvbmVudHMvY2FyLWludm9pY2UtcHJpbnQvY2FyLWludm9pY2UtcHJpbnQuY29tcG9uZW50LnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQ0E7RUFFRSxXQUFBO0FDREY7O0FESUE7RUFFRTtJQUVFLGFBQUE7RUNIRjtBQUNGIiwiZmlsZSI6InNyYy9hcHAvY29tcG9uZW50cy9jYXItaW52b2ljZS1wcmludC9jYXItaW52b2ljZS1wcmludC5jb21wb25lbnQuc2NzcyIsInNvdXJjZXNDb250ZW50IjpbIlxudGFibGVcbntcbiAgd2lkdGg6IDEwMCU7XG59XG5cbkBtZWRpYSBwcmludFxue1xuICBidXR0b25cbiAge1xuICAgIGRpc3BsYXk6IG5vbmU7XG4gIH1cbn1cbiIsInRhYmxlIHtcbiAgd2lkdGg6IDEwMCU7XG59XG5cbkBtZWRpYSBwcmludCB7XG4gIGJ1dHRvbiB7XG4gICAgZGlzcGxheTogbm9uZTtcbiAgfVxufSJdfQ== */");

/***/ }),

/***/ "./src/app/components/car-invoice-print/car-invoice-print.component.ts":
/*!*****************************************************************************!*\
  !*** ./src/app/components/car-invoice-print/car-invoice-print.component.ts ***!
  \*****************************************************************************/
/*! exports provided: CarInvoicePrintComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CarInvoicePrintComponent", function() { return CarInvoicePrintComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! moment */ "./node_modules/moment/moment.js");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _node_modules_angular_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../node_modules/@angular/material */ "./node_modules/@angular/material/esm2015/material.js");
/* harmony import */ var _services_helper_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../services/helper.service */ "./src/app/services/helper.service.ts");





let CarInvoicePrintComponent = class CarInvoicePrintComponent {
    constructor(dialogRef, data, helper) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.helper = helper;
        this.mymoment = moment__WEBPACK_IMPORTED_MODULE_2__;
        this.imgLoaded = false;
        this.mymoment().locale('de');
    }
    ngOnInit() {
        console.log('Data', this.data);
        if (this.data.qr_image) {
            this.imgFile = 'data:image/png;base64,' + this.data.qr_image;
        }
        else if (this.data.qr_url) {
            this.helper.getBase64ImageFromUrl(this.data.qr_url)
                .then(result => {
                this.imgFile = result;
            })
                .catch(err => console.error(err));
        }
        else {
            this.imgFile = null;
            this.imgLoaded = true;
            setTimeout(() => {
                this.printInvoice();
            }, 100);
        }
    }
    printInvoice() {
        try {
            this.imgLoaded = true;
            const div = document.getElementById('print-content');
            const mywindow = window.open('', '_blank');
            mywindow.document.write('<html><head><title>' + document.title + '</title><style>*{font-size:10px}body{width: 1.8in; font-family:Arial} table{width:100%}</style>');
            mywindow.document.write('</head><body>');
            mywindow.document.write(div.innerHTML);
            mywindow.document.write('</body></html>');
            mywindow.document.close(); // necessary for IE >= 10
            mywindow.focus(); // necessary for IE >= 10*/
            mywindow.print();
            mywindow.close();
            // this.dialogRef.close();
        }
        catch (error) {
            console.log('Error has occured when trying to open a new tab: \n\n', error);
        }
    }
};
CarInvoicePrintComponent.ctorParameters = () => [
    { type: _node_modules_angular_material__WEBPACK_IMPORTED_MODULE_3__["MatDialogRef"] },
    { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"], args: [_node_modules_angular_material__WEBPACK_IMPORTED_MODULE_3__["MAT_DIALOG_DATA"],] }] },
    { type: _services_helper_service__WEBPACK_IMPORTED_MODULE_4__["HelperService"] }
];
CarInvoicePrintComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-car-invoice-print',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./car-invoice-print.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/car-invoice-print/car-invoice-print.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./car-invoice-print.component.scss */ "./src/app/components/car-invoice-print/car-invoice-print.component.scss")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__param"](1, Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"])(_node_modules_angular_material__WEBPACK_IMPORTED_MODULE_3__["MAT_DIALOG_DATA"])),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_node_modules_angular_material__WEBPACK_IMPORTED_MODULE_3__["MatDialogRef"], Object, _services_helper_service__WEBPACK_IMPORTED_MODULE_4__["HelperService"]])
], CarInvoicePrintComponent);



/***/ }),

/***/ "./src/app/components/car-market-booking/car-market-booking.component.scss":
/*!*********************************************************************************!*\
  !*** ./src/app/components/car-market-booking/car-market-booking.component.scss ***!
  \*********************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".wrapper {\n  margin: 2em auto;\n}\n.wrapper mat-form-field {\n  width: 100%;\n}\n.wrapper .flex-v-align-center {\n  display: flex;\n  align-items: center;\n}\n.wrapper .action-stack div.date-action {\n  margin: 8px 0;\n}\n.wrapper .action-stack div.date-action button {\n  width: 100%;\n}\n.wrapper .action-stack .discount {\n  margin: 16px 0;\n}\n.wrapper .action-stack .discount .discount-radio-group {\n  display: inline-flex;\n  flex-direction: column;\n}\n.wrapper .action-stack .discount .discount-radio-group .discount-button {\n  margin: 8px;\n}\n.wrapper .status-boxes {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  grid-column-gap: 16px;\n  margin-bottom: 32px;\n}\n.wrapper .status-boxes .box {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  border: 2px solid #ddd;\n  background-color: white;\n  padding: 10px;\n}\n.wrapper .status-boxes .box span {\n  text-align: center;\n}\n.wrapper .status-boxes .box span:nth-child(2) {\n  margin: 16px 0;\n  font-size: 2em;\n}\n.wrapper .status-boxes .box .status {\n  width: 50px;\n  height: 50px;\n}\n.wrapper .car-info {\n  margin-top: 32px;\n  margin-bottom: 32px;\n}\n.wrapper .car-info .subtitle {\n  margin: 16px 0;\n}\n.wrapper .car-info .image_preview {\n  width: 100%;\n  height: 150px;\n  text-align: center;\n  padding-top: 2em;\n  background-color: #f0f0f0;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  cursor: pointer;\n}\n.wrapper .car-info .online-ad {\n  margin-top: 16px;\n}\n.wrapper .car-info .online-ad p {\n  font-size: 0.85em;\n}\n.wrapper .save-button {\n  text-align: center;\n}\n/*# sourceMappingURL=data:application/json;base64,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 */");

/***/ }),

/***/ "./src/app/components/car-market-booking/car-market-booking.component.ts":
/*!*******************************************************************************!*\
  !*** ./src/app/components/car-market-booking/car-market-booking.component.ts ***!
  \*******************************************************************************/
/*! exports provided: CarMarketBookingComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CarMarketBookingComponent", function() { return CarMarketBookingComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! moment */ "./node_modules/moment/moment.js");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _services_car_market_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../services/car-market.service */ "./src/app/services/car-market.service.ts");
/* harmony import */ var _constants_statuses__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../constants/statuses */ "./src/app/constants/statuses.ts");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _services_helper_service__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../services/helper.service */ "./src/app/services/helper.service.ts");
/* harmony import */ var _ngx_translate_core__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @ngx-translate/core */ "./node_modules/@ngx-translate/core/fesm2015/ngx-translate-core.js");
/* harmony import */ var _services_loading_service__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../services/loading.service */ "./src/app/services/loading.service.ts");
/* harmony import */ var _constants_price__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../constants/price */ "./src/app/constants/price.ts");
/* harmony import */ var _node_modules_angular_material__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../../../node_modules/@angular/material */ "./node_modules/@angular/material/esm2015/material.js");
/* harmony import */ var _car_invoice_print_car_invoice_print_component__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../car-invoice-print/car-invoice-print.component */ "./src/app/components/car-invoice-print/car-invoice-print.component.ts");
/* harmony import */ var _changes_not_saved_dialog_changes_not_saved_dialog_component__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../changes-not-saved-dialog/changes-not-saved-dialog.component */ "./src/app/components/changes-not-saved-dialog/changes-not-saved-dialog.component.ts");















let CarMarketBookingComponent = class CarMarketBookingComponent {
    constructor(location, fb, carService, router, helper, i18n, ls, route, dialog) {
        this.location = location;
        this.fb = fb;
        this.carService = carService;
        this.router = router;
        this.helper = helper;
        this.i18n = i18n;
        this.ls = ls;
        this.route = route;
        this.dialog = dialog;
        this.loadingData = false;
        this.dates = [];
        this.addAmountDropdown = [1, 2, 3, 4, 5, 10];
        this.imageUploading = false;
    }
    get unitPrice() { return this.ticketPriceForm.controls.unit_price; }
    get sum() { return this.ticketPriceForm.controls.sum; }
    ngOnInit() {
        this.ls.loading = true;
        this.loadingData = true;
        const yearAgo = moment__WEBPACK_IMPORTED_MODULE_3__().locale('de').endOf('week').subtract(52, 'week');
        for (let index = 0; index <= 156; index++) // Iterate over dates to get the 3 year range
         {
            this.dates.push(yearAgo.clone().add(index, 'week').format('dddd, DD.MM.YYYY')); // Push each sunday date to the array of dates
        }
        this.bookingID = this.route.snapshot.params.id;
        if (this.bookingID) // If booking id exist, that means that we are editing an existing booking
         {
            this.carService.getBookingByID(this.bookingID).subscribe(res => {
                this.ls.loading = false;
                this.loadingData = false;
                console.log('Booking details', res);
                this.booking = res;
                this.createForm(res);
            }, err => {
                console.log(err);
                this.ls.loading = false;
                this.loadingData = false;
                this.helper.errorNoti(this.i18n.instant('NOTI.error_getting_booking'));
                this.location.back();
            });
        }
        else // Else a new booking is being made
         {
            this.createForm();
            this.loadingData = false;
            this.ls.loading = false;
        }
    }
    ngOnDestroy() {
        this.helper.clearNotifications();
    }
    createForm(booking) {
        if (booking) // If the booking is being edited
         {
            // Initialize date form
            this.datesForm = this.fb.group({
                dates: this.fb.array(this.createDatesFormGroupArray(booking.booking_dates))
            });
            // Initialize ticket price form
            this.ticketPriceForm = this.fb.group({
                price_type: [{ value: booking.discount ? true : false, disabled: true }, _angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].required],
                unit_price: [{ value: booking.price, disabled: true }, _angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].compose([_angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].required, _angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].min(0)])],
                sum: [{ value: booking.total, disabled: true }]
            });
            // Initialize user form
            this.userInfoForm = this.fb.group({
                first_name: [booking.customer.first_name, _angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].required],
                last_name: [booking.customer.last_name, _angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].required],
                email: [booking.customer.email, _angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].compose([_angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].email, _angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].required])],
                phone_number: [booking.customer.phone],
                company: [booking.customer.company],
                street: [booking.customer.streetname],
                street_number: [booking.customer.street_number],
                place: [booking.customer.city],
                post_code: [booking.customer.post_code]
            });
            // Initialize car info form
            this.carInfoForm = this.fb.group({
                vehicle_manufacturers: [booking.car_details.car_make, _angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].required],
                vehicle_model: [booking.car_details.car_model, _angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].required],
                vehicle_price: [booking.car_details.car_price, _angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].required],
                ad_desc: [booking.car_details.description],
                vehicle_url: [booking.car_details.photo_url]
            });
            this.topayControl = new _angular_forms__WEBPACK_IMPORTED_MODULE_4__["FormControl"]((booking.total - booking.payed_amount).toFixed(2), _angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].compose([
                _angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].required,
                _angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].min(0.01)
            ]));
        }
        else // If a new booking is being made
         {
            // Initialize date form
            this.datesForm = this.fb.group({
                dates: this.fb.array([
                    new _angular_forms__WEBPACK_IMPORTED_MODULE_4__["FormGroup"]({
                        date: new _angular_forms__WEBPACK_IMPORTED_MODULE_4__["FormControl"](moment__WEBPACK_IMPORTED_MODULE_3__().locale('de').endOf('week').format('dddd, DD.MM.YYYY'), _angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].required)
                    })
                ])
            });
            // Initialize ticket price form
            this.ticketPriceForm = this.fb.group({
                price_type: [false, _angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].required],
                unit_price: [_constants_price__WEBPACK_IMPORTED_MODULE_11__["Price"].CAR, _angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].compose([_angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].required, _angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].min(0)])],
                sum: [_constants_price__WEBPACK_IMPORTED_MODULE_11__["Price"].CAR, _angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].compose([_angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].required, _angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].min(0)])]
            });
            // Initialize user form
            this.userInfoForm = this.fb.group({
                first_name: ['', _angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].required],
                last_name: ['', _angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].required],
                email: ['', _angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].compose([_angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].email, _angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].required])],
                phone_number: [''],
                company: [''],
                street: [''],
                street_number: [''],
                place: [''],
                post_code: ['']
            });
            // Initialize car info form
            this.carInfoForm = this.fb.group({
                vehicle_manufacturers: ['', _angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].required],
                vehicle_model: ['', _angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].required],
                vehicle_price: ['', _angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].required],
                ad_desc: [''],
                vehicle_url: ['']
            });
        }
        this.ticketPriceForm.controls['price_type'].valueChanges.subscribe(value => {
            this.calcSum();
        });
        this.unitPrice.valueChanges.subscribe(v => {
            if (v < 0) {
                this.unitPrice.setValue(0, { emitEvent: false });
            }
            this.calculateSum();
        });
        this.sum.valueChanges.subscribe(v => {
            if (v < 0) {
                this.sum.setValue(0, { emitEvent: false });
            }
            this.calculateTicketPrice();
        });
        this.carInfoForm.controls.vehicle_price.valueChanges.subscribe(v => {
            if (v < 0) {
                this.carInfoForm.controls.vehicle_price.setValue(0, { emitEvent: false });
            }
        });
    }
    calculateSum() {
        this.sum.setValue(this.unitPrice.value * this.getDatesControls().length, { emitEvent: false });
    }
    calculateTicketPrice() {
        this.unitPrice.setValue(this.helper.getTicketPriceBasedOnTotal(this.sum.value, 1, this.getDatesControls().length), { emitEvent: false });
    }
    /**
     * Returns a form group array with formatted dates
     * @param dates
     */
    createDatesFormGroupArray(dates) {
        const formGroupArray = [];
        dates.forEach((element, i) => {
            formGroupArray.push(new _angular_forms__WEBPACK_IMPORTED_MODULE_4__["FormGroup"]({
                date: new _angular_forms__WEBPACK_IMPORTED_MODULE_4__["FormControl"]({ value: moment__WEBPACK_IMPORTED_MODULE_3__(element.date, 'YYYY-MM-DD').locale('de').format('dddd, DD.MM.YYYY'), disabled: true }, _angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].required)
            }));
        });
        return formGroupArray;
    }
    /**
     * Gets the dates form groups
     */
    getDatesControls() {
        // @ts-ignore
        return this.datesForm.get('dates').controls;
    }
    /**
     * Gets the field's value
     * @param field
     */
    getUserFormControlValue(field) {
        return this.userInfoForm.controls[field].value;
    }
    /**
     * Gets the field's value
     * @param field
     */
    getCarFormControlValue(field) {
        return this.carInfoForm.controls[field].value;
    }
    goBack() {
        if (this.datesForm.touched || this.ticketPriceForm.touched || this.userInfoForm.touched || this.carInfoForm) {
            const dialogRef = this.dialog.open(_changes_not_saved_dialog_changes_not_saved_dialog_component__WEBPACK_IMPORTED_MODULE_14__["ChangesNotSavedDialogComponent"], { autoFocus: false, minWidth: 300 });
            dialogRef.afterClosed().subscribe(dialog_response => {
                console.log(dialog_response);
                if (dialog_response) {
                    this.location.back();
                }
            });
        }
        else {
            this.location.back();
        }
    }
    calcSum() {
        this.ticketPriceForm.controls.unit_price.setValue(this.ticketPriceForm.controls.price_type.value ? _constants_price__WEBPACK_IMPORTED_MODULE_11__["Price"].CAR_DISCOUNT : _constants_price__WEBPACK_IMPORTED_MODULE_11__["Price"].CAR);
        this.ticketPriceForm.controls['sum'].setValue(this.ticketPriceForm.controls.price_type.value ?
            _constants_price__WEBPACK_IMPORTED_MODULE_11__["Price"].CAR_DISCOUNT * this.getDatesControls().length :
            _constants_price__WEBPACK_IMPORTED_MODULE_11__["Price"].CAR * this.getDatesControls().length);
    }
    /**
     * Adds new date control to the formArray
     * @param amount The amount of dates to add
     */
    addNewDate(amount = 1) {
        // Iterate the amount of time specified
        for (let i = 0; i < amount; i++) {
            // Get the index of the last form group control in form array
            const len = this.getDatesControls().length;
            // Get the date value of the date control
            const last_date_value = this.getDatesControls()[len - 1].controls['date'].value;
            // Add a week to the found control
            const value = this.getMomentFromString(last_date_value).add(1, 'week');
            this.datesForm.get('dates').push(new _angular_forms__WEBPACK_IMPORTED_MODULE_4__["FormGroup"]({
                // Initialize the new form control with a date one week in advance
                date: new _angular_forms__WEBPACK_IMPORTED_MODULE_4__["FormControl"](this.getStringDateFromMoment(value), _angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].required)
            }));
        }
        this.calculateSum();
    }
    /**
     * Removes the date control from the formArray on the provided index
     * @param num Index of the form control
     */
    removeDate(num) {
        this.datesForm.get('dates').removeAt(num);
        this.calculateSum();
    }
    onFileChanged(files) {
        this.selectedFile = files[0]; // Set the selected file
        // Make the file into a base64 string to show it in the preview
        const reader = new FileReader();
        reader.readAsDataURL(this.selectedFile);
        reader.onload = () => {
            this.image = reader.result;
            this.imageUploading = true;
            // Upload the file to the back end
            this.carService.uploadImage(this.image).subscribe(res => {
                console.log('Upload response', res);
                this.carInfoForm.controls.vehicle_url.setValue(res.url);
                this.imageUploading = false;
            }, err => console.log('Error on upload', err));
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
    }
    submitForm() {
        const data = {
            status: _constants_statuses__WEBPACK_IMPORTED_MODULE_6__["STATUS_NOT_PAID"],
            price: this.unitPrice.value,
            discount: this.ticketPriceForm.controls.price_type.value,
            booking_dates: this.getBookingDates(),
            customer: {
                first_name: this.getUserFormControlValue('first_name'),
                last_name: this.getUserFormControlValue('last_name'),
                email: this.getUserFormControlValue('email'),
                phone: this.getUserFormControlValue('phone_number'),
                company: this.getUserFormControlValue('company'),
                streetname: this.getUserFormControlValue('street'),
                street_number: this.getUserFormControlValue('street_number'),
                city: this.getUserFormControlValue('place'),
                post_code: this.getUserFormControlValue('post_code')
            },
            car_details: {
                car_price: this.getCarFormControlValue('vehicle_price'),
                car_make: this.getCarFormControlValue('vehicle_manufacturers'),
                car_model: this.getCarFormControlValue('vehicle_model'),
                description: this.getCarFormControlValue('ad_desc'),
                photo_url: this.getCarFormControlValue('vehicle_url')
            }
        };
        console.log('');
        console.log('DATA', data);
        console.log('');
        if (this.bookingID) {
            if (!this.userInfoForm.valid || !this.carInfoForm.valid) {
                this.helper.warningNoti(this.i18n.instant('NOTI.fill_required_fields'));
                this.markControlsAsTouch();
                return;
            }
            this.ls.loading = true;
            data.id = this.bookingID;
            this.carService.updateCarMarketBooking(data).subscribe(res => {
                this.ls.loading = false;
                console.log('Car booking updated response:', res);
                this.helper.successNoti(this.i18n.instant('NOTI.booking_saved'));
                this.router.navigate(['/car-market']);
            }, (err) => {
                this.ls.loading = false;
                this.helper.errorNoti(this.i18n.instant('NOTI.error_saving_booking', err.error.message));
                console.log('Car market booking update error', err);
            });
        }
        else {
            if (!this.areFormsValid()) {
                this.helper.warningNoti(this.i18n.instant('NOTI.fill_required_fields'));
                console.log('Valid ', this.areFormsValid());
                this.markControlsAsTouch();
                return;
            }
            this.ls.loading = true;
            this.carService.createCarMarketBooking(data).subscribe(res => {
                this.ls.loading = false;
                console.log('Car booking response:', res);
                this.helper.successNoti(this.i18n.instant('NOTI.booking_saved'));
                this.router.navigate(['/car-market']);
            }, (err) => {
                this.ls.loading = false;
                this.helper.errorNoti(this.i18n.instant('NOTI.error_saving_booking', err.error.message));
                console.log(err);
            });
        }
    }
    areFormsValid() {
        return this.datesForm.valid && this.userInfoForm.valid && this.carInfoForm.valid && this.ticketPriceForm.valid;
    }
    markControlsAsTouch() {
        Object.keys(this.userInfoForm.controls).forEach(field => {
            const control = this.userInfoForm.get(field);
            control.markAsTouched({ onlySelf: true });
        });
        Object.keys(this.carInfoForm.controls).forEach(field => {
            const control = this.carInfoForm.get(field);
            control.markAsTouched({ onlySelf: true });
        });
        Object.keys(this.ticketPriceForm.controls).forEach(field => {
            const control = this.ticketPriceForm.get(field);
            control.markAsTouched({ onlySelf: true });
        });
    }
    /**
     * Get string array of booking dates to send to backend
     */
    getBookingDates() {
        const booking_dates = [];
        this.getDatesControls().forEach(date => {
            const mom_date = this.getMomentFromString(date.controls.date.value);
            booking_dates.push({ date: mom_date.format('YYYY-MM-DD') });
        });
        return booking_dates;
    }
    /**
     * Converts the date in string format to a moment object
     * @param date
     * @param format
     */
    getMomentFromString(date, format = 'dddd, DD.MM.YYYY') {
        return moment__WEBPACK_IMPORTED_MODULE_3__(date, format, 'de', true);
    }
    /**
     * Converts the moment object to a string format
     * @param date
     * @param format
     */
    getStringDateFromMoment(date, format = 'dddd, DD.MM.YYYY') {
        return moment__WEBPACK_IMPORTED_MODULE_3__(date).locale('de').format(format);
    }
    addUntilEndOfMonth() {
        // Get current value
        const date = this.getDatesControls()[this.getDatesControls().length - 1].controls['date'].value;
        // Get current date's end of month
        const date_a = this.getMomentFromString(date).endOf('month');
        // Get current date to moment object
        const date_b = this.getMomentFromString(date);
        // Get the difference in weeks to the end of the month
        const diff = date_a.diff(date_b, 'week');
        // Add the amount of dates in difference
        this.addNewDate(diff);
    }
    addUntilEndOfYear() {
        // Get current value
        const date = this.getDatesControls()[this.getDatesControls().length - 1].controls['date'].value;
        // Get current date's end of month
        const date_a = this.getMomentFromString(date).endOf('year');
        // Get current date to moment object
        const date_b = this.getMomentFromString(date);
        // Get the difference in weeks to the end of the month
        const diff = date_a.diff(date_b, 'week');
        // Add the amount of dates in difference
        this.addNewDate(diff);
    }
    addOneYear() {
        this.addNewDate(52); // Add 52 weeks
    }
    /**
     * Creates an invoice
     */
    createInvoice() {
        if (this.booking && (this.booking.status === _constants_statuses__WEBPACK_IMPORTED_MODULE_6__["STATUS_PAID"] || this.booking.status === _constants_statuses__WEBPACK_IMPORTED_MODULE_6__["STATUS_STORNO"])) {
            this.carService.getCarInvoice(this.booking.invoices[0].id).subscribe(res => {
                this.dialog.open(_car_invoice_print_car_invoice_print_component__WEBPACK_IMPORTED_MODULE_13__["CarInvoicePrintComponent"], { data: res, disableClose: true, autoFocus: false });
            });
        }
        else {
            this.ls.loading = true;
            this.carService.createCarMarketInvoice(this.bookingID, this.topayControl.value).subscribe(res => {
                this.ls.loading = false;
                const dialogRef = this.dialog.open(_car_invoice_print_car_invoice_print_component__WEBPACK_IMPORTED_MODULE_13__["CarInvoicePrintComponent"], { data: res, disableClose: true, autoFocus: false });
                dialogRef.afterClosed().subscribe(dialogResponse => {
                    this.router.navigate(['/car-market']);
                });
            }, err => {
                console.log('Error creating invoice', err);
                this.helper.errorNoti(this.i18n.instant('ERR.error_create_invoice'));
                this.ls.loading = false;
            });
        }
    }
    createStorno() {
        this.ls.loading = true;
        this.carService.stornoCarMarketBooking(this.bookingID).subscribe(res => {
            console.log('Storno response: ', res);
            this.ls.loading = false;
            const dialogRef = this.dialog.open(_car_invoice_print_car_invoice_print_component__WEBPACK_IMPORTED_MODULE_13__["CarInvoicePrintComponent"], { data: res, disableClose: true, autoFocus: false });
            dialogRef.afterClosed().subscribe(dialogResponse => {
                this.router.navigate(['/car-market']);
            });
        }, err => {
            console.log('Storno error', err);
            this.ls.loading = false;
        });
    }
    /**
     * Calculate how many weeks are left in a booking
     */
    remainingWeeks() {
        let rem = 0;
        if (this.booking) {
            this.booking.booking_dates.forEach(element => {
                if (moment__WEBPACK_IMPORTED_MODULE_3__(element.date, 'YYYY-MM-DD').isAfter(moment__WEBPACK_IMPORTED_MODULE_3__())) {
                    rem++;
                }
            });
        }
        return rem || 0;
    }
    /**
     * Prints the invoice
     * @param invoice_id
     */
    printInvoiceById(invoice_id) {
        this.carService.getCarInvoice(invoice_id).subscribe(res => {
            const dialogRef = this.dialog.open(_car_invoice_print_car_invoice_print_component__WEBPACK_IMPORTED_MODULE_13__["CarInvoicePrintComponent"], { data: res, disableClose: true, autoFocus: false });
        });
    }
};
CarMarketBookingComponent.ctorParameters = () => [
    { type: _angular_common__WEBPACK_IMPORTED_MODULE_2__["Location"] },
    { type: _angular_forms__WEBPACK_IMPORTED_MODULE_4__["FormBuilder"] },
    { type: _services_car_market_service__WEBPACK_IMPORTED_MODULE_5__["CarMarketService"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_7__["Router"] },
    { type: _services_helper_service__WEBPACK_IMPORTED_MODULE_8__["HelperService"] },
    { type: _ngx_translate_core__WEBPACK_IMPORTED_MODULE_9__["TranslateService"] },
    { type: _services_loading_service__WEBPACK_IMPORTED_MODULE_10__["LoadingService"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_7__["ActivatedRoute"] },
    { type: _node_modules_angular_material__WEBPACK_IMPORTED_MODULE_12__["MatDialog"] }
];
CarMarketBookingComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-car-market-booking',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./car-market-booking.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/car-market-booking/car-market-booking.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./car-market-booking.component.scss */ "./src/app/components/car-market-booking/car-market-booking.component.scss")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_common__WEBPACK_IMPORTED_MODULE_2__["Location"],
        _angular_forms__WEBPACK_IMPORTED_MODULE_4__["FormBuilder"],
        _services_car_market_service__WEBPACK_IMPORTED_MODULE_5__["CarMarketService"],
        _angular_router__WEBPACK_IMPORTED_MODULE_7__["Router"],
        _services_helper_service__WEBPACK_IMPORTED_MODULE_8__["HelperService"],
        _ngx_translate_core__WEBPACK_IMPORTED_MODULE_9__["TranslateService"],
        _services_loading_service__WEBPACK_IMPORTED_MODULE_10__["LoadingService"],
        _angular_router__WEBPACK_IMPORTED_MODULE_7__["ActivatedRoute"],
        _node_modules_angular_material__WEBPACK_IMPORTED_MODULE_12__["MatDialog"]])
], CarMarketBookingComponent);



/***/ }),

/***/ "./src/app/components/car-market/car-market.component.scss":
/*!*****************************************************************!*\
  !*** ./src/app/components/car-market/car-market.component.scss ***!
  \*****************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".wrapper {\n  margin: 16px auto;\n}\n.wrapper .filter-row {\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n}\n.wrapper .filter-row .date-filter {\n  width: 135px;\n}\n.wrapper .filter-row .status-filter {\n  width: 350px;\n}\n.wrapper .filter-row mat-form-field {\n  width: 100%;\n}\n.wrapper .table-wrapper table {\n  width: 100%;\n}\n.wrapper .table-wrapper table .paid-status {\n  display: block;\n  content: \" \";\n  width: 25px;\n  height: 25px;\n}\n.wrapper .table-wrapper table .paid {\n  background-color: green;\n}\n.wrapper .table-wrapper table .partially-paid {\n  background-color: orange;\n}\n.wrapper .table-wrapper table .not-paid {\n  background-color: red;\n}\n.wrapper .table-wrapper table .cancellation {\n  background-color: darkgray;\n}\n.wrapper .sum-report {\n  margin-top: 2em;\n}\n.wrapper .sum-report .sum-row {\n  display: flex;\n  justify-content: space-between;\n  margin: 8px 0;\n}\n.wrapper .sum-report .sum-actions {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  align-items: center;\n}\n.wrapper .sum-report .sum-actions button:not(:first-child) {\n  margin-left: 16px;\n}\n.wrapper .spiner {\n  display: flex;\n  justify-content: center;\n}\n@media print {\n  button {\n    display: none;\n  }\n\n  mat-form-field {\n    display: none;\n  }\n\n  mat-toolbar {\n    display: none;\n  }\n}\n/*# sourceMappingURL=data:application/json;base64,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 */");

/***/ }),

/***/ "./src/app/components/car-market/car-market.component.ts":
/*!***************************************************************!*\
  !*** ./src/app/components/car-market/car-market.component.ts ***!
  \***************************************************************/
/*! exports provided: CarMarketComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CarMarketComponent", function() { return CarMarketComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _services_nav_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../services/nav.service */ "./src/app/services/nav.service.ts");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! moment */ "./node_modules/moment/moment.js");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _constants_statuses__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../constants/statuses */ "./src/app/constants/statuses.ts");
/* harmony import */ var _constants_origins__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../constants/origins */ "./src/app/constants/origins.ts");
/* harmony import */ var _angular_material_sort__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @angular/material/sort */ "./node_modules/@angular/material/esm2015/sort.js");
/* harmony import */ var _angular_material_table__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @angular/material/table */ "./node_modules/@angular/material/esm2015/table.js");
/* harmony import */ var _services_car_market_service__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../services/car-market.service */ "./src/app/services/car-market.service.ts");
/* harmony import */ var _services_download_file_service__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../services/download-file.service */ "./src/app/services/download-file.service.ts");
/* harmony import */ var _services_helper_service__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../services/helper.service */ "./src/app/services/helper.service.ts");
/* harmony import */ var _ngx_translate_core__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @ngx-translate/core */ "./node_modules/@ngx-translate/core/fesm2015/ngx-translate-core.js");













let CarMarketComponent = class CarMarketComponent {
    constructor(nav, carMarketService, downloadService, helper, i18n) {
        this.nav = nav;
        this.carMarketService = carMarketService;
        this.downloadService = downloadService;
        this.helper = helper;
        this.i18n = i18n;
        this.loading = false;
        this.statuses = _constants_statuses__WEBPACK_IMPORTED_MODULE_5__["STATUSES"].filter(s => s.id !== _constants_statuses__WEBPACK_IMPORTED_MODULE_5__["STATUS_INFORMAL_RESERVATION"] && s.id !== _constants_statuses__WEBPACK_IMPORTED_MODULE_5__["STATUS_RESERVED"] && s.id !== _constants_statuses__WEBPACK_IMPORTED_MODULE_5__["STATUS_FREE"]);
        this.origins = _constants_origins__WEBPACK_IMPORTED_MODULE_6__["ORIGINS"];
        // Table
        this.dataSource = new _angular_material_table__WEBPACK_IMPORTED_MODULE_8__["MatTableDataSource"]();
        this.displayedColumns = ['id', 'date', 'status', 'total', 'customer', 'edit'];
        this.tableData = [];
    }
    ngOnInit() {
        this.createFormControls();
    }
    ngOnDestroy() {
        this.helper.clearNotifications();
    }
    createFormControls() {
        if (moment__WEBPACK_IMPORTED_MODULE_4__().day() === 0) // Check if it is sunday
         {
            this.date_from_Control = new _angular_forms__WEBPACK_IMPORTED_MODULE_3__["FormControl"](moment__WEBPACK_IMPORTED_MODULE_4__());
            this.date_to_Control = new _angular_forms__WEBPACK_IMPORTED_MODULE_3__["FormControl"](moment__WEBPACK_IMPORTED_MODULE_4__());
        }
        else // If not set date to next sunday
         {
            this.date_from_Control = new _angular_forms__WEBPACK_IMPORTED_MODULE_3__["FormControl"](moment__WEBPACK_IMPORTED_MODULE_4__().day(0 + 7));
            this.date_to_Control = new _angular_forms__WEBPACK_IMPORTED_MODULE_3__["FormControl"](moment__WEBPACK_IMPORTED_MODULE_4__().day(0 + 7));
        }
        this.status_Control = new _angular_forms__WEBPACK_IMPORTED_MODULE_3__["FormControl"]([-1], [_angular_forms__WEBPACK_IMPORTED_MODULE_3__["Validators"].required]);
        this.origin_Control = new _angular_forms__WEBPACK_IMPORTED_MODULE_3__["FormControl"](this.origins[0].id, [_angular_forms__WEBPACK_IMPORTED_MODULE_3__["Validators"].required]);
        this.getData();
    }
    /**
     * Resets the filters
     */
    resetFilters() {
        this.createFormControls();
    }
    fillSource() {
        this.dataSource.data = this.tableData;
    }
    getData() {
        this.loading = true;
        this.carMarketService.getTableData(this.date_from_Control.value.format('YYYY-MM-DD'), this.date_to_Control.value.format('YYYY-MM-DD'))
            .subscribe((res) => {
            console.log('Car table:', res);
            this.data = res;
            this.tableData = res.data;
            this.fillSource();
            this.loading = false;
            setTimeout(() => {
                this.dataSource.sort = this.sort;
            }, 0);
        }, (err) => {
            this.helper.infoNoti(this.i18n.instant('NOTI.no_booking_in_date_range'));
            this.tableData = [];
            this.dataSource.data = [];
            this.loading = false;
            console.log(err);
        });
    }
    /**
     * Results filter for table
     */
    filterResults() {
        let selectedValue = this.status_Control.value;
        if (selectedValue.length >= 1) {
            if (selectedValue.includes(-1)) {
                // If All is selected, filter it out
                this.status_Control.setValue(selectedValue.filter(x => x !== -1));
                selectedValue = this.status_Control.value;
            }
            console.log('Selected', selectedValue);
            console.log('Table data:', this.tableData);
            this.dataSource.data = this.tableData.filter(row => selectedValue.includes(row.status));
        }
        else if (selectedValue.length < 1 && !selectedValue.includes(-1)) {
            this.status_Control.setValue([-1]);
            this.dataSource.data = this.tableData;
        }
    }
    resetStatusSelection() {
        this.status_Control.setValue([-1]);
        this.dataSource.data = this.tableData;
    }
    pdf() {
        this.carMarketService.getPDF(this.date_from_Control.value.format('YYYY-MM-DD'), this.date_to_Control.value.format('YYYY-MM-DD'))
            .subscribe((res) => {
            const title = 'Automarkt report ' + this.date_from_Control.value.format('YYYY-MM-DD') + ' ' + this.date_to_Control.value.format('YYYY-MM-DD');
            this.downloadService.download(res, title, '.pdf');
        }, (err) => {
            console.log(err);
        });
    }
    excel() {
        this.carMarketService.getExcel(this.date_from_Control.value.format('YYYY-MM-DD'), this.date_to_Control.value.format('YYYY-MM-DD'))
            .subscribe((res) => {
            const title = 'Automarkt report ' + this.date_from_Control.value.format('YYYY-MM-DD') + ' ' + this.date_to_Control.value.format('YYYY-MM-DD');
            this.downloadService.download(res, title, '.xlsx');
        }, (err) => {
            console.log(err);
        });
    }
    /**
     * print table with printer
     */
    print() {
        window.print();
    }
    getStatusColor(element) {
        const found = _constants_statuses__WEBPACK_IMPORTED_MODULE_5__["STATUSES"].find(x => x.id === element.status);
        return found ? found.color : '';
    }
    getStatusTooltip(element) {
        const found = _constants_statuses__WEBPACK_IMPORTED_MODULE_5__["STATUSES"].find(x => x.id === element.status);
        return found ? found.name : '';
    }
};
CarMarketComponent.ctorParameters = () => [
    { type: _services_nav_service__WEBPACK_IMPORTED_MODULE_2__["NavService"] },
    { type: _services_car_market_service__WEBPACK_IMPORTED_MODULE_9__["CarMarketService"] },
    { type: _services_download_file_service__WEBPACK_IMPORTED_MODULE_10__["DownloadFileService"] },
    { type: _services_helper_service__WEBPACK_IMPORTED_MODULE_11__["HelperService"] },
    { type: _ngx_translate_core__WEBPACK_IMPORTED_MODULE_12__["TranslateService"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"])(_angular_material_sort__WEBPACK_IMPORTED_MODULE_7__["MatSort"], { static: false }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", _angular_material_sort__WEBPACK_IMPORTED_MODULE_7__["MatSort"])
], CarMarketComponent.prototype, "sort", void 0);
CarMarketComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-car-market',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./car-market.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/car-market/car-market.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./car-market.component.scss */ "./src/app/components/car-market/car-market.component.scss")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_services_nav_service__WEBPACK_IMPORTED_MODULE_2__["NavService"],
        _services_car_market_service__WEBPACK_IMPORTED_MODULE_9__["CarMarketService"],
        _services_download_file_service__WEBPACK_IMPORTED_MODULE_10__["DownloadFileService"],
        _services_helper_service__WEBPACK_IMPORTED_MODULE_11__["HelperService"],
        _ngx_translate_core__WEBPACK_IMPORTED_MODULE_12__["TranslateService"]])
], CarMarketComponent);



/***/ }),

/***/ "./src/app/components/changes-not-saved-dialog/changes-not-saved-dialog.component.scss":
/*!*********************************************************************************************!*\
  !*** ./src/app/components/changes-not-saved-dialog/changes-not-saved-dialog.component.scss ***!
  \*********************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2NvbXBvbmVudHMvY2hhbmdlcy1ub3Qtc2F2ZWQtZGlhbG9nL2NoYW5nZXMtbm90LXNhdmVkLWRpYWxvZy5jb21wb25lbnQuc2NzcyJ9 */");

/***/ }),

/***/ "./src/app/components/changes-not-saved-dialog/changes-not-saved-dialog.component.ts":
/*!*******************************************************************************************!*\
  !*** ./src/app/components/changes-not-saved-dialog/changes-not-saved-dialog.component.ts ***!
  \*******************************************************************************************/
/*! exports provided: ChangesNotSavedDialogComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ChangesNotSavedDialogComponent", function() { return ChangesNotSavedDialogComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _node_modules_angular_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../node_modules/@angular/material */ "./node_modules/@angular/material/esm2015/material.js");



let ChangesNotSavedDialogComponent = class ChangesNotSavedDialogComponent {
    constructor(dialogRef) {
        this.dialogRef = dialogRef;
    }
    ngOnInit() {
    }
};
ChangesNotSavedDialogComponent.ctorParameters = () => [
    { type: _node_modules_angular_material__WEBPACK_IMPORTED_MODULE_2__["MatDialogRef"] }
];
ChangesNotSavedDialogComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-changes-not-saved-dialog',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./changes-not-saved-dialog.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/changes-not-saved-dialog/changes-not-saved-dialog.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./changes-not-saved-dialog.component.scss */ "./src/app/components/changes-not-saved-dialog/changes-not-saved-dialog.component.scss")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_node_modules_angular_material__WEBPACK_IMPORTED_MODULE_2__["MatDialogRef"]])
], ChangesNotSavedDialogComponent);



/***/ }),

/***/ "./src/app/components/event-log/event-log.component.scss":
/*!***************************************************************!*\
  !*** ./src/app/components/event-log/event-log.component.scss ***!
  \***************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2NvbXBvbmVudHMvZXZlbnQtbG9nL2V2ZW50LWxvZy5jb21wb25lbnQuc2NzcyJ9 */");

/***/ }),

/***/ "./src/app/components/event-log/event-log.component.ts":
/*!*************************************************************!*\
  !*** ./src/app/components/event-log/event-log.component.ts ***!
  \*************************************************************/
/*! exports provided: EventLogComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EventLogComponent", function() { return EventLogComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let EventLogComponent = class EventLogComponent {
    constructor() {
        this._eventLog = [];
    }
    set eventLog(v) { this._eventLog = v.reverse(); }
    get eventLog() { return this._eventLog; }
    ngOnInit() {
    }
};
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])(),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", Array),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [Array])
], EventLogComponent.prototype, "eventLog", null);
EventLogComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-event-log',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./event-log.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/event-log/event-log.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./event-log.component.scss */ "./src/app/components/event-log/event-log.component.scss")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [])
], EventLogComponent);



/***/ }),

/***/ "./src/app/components/flea-invoice-print/flea-invoice-print.component.scss":
/*!*********************************************************************************!*\
  !*** ./src/app/components/flea-invoice-print/flea-invoice-print.component.scss ***!
  \*********************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("table {\n  width: 100%;\n}\n\n@media print {\n  button {\n    display: none;\n  }\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9Vc2Vycy9jaHJpc3RvcGhlbmdlbG1heWVyL0NvZGUvZmxvaG1hcmt0L2F1dG9raW5vdjItZmUtYmUvYW5ndWxhci1mcm9udGVuZC9zcmMvYXBwL2NvbXBvbmVudHMvZmxlYS1pbnZvaWNlLXByaW50L2ZsZWEtaW52b2ljZS1wcmludC5jb21wb25lbnQuc2NzcyIsInNyYy9hcHAvY29tcG9uZW50cy9mbGVhLWludm9pY2UtcHJpbnQvZmxlYS1pbnZvaWNlLXByaW50LmNvbXBvbmVudC5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUNBO0VBRUUsV0FBQTtBQ0RGOztBRElBO0VBRUU7SUFFRSxhQUFBO0VDSEY7QUFDRiIsImZpbGUiOiJzcmMvYXBwL2NvbXBvbmVudHMvZmxlYS1pbnZvaWNlLXByaW50L2ZsZWEtaW52b2ljZS1wcmludC5jb21wb25lbnQuc2NzcyIsInNvdXJjZXNDb250ZW50IjpbIlxudGFibGVcbntcbiAgd2lkdGg6IDEwMCU7XG59XG5cbkBtZWRpYSBwcmludFxue1xuICBidXR0b25cbiAge1xuICAgIGRpc3BsYXk6IG5vbmU7XG4gIH1cbn1cbiIsInRhYmxlIHtcbiAgd2lkdGg6IDEwMCU7XG59XG5cbkBtZWRpYSBwcmludCB7XG4gIGJ1dHRvbiB7XG4gICAgZGlzcGxheTogbm9uZTtcbiAgfVxufSJdfQ== */");

/***/ }),

/***/ "./src/app/components/flea-invoice-print/flea-invoice-print.component.ts":
/*!*******************************************************************************!*\
  !*** ./src/app/components/flea-invoice-print/flea-invoice-print.component.ts ***!
  \*******************************************************************************/
/*! exports provided: FleaInvoicePrintComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FleaInvoicePrintComponent", function() { return FleaInvoicePrintComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! moment */ "./node_modules/moment/moment.js");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _node_modules_angular_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../node_modules/@angular/material */ "./node_modules/@angular/material/esm2015/material.js");
/* harmony import */ var _services_helper_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../services/helper.service */ "./src/app/services/helper.service.ts");
/* harmony import */ var _angular_platform_browser__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/platform-browser */ "./node_modules/@angular/platform-browser/fesm2015/platform-browser.js");






let FleaInvoicePrintComponent = class FleaInvoicePrintComponent {
    constructor(dialogRef, data, helper, sanitize) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.helper = helper;
        this.sanitize = sanitize;
        this.mymoment = moment__WEBPACK_IMPORTED_MODULE_2__;
        this.abs = Math.abs;
        this.imgLoaded = false;
        this.bookings = [];
        this.bookedSpots = '';
        this.mymoment().locale('de');
    }
    ngOnInit() {
        console.log('Data', this.data);
        this.data.fleaMarketBooking.booking_dates.forEach(date => {
            this.bookings.push({
                spotAmount: this.data.fleaMarketBooking.spots.length,
                date: this.mymoment(date.date).format('DD.MM.YYYY.'),
                ticketPrice: this.helper.getTicketPriceBasedOnTotal(this.data.total, this.data.fleaMarketBooking.spots.length, this.data.fleaMarketBooking.booking_dates.length)
            });
        });
        this.bookedSpots = this.data.fleaMarketBooking.spots.map(s => s.name).toString();
        if (this.data.qr_image) {
            this.imgFile = this.sanitize.bypassSecurityTrustResourceUrl('data:image/png;base64,' + this.data.qr_image);
        }
        else if (this.data.qr_url) {
            this.helper.getBase64ImageFromUrl(this.data.qr_url)
                .then((result) => {
                this.imgFile = this.sanitize.bypassSecurityTrustResourceUrl(result);
            })
                .catch(err => console.error(err));
        }
        else {
            this.imgFile = null;
            this.imgLoaded = true;
            setTimeout(() => {
                this.printInvoice();
            }, 100);
        }
    }
    printInvoice() {
        try {
            this.imgLoaded = true;
            const div = document.getElementById('print-content');
            const mywindow = window.open('', '_blank');
            mywindow.document.write('<html><head><title>' + document.title + '</title><style>*{font-size:10px}body{width: 1.8in; font-family:Arial;} table{width:100%}</style>');
            mywindow.document.write('</head><body>');
            mywindow.document.write(div.innerHTML);
            mywindow.document.write('</body></html>');
            mywindow.document.close(); // necessary for IE >= 10
            mywindow.focus(); // necessary for IE >= 10*/
            mywindow.print();
            mywindow.close();
            // this.dialogRef.close();
        }
        catch (error) {
            console.log('Error has occured when trying to open a new tab: \n\n', error);
        }
    }
};
FleaInvoicePrintComponent.ctorParameters = () => [
    { type: _node_modules_angular_material__WEBPACK_IMPORTED_MODULE_3__["MatDialogRef"] },
    { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"], args: [_node_modules_angular_material__WEBPACK_IMPORTED_MODULE_3__["MAT_DIALOG_DATA"],] }] },
    { type: _services_helper_service__WEBPACK_IMPORTED_MODULE_4__["HelperService"] },
    { type: _angular_platform_browser__WEBPACK_IMPORTED_MODULE_5__["DomSanitizer"] }
];
FleaInvoicePrintComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-flea-invoice-print',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./flea-invoice-print.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/flea-invoice-print/flea-invoice-print.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./flea-invoice-print.component.scss */ "./src/app/components/flea-invoice-print/flea-invoice-print.component.scss")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__param"](1, Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"])(_node_modules_angular_material__WEBPACK_IMPORTED_MODULE_3__["MAT_DIALOG_DATA"])),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_node_modules_angular_material__WEBPACK_IMPORTED_MODULE_3__["MatDialogRef"], Object, _services_helper_service__WEBPACK_IMPORTED_MODULE_4__["HelperService"],
        _angular_platform_browser__WEBPACK_IMPORTED_MODULE_5__["DomSanitizer"]])
], FleaInvoicePrintComponent);



/***/ }),

/***/ "./src/app/components/kino-booking/kino-booking.component.scss":
/*!*********************************************************************!*\
  !*** ./src/app/components/kino-booking/kino-booking.component.scss ***!
  \*********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".wrapper {\n  margin: 2em auto;\n}\n.wrapper mat-form-field {\n  width: 100%;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9Vc2Vycy9jaHJpc3RvcGhlbmdlbG1heWVyL0NvZGUvZmxvaG1hcmt0L2F1dG9raW5vdjItZmUtYmUvYW5ndWxhci1mcm9udGVuZC9zcmMvYXBwL2NvbXBvbmVudHMva2luby1ib29raW5nL2tpbm8tYm9va2luZy5jb21wb25lbnQuc2NzcyIsInNyYy9hcHAvY29tcG9uZW50cy9raW5vLWJvb2tpbmcva2luby1ib29raW5nLmNvbXBvbmVudC5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBRUUsZ0JBQUE7QUNBRjtBREVFO0VBRUUsV0FBQTtBQ0RKIiwiZmlsZSI6InNyYy9hcHAvY29tcG9uZW50cy9raW5vLWJvb2tpbmcva2luby1ib29raW5nLmNvbXBvbmVudC5zY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLndyYXBwZXJcbntcbiAgbWFyZ2luOiAyZW0gYXV0bztcblxuICBtYXQtZm9ybS1maWVsZFxuICB7XG4gICAgd2lkdGg6IDEwMCU7XG4gIH1cbn1cbiIsIi53cmFwcGVyIHtcbiAgbWFyZ2luOiAyZW0gYXV0bztcbn1cbi53cmFwcGVyIG1hdC1mb3JtLWZpZWxkIHtcbiAgd2lkdGg6IDEwMCU7XG59Il19 */");

/***/ }),

/***/ "./src/app/components/kino-booking/kino-booking.component.ts":
/*!*******************************************************************!*\
  !*** ./src/app/components/kino-booking/kino-booking.component.ts ***!
  \*******************************************************************/
/*! exports provided: KinoBookingComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "KinoBookingComponent", function() { return KinoBookingComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! moment */ "./node_modules/moment/moment.js");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _services_kino_booking_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../services/kino-booking.service */ "./src/app/services/kino-booking.service.ts");
/* harmony import */ var _constants_statuses__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../constants/statuses */ "./src/app/constants/statuses.ts");
/* harmony import */ var _services_loading_service__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../services/loading.service */ "./src/app/services/loading.service.ts");
/* harmony import */ var _services_helper_service__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../services/helper.service */ "./src/app/services/helper.service.ts");
/* harmony import */ var _ngx_translate_core__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @ngx-translate/core */ "./node_modules/@ngx-translate/core/fesm2015/ngx-translate-core.js");
/* harmony import */ var _constants_price__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../constants/price */ "./src/app/constants/price.ts");
/* harmony import */ var _angular_material_dialog__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @angular/material/dialog */ "./node_modules/@angular/material/esm2015/dialog.js");
/* harmony import */ var _kino_inovice_print_kino_inovice_print_component__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../kino-inovice-print/kino-inovice-print.component */ "./src/app/components/kino-inovice-print/kino-inovice-print.component.ts");













let KinoBookingComponent = class KinoBookingComponent {
    constructor(location, fb, kinoBookingService, ls, helper, i18n, dialog) {
        this.location = location;
        this.fb = fb;
        this.kinoBookingService = kinoBookingService;
        this.ls = ls;
        this.helper = helper;
        this.i18n = i18n;
        this.dialog = dialog;
        moment__WEBPACK_IMPORTED_MODULE_3__["locale"]('de');
        this.createForm();
    }
    ngOnInit() {
    }
    ngOnDestroy() {
    }
    createForm() {
        this.form = this.fb.group({
            date: [moment__WEBPACK_IMPORTED_MODULE_3__(), _angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].required],
            unit_price: [_constants_price__WEBPACK_IMPORTED_MODULE_10__["Price"].KINO, _angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].required],
            tickets: [1, _angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].required]
        });
        this.calcTotal();
        this.form.controls.unit_price.valueChanges.subscribe((value) => {
            if (value < 0) {
                this.form.controls.unit_price.setValue(0);
            }
            this.calcTotal();
        });
        this.form.controls.tickets.valueChanges.subscribe((value) => {
            if (value < 1) {
                this.form.controls.tickets.setValue(1);
            }
            this.calcTotal();
        });
    }
    /**
     * Calculates the total price
     */
    calcTotal() {
        this.total = this.form.controls.unit_price.value * this.form.controls.tickets.value;
    }
    goBack() {
        this.location.back();
    }
    getControl(name) {
        return this.form.controls[name];
    }
    save() {
        this.ls.loading = true;
        this.kinoBookingService.createNewKinoBooking({
            booking_dates: [{ date: this.getControl('date').value.format('YYYY-MM-DD') }],
            amount: this.getControl('tickets').value,
            price: this.getControl('unit_price').value,
            status: _constants_statuses__WEBPACK_IMPORTED_MODULE_6__["STATUS_NOT_PAID"],
            discount: false
        }).subscribe(res_booking => {
            console.log('Booking response', res_booking);
            this.kinoBookingService.createKinoInvoice(res_booking.id, (res_booking.price * res_booking.amount)).subscribe(res_invoice => {
                this.ls.loading = false;
                console.log('Invoice response', res_invoice);
                const dialogRef = this.dialog.open(_kino_inovice_print_kino_inovice_print_component__WEBPACK_IMPORTED_MODULE_12__["KinoInovicePrintComponent"], { data: res_invoice, disableClose: true, autoFocus: false });
                dialogRef.afterClosed().subscribe(dialogResponse => {
                    this.helper.successNoti(this.i18n.instant('NOTI.booking_saved'));
                    this.location.back();
                });
            }, (err) => {
                this.ls.loading = false;
                console.log(err);
            });
        }, (err) => {
            this.ls.loading = false;
            console.log(err);
        });
    }
};
KinoBookingComponent.ctorParameters = () => [
    { type: _angular_common__WEBPACK_IMPORTED_MODULE_2__["Location"] },
    { type: _angular_forms__WEBPACK_IMPORTED_MODULE_4__["FormBuilder"] },
    { type: _services_kino_booking_service__WEBPACK_IMPORTED_MODULE_5__["KinoBookingService"] },
    { type: _services_loading_service__WEBPACK_IMPORTED_MODULE_7__["LoadingService"] },
    { type: _services_helper_service__WEBPACK_IMPORTED_MODULE_8__["HelperService"] },
    { type: _ngx_translate_core__WEBPACK_IMPORTED_MODULE_9__["TranslateService"] },
    { type: _angular_material_dialog__WEBPACK_IMPORTED_MODULE_11__["MatDialog"] }
];
KinoBookingComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-kino-booking',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./kino-booking.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/kino-booking/kino-booking.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./kino-booking.component.scss */ "./src/app/components/kino-booking/kino-booking.component.scss")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_common__WEBPACK_IMPORTED_MODULE_2__["Location"],
        _angular_forms__WEBPACK_IMPORTED_MODULE_4__["FormBuilder"],
        _services_kino_booking_service__WEBPACK_IMPORTED_MODULE_5__["KinoBookingService"],
        _services_loading_service__WEBPACK_IMPORTED_MODULE_7__["LoadingService"],
        _services_helper_service__WEBPACK_IMPORTED_MODULE_8__["HelperService"],
        _ngx_translate_core__WEBPACK_IMPORTED_MODULE_9__["TranslateService"],
        _angular_material_dialog__WEBPACK_IMPORTED_MODULE_11__["MatDialog"]])
], KinoBookingComponent);



/***/ }),

/***/ "./src/app/components/kino-inovice-print/kino-inovice-print.component.scss":
/*!*********************************************************************************!*\
  !*** ./src/app/components/kino-inovice-print/kino-inovice-print.component.scss ***!
  \*********************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("@media print {\n  button {\n    display: none;\n  }\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9Vc2Vycy9jaHJpc3RvcGhlbmdlbG1heWVyL0NvZGUvZmxvaG1hcmt0L2F1dG9raW5vdjItZmUtYmUvYW5ndWxhci1mcm9udGVuZC9zcmMvYXBwL2NvbXBvbmVudHMva2luby1pbm92aWNlLXByaW50L2tpbm8taW5vdmljZS1wcmludC5jb21wb25lbnQuc2NzcyIsInNyYy9hcHAvY29tcG9uZW50cy9raW5vLWlub3ZpY2UtcHJpbnQva2luby1pbm92aWNlLXByaW50LmNvbXBvbmVudC5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUNBO0VBRUU7SUFFRSxhQUFBO0VDRkY7QUFDRiIsImZpbGUiOiJzcmMvYXBwL2NvbXBvbmVudHMva2luby1pbm92aWNlLXByaW50L2tpbm8taW5vdmljZS1wcmludC5jb21wb25lbnQuc2NzcyIsInNvdXJjZXNDb250ZW50IjpbIlxuQG1lZGlhIHByaW50XG57XG4gIGJ1dHRvblxuICB7XG4gICAgZGlzcGxheTogbm9uZTtcbiAgfVxufVxuIiwiQG1lZGlhIHByaW50IHtcbiAgYnV0dG9uIHtcbiAgICBkaXNwbGF5OiBub25lO1xuICB9XG59Il19 */");

/***/ }),

/***/ "./src/app/components/kino-inovice-print/kino-inovice-print.component.ts":
/*!*******************************************************************************!*\
  !*** ./src/app/components/kino-inovice-print/kino-inovice-print.component.ts ***!
  \*******************************************************************************/
/*! exports provided: KinoInovicePrintComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "KinoInovicePrintComponent", function() { return KinoInovicePrintComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_material_dialog__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/material/dialog */ "./node_modules/@angular/material/esm2015/dialog.js");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! moment */ "./node_modules/moment/moment.js");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _services_helper_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../services/helper.service */ "./src/app/services/helper.service.ts");





let KinoInovicePrintComponent = class KinoInovicePrintComponent {
    constructor(dialogRef, data, helper) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.helper = helper;
        this.mymoment = moment__WEBPACK_IMPORTED_MODULE_3__;
        this.imgLoaded = false;
        this.mymoment().locale('de');
    }
    ngOnInit() {
        console.log('Data', this.data);
        if (this.data.qr_image) {
            this.imgFile = 'data:image/png;base64,' + this.data.qr_image;
        }
        else if (this.data.qr_url) {
            this.helper.getBase64ImageFromUrl(this.data.qr_url)
                .then(result => {
                this.imgFile = result;
            })
                .catch(err => console.error(err));
        }
        else {
            this.imgFile = null;
            this.imgLoaded = true;
            setTimeout(() => {
                this.printInvoice();
            }, 100);
        }
    }
    printInvoice() {
        try {
            this.imgLoaded = true;
            const div = document.getElementById('print-content');
            const mywindow = window.open('', '_blank');
            mywindow.document.write('<html><head><title>' + document.title + '</title><style>*{font-size:10px}body{width: 1.8in; font-family:Arial} table{width:100%}</style>');
            mywindow.document.write('</head><body>');
            mywindow.document.write(div.innerHTML);
            mywindow.document.write('</body></html>');
            mywindow.document.close(); // necessary for IE >= 10
            mywindow.focus(); // necessary for IE >= 10*/
            mywindow.print();
            mywindow.close();
            // this.dialogRef.close();
        }
        catch (error) {
            console.log('Error has occured when trying to open a new tab: \n\n', error);
        }
    }
};
KinoInovicePrintComponent.ctorParameters = () => [
    { type: _angular_material_dialog__WEBPACK_IMPORTED_MODULE_2__["MatDialogRef"] },
    { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"], args: [_angular_material_dialog__WEBPACK_IMPORTED_MODULE_2__["MAT_DIALOG_DATA"],] }] },
    { type: _services_helper_service__WEBPACK_IMPORTED_MODULE_4__["HelperService"] }
];
KinoInovicePrintComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-kino-inovice-print',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./kino-inovice-print.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/kino-inovice-print/kino-inovice-print.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./kino-inovice-print.component.scss */ "./src/app/components/kino-inovice-print/kino-inovice-print.component.scss")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__param"](1, Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"])(_angular_material_dialog__WEBPACK_IMPORTED_MODULE_2__["MAT_DIALOG_DATA"])),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_material_dialog__WEBPACK_IMPORTED_MODULE_2__["MatDialogRef"], Object, _services_helper_service__WEBPACK_IMPORTED_MODULE_4__["HelperService"]])
], KinoInovicePrintComponent);



/***/ }),

/***/ "./src/app/components/kino/kino.component.scss":
/*!*****************************************************!*\
  !*** ./src/app/components/kino/kino.component.scss ***!
  \*****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".wrapper {\n  margin: 16px auto;\n}\n.wrapper .filter-row {\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n}\n.wrapper .filter-row .date-filter {\n  width: 135px;\n}\n.wrapper .filter-row .status-filter {\n  width: 350px;\n}\n.wrapper .filter-row mat-form-field {\n  width: 100%;\n}\n.wrapper .table-wrapper table {\n  width: 100%;\n}\n.wrapper .table-wrapper table .paid-status {\n  display: block;\n  content: \" \";\n  width: 25px;\n  height: 25px;\n}\n.wrapper .table-wrapper table .paid {\n  background-color: green;\n}\n.wrapper .table-wrapper table .partially-paid {\n  background-color: orange;\n}\n.wrapper .table-wrapper table .not-paid {\n  background-color: red;\n}\n.wrapper .table-wrapper table .cancellation {\n  background-color: darkgray;\n}\n.wrapper .sum-report {\n  margin-top: 2em;\n}\n.wrapper .sum-report .sum-row {\n  display: flex;\n  justify-content: space-between;\n  margin: 8px 0;\n}\n.wrapper .sum-report .sum-actions {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  align-items: center;\n}\n.wrapper .sum-report .sum-actions button:not(:first-child) {\n  margin-left: 16px;\n}\n.wrapper .spiner {\n  display: flex;\n  justify-content: center;\n}\n@media print {\n  button {\n    display: none;\n  }\n\n  mat-form-field {\n    display: none;\n  }\n\n  mat-toolbar {\n    display: none;\n  }\n}\n/*# sourceMappingURL=data:application/json;base64,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 */");

/***/ }),

/***/ "./src/app/components/kino/kino.component.ts":
/*!***************************************************!*\
  !*** ./src/app/components/kino/kino.component.ts ***!
  \***************************************************/
/*! exports provided: KinoComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "KinoComponent", function() { return KinoComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _services_nav_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../services/nav.service */ "./src/app/services/nav.service.ts");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! moment */ "./node_modules/moment/moment.js");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _constants_statuses__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../constants/statuses */ "./src/app/constants/statuses.ts");
/* harmony import */ var _constants_origins__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../constants/origins */ "./src/app/constants/origins.ts");
/* harmony import */ var _angular_material_dialog__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @angular/material/dialog */ "./node_modules/@angular/material/esm2015/dialog.js");
/* harmony import */ var _angular_material_sort__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @angular/material/sort */ "./node_modules/@angular/material/esm2015/sort.js");
/* harmony import */ var _angular_material_table__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @angular/material/table */ "./node_modules/@angular/material/esm2015/table.js");
/* harmony import */ var _services_kino_booking_service__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../services/kino-booking.service */ "./src/app/services/kino-booking.service.ts");
/* harmony import */ var _services_download_file_service__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../services/download-file.service */ "./src/app/services/download-file.service.ts");
/* harmony import */ var _services_helper_service__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../services/helper.service */ "./src/app/services/helper.service.ts");
/* harmony import */ var _ngx_translate_core__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @ngx-translate/core */ "./node_modules/@ngx-translate/core/fesm2015/ngx-translate-core.js");
/* harmony import */ var _kino_inovice_print_kino_inovice_print_component__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../kino-inovice-print/kino-inovice-print.component */ "./src/app/components/kino-inovice-print/kino-inovice-print.component.ts");















let KinoComponent = class KinoComponent {
    constructor(nav, kinoService, downloadService, helper, i18n, dialog) {
        this.nav = nav;
        this.kinoService = kinoService;
        this.downloadService = downloadService;
        this.helper = helper;
        this.i18n = i18n;
        this.dialog = dialog;
        this.loading = false;
        this.stornoLoadingID = [];
        this.invoiceLoadingID = [];
        // Only keep "paid" and "cancel" options
        this.statuses = _constants_statuses__WEBPACK_IMPORTED_MODULE_5__["STATUSES"].filter(s => s.id === _constants_statuses__WEBPACK_IMPORTED_MODULE_5__["STATUS_PAID"] || s.id === _constants_statuses__WEBPACK_IMPORTED_MODULE_5__["STATUS_STORNO"]);
        this.origins = _constants_origins__WEBPACK_IMPORTED_MODULE_6__["ORIGINS"].filter(o => o.id === 0 || o.id === 2); // Only keep "all" and "local" options
        // Table
        this.dataSource = new _angular_material_table__WEBPACK_IMPORTED_MODULE_9__["MatTableDataSource"]();
        this.displayedColumns = ['id', 'date', 'status', 'total', 'amount', 'edit'];
        this.tableData = [];
        moment__WEBPACK_IMPORTED_MODULE_4__["locale"]('de');
    }
    ngOnInit() {
        this.createFormControls();
    }
    ngOnDestroy() {
        this.helper.clearNotifications();
    }
    createFormControls() {
        this.date_from_Control = new _angular_forms__WEBPACK_IMPORTED_MODULE_3__["FormControl"](moment__WEBPACK_IMPORTED_MODULE_4__().startOf('week'));
        this.date_to_Control = new _angular_forms__WEBPACK_IMPORTED_MODULE_3__["FormControl"](moment__WEBPACK_IMPORTED_MODULE_4__().endOf('week'));
        this.status_Control = new _angular_forms__WEBPACK_IMPORTED_MODULE_3__["FormControl"]([-1], [_angular_forms__WEBPACK_IMPORTED_MODULE_3__["Validators"].required]);
        this.origin_Control = new _angular_forms__WEBPACK_IMPORTED_MODULE_3__["FormControl"](this.origins[0].id, [_angular_forms__WEBPACK_IMPORTED_MODULE_3__["Validators"].required]);
        this.getData();
    }
    /**
     * Resets the filters
     */
    resetFilters() {
        this.createFormControls();
    }
    fillSource() {
        this.dataSource.data = this.tableData;
    }
    getData() {
        this.loading = true;
        this.kinoService.getTableData(this.date_from_Control.value.format('YYYY-MM-DD'), this.date_to_Control.value.format('YYYY-MM-DD'))
            .subscribe((res) => {
            console.log('Kino table:', res);
            this.data = res;
            this.tableData = res.data;
            this.fillSource();
            this.loading = false;
            setTimeout(() => {
                this.dataSource.sort = this.sort;
            }, 0);
        }, (err) => {
            this.helper.infoNoti(this.i18n.instant('NOTI.no_booking_in_date_range'));
            this.tableData = [];
            this.fillSource();
            this.loading = false;
            console.log(err);
        });
    }
    /**
     * Results filter for table
     */
    filterResults() {
        let selectedValue = this.status_Control.value;
        if (selectedValue.length >= 1) {
            if (selectedValue.includes(-1)) {
                // If All is selected, filter it out
                this.status_Control.setValue(selectedValue.filter(x => x !== -1));
                selectedValue = this.status_Control.value;
            }
            console.log('Selected', selectedValue);
            console.log('Table data:', this.tableData);
            this.dataSource.data = this.tableData.filter(row => selectedValue.includes(row.status));
        }
        else if (selectedValue.length < 1 && !selectedValue.includes(-1)) {
            this.status_Control.setValue([-1]);
            this.dataSource.data = this.tableData;
        }
    }
    resetStatusSelection() {
        this.status_Control.setValue([-1]);
        this.dataSource.data = this.tableData;
    }
    pdf() {
        this.kinoService.getPDF(this.date_from_Control.value.format('YYYY-MM-DD'), this.date_to_Control.value.format('YYYY-MM-DD'))
            .subscribe((res) => {
            const title = 'Kino report ' + this.date_from_Control.value.format('YYYY-MM-DD') + ' ' + this.date_to_Control.value.format('YYYY-MM-DD');
            this.downloadService.download(res, title, '.pdf');
        }, (err) => {
            console.log(err);
        });
    }
    excel() {
        this.kinoService.getExcel(this.date_from_Control.value.format('YYYY-MM-DD'), this.date_to_Control.value.format('YYYY-MM-DD'))
            .subscribe((res) => {
            const title = 'Kino report ' + this.date_from_Control.value.format('YYYY-MM-DD') + ' ' + this.date_to_Control.value.format('YYYY-MM-DD');
            this.downloadService.download(res, title, '.xlsx');
        }, (err) => {
            console.log(err);
        });
    }
    /**
     * print table with printer
     */
    print() {
        window.print();
    }
    /**
     * Create a new new invoice for Kino Booking
     */
    printReceipt(row) {
        this.invoiceLoadingID.push(row.id);
        if (row.status === _constants_statuses__WEBPACK_IMPORTED_MODULE_5__["STATUS_PAID"] || row.status === _constants_statuses__WEBPACK_IMPORTED_MODULE_5__["STATUS_STORNO"]) {
            this.kinoService.getKinoInvoice(row.invoice[0]).subscribe(res => {
                const dialogRef = this.dialog.open(_kino_inovice_print_kino_inovice_print_component__WEBPACK_IMPORTED_MODULE_14__["KinoInovicePrintComponent"], { data: res, disableClose: true, autoFocus: false });
                dialogRef.afterClosed().subscribe(dialogResponse => {
                    this.invoiceLoadingID = this.invoiceLoadingID.filter(x => x !== row.id);
                });
            });
        }
        else {
            this.kinoService.createKinoInvoice(row.id, row.total).subscribe(res => {
                const dialogRef = this.dialog.open(_kino_inovice_print_kino_inovice_print_component__WEBPACK_IMPORTED_MODULE_14__["KinoInovicePrintComponent"], { data: res, disableClose: true, autoFocus: false });
                dialogRef.afterClosed().subscribe(dialogResponse => {
                    this.invoiceLoadingID = this.invoiceLoadingID.filter(x => x !== row.id);
                    console.log('Invoice res', res);
                    this.getData();
                });
            });
        }
    }
    /**
     * Storno a Kino Booking and create storno invoice
     */
    storno(row) {
        this.stornoLoadingID.push(row.id);
        this.kinoService.stornoKinoBooking(row.id).subscribe(res => {
            const dialogRef = this.dialog.open(_kino_inovice_print_kino_inovice_print_component__WEBPACK_IMPORTED_MODULE_14__["KinoInovicePrintComponent"], { data: res, disableClose: true, autoFocus: false });
            dialogRef.afterClosed().subscribe(dialogResponse => {
                this.stornoLoadingID = this.stornoLoadingID.filter(x => x !== row.id);
                console.log('Storno res', res);
                this.getData();
            });
        });
    }
    getStatusColor(element) {
        const found = _constants_statuses__WEBPACK_IMPORTED_MODULE_5__["STATUSES"].find(x => x.id === element.status);
        return found ? found.color : '';
    }
    getStatusTooltip(element) {
        const found = _constants_statuses__WEBPACK_IMPORTED_MODULE_5__["STATUSES"].find(x => x.id === element.status);
        return found ? found.name : '';
    }
};
KinoComponent.ctorParameters = () => [
    { type: _services_nav_service__WEBPACK_IMPORTED_MODULE_2__["NavService"] },
    { type: _services_kino_booking_service__WEBPACK_IMPORTED_MODULE_10__["KinoBookingService"] },
    { type: _services_download_file_service__WEBPACK_IMPORTED_MODULE_11__["DownloadFileService"] },
    { type: _services_helper_service__WEBPACK_IMPORTED_MODULE_12__["HelperService"] },
    { type: _ngx_translate_core__WEBPACK_IMPORTED_MODULE_13__["TranslateService"] },
    { type: _angular_material_dialog__WEBPACK_IMPORTED_MODULE_7__["MatDialog"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"])(_angular_material_sort__WEBPACK_IMPORTED_MODULE_8__["MatSort"], { static: false }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", _angular_material_sort__WEBPACK_IMPORTED_MODULE_8__["MatSort"])
], KinoComponent.prototype, "sort", void 0);
KinoComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-kino',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./kino.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/kino/kino.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./kino.component.scss */ "./src/app/components/kino/kino.component.scss")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_services_nav_service__WEBPACK_IMPORTED_MODULE_2__["NavService"],
        _services_kino_booking_service__WEBPACK_IMPORTED_MODULE_10__["KinoBookingService"],
        _services_download_file_service__WEBPACK_IMPORTED_MODULE_11__["DownloadFileService"],
        _services_helper_service__WEBPACK_IMPORTED_MODULE_12__["HelperService"],
        _ngx_translate_core__WEBPACK_IMPORTED_MODULE_13__["TranslateService"],
        _angular_material_dialog__WEBPACK_IMPORTED_MODULE_7__["MatDialog"]])
], KinoComponent);



/***/ }),

/***/ "./src/app/components/login/login.component.scss":
/*!*******************************************************!*\
  !*** ./src/app/components/login/login.component.scss ***!
  \*******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (":host .wrapper {\n  position: absolute;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  align-items: center;\n  justify-content: center;\n}\n:host .wrapper .card {\n  max-width: 300px;\n  width: 100%;\n  margin: 0 auto;\n}\n:host .wrapper .card mat-form-field {\n  width: 100%;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9Vc2Vycy9jaHJpc3RvcGhlbmdlbG1heWVyL0NvZGUvZmxvaG1hcmt0L2F1dG9raW5vdjItZmUtYmUvYW5ndWxhci1mcm9udGVuZC9zcmMvYXBwL2NvbXBvbmVudHMvbG9naW4vbG9naW4uY29tcG9uZW50LnNjc3MiLCJzcmMvYXBwL2NvbXBvbmVudHMvbG9naW4vbG9naW4uY29tcG9uZW50LnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBSUU7RUFFRSxrQkFBQTtFQUNBLGFBQUE7RUFDQSxzQkFBQTtFQUNBLFdBQUE7RUFDQSxZQUFBO0VBQ0EsbUJBQUE7RUFDQSx1QkFBQTtBQ0pKO0FETUk7RUFFRSxnQkFBQTtFQUNBLFdBQUE7RUFDQSxjQUFBO0FDTE47QURPTTtFQUVFLFdBQUE7QUNOUiIsImZpbGUiOiJzcmMvYXBwL2NvbXBvbmVudHMvbG9naW4vbG9naW4uY29tcG9uZW50LnNjc3MiLCJzb3VyY2VzQ29udGVudCI6WyJAaW1wb3J0IFwic3JjL2JyZWFrcG9pbnRzLnNjc3NcIjtcblxuOmhvc3RcbntcbiAgLndyYXBwZXJcbiAge1xuICAgIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgICBkaXNwbGF5OiBmbGV4O1xuICAgIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG4gICAgd2lkdGg6IDEwMCU7XG4gICAgaGVpZ2h0OiAxMDAlO1xuICAgIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gICAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7XG5cbiAgICAuY2FyZFxuICAgIHtcbiAgICAgIG1heC13aWR0aDogMzAwcHg7XG4gICAgICB3aWR0aDogMTAwJTtcbiAgICAgIG1hcmdpbjogMCBhdXRvO1xuXG4gICAgICBtYXQtZm9ybS1maWVsZFxuICAgICAge1xuICAgICAgICB3aWR0aDogMTAwJTtcbiAgICAgIH1cbiAgICB9XG4gIH1cbn1cbiIsIjpob3N0IC53cmFwcGVyIHtcbiAgcG9zaXRpb246IGFic29sdXRlO1xuICBkaXNwbGF5OiBmbGV4O1xuICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICB3aWR0aDogMTAwJTtcbiAgaGVpZ2h0OiAxMDAlO1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcbn1cbjpob3N0IC53cmFwcGVyIC5jYXJkIHtcbiAgbWF4LXdpZHRoOiAzMDBweDtcbiAgd2lkdGg6IDEwMCU7XG4gIG1hcmdpbjogMCBhdXRvO1xufVxuOmhvc3QgLndyYXBwZXIgLmNhcmQgbWF0LWZvcm0tZmllbGQge1xuICB3aWR0aDogMTAwJTtcbn0iXX0= */");

/***/ }),

/***/ "./src/app/components/login/login.component.ts":
/*!*****************************************************!*\
  !*** ./src/app/components/login/login.component.ts ***!
  \*****************************************************/
/*! exports provided: LoginComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LoginComponent", function() { return LoginComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _services_auth_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../services/auth.service */ "./src/app/services/auth.service.ts");
/* harmony import */ var _guards_auth_guard__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../guards/auth.guard */ "./src/app/guards/auth.guard.ts");
/* harmony import */ var _services_helper_service__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../services/helper.service */ "./src/app/services/helper.service.ts");







let LoginComponent = class LoginComponent {
    constructor(fb, router, auth, authGuard, helper) {
        this.fb = fb;
        this.router = router;
        this.auth = auth;
        this.authGuard = authGuard;
        this.helper = helper;
        this.loading = false;
        if (auth.isLoggedIn()) {
            this.router.navigate(['/schedule']);
        }
    }
    ngOnInit() {
        if (this.authGuard.redirectURL) {
            this.previousURL = this.authGuard.redirectURL;
            this.authGuard.redirectURL = undefined;
        }
        this.createForm();
        if (window.location.hostname === 'localhost') {
            setTimeout(() => {
                this.auth.setData({ username: 'admin' });
                this.router.navigate([this.previousURL ? this.previousURL : '/schedule']);
            }, 0);
        }
    }
    ngOnDestroy() {
        this.helper.clearNotifications();
    }
    createForm() {
        this.form = this.fb.group({
            username: ['', _angular_forms__WEBPACK_IMPORTED_MODULE_2__["Validators"].required],
            password: ['', _angular_forms__WEBPACK_IMPORTED_MODULE_2__["Validators"].required]
        });
    }
    login() {
        if (this.form.invalid || this.loading) {
            return;
        }
        this.loading = true;
        this.auth.login(this.form.controls.username.value, this.form.controls.password.value).subscribe(res => {
            console.log('Login res', res);
            this.auth.setData({ username: this.form.controls.username.value });
            this.loading = false;
            if (this.previousURL) {
                this.router.navigate([this.previousURL]);
            }
            else {
                this.router.navigate(['/schedule']);
            }
        }, err => {
            this.loading = false;
            console.log('Login error', err);
            this.helper.warningNoti(err.error.message);
        });
    }
};
LoginComponent.ctorParameters = () => [
    { type: _angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormBuilder"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_3__["Router"] },
    { type: _services_auth_service__WEBPACK_IMPORTED_MODULE_4__["AuthService"] },
    { type: _guards_auth_guard__WEBPACK_IMPORTED_MODULE_5__["AuthGuard"] },
    { type: _services_helper_service__WEBPACK_IMPORTED_MODULE_6__["HelperService"] }
];
LoginComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-login',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./login.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/login/login.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./login.component.scss */ "./src/app/components/login/login.component.scss")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormBuilder"],
        _angular_router__WEBPACK_IMPORTED_MODULE_3__["Router"],
        _services_auth_service__WEBPACK_IMPORTED_MODULE_4__["AuthService"],
        _guards_auth_guard__WEBPACK_IMPORTED_MODULE_5__["AuthGuard"],
        _services_helper_service__WEBPACK_IMPORTED_MODULE_6__["HelperService"]])
], LoginComponent);



/***/ }),

/***/ "./src/app/components/price-adjust/price-adjust.component.scss":
/*!*********************************************************************!*\
  !*** ./src/app/components/price-adjust/price-adjust.component.scss ***!
  \*********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".wrapper {\n  padding: 32px;\n}\n.wrapper .grid {\n  display: grid;\n  grid-template-columns: 2fr 1fr;\n  grid-column-gap: 16px;\n  grid-row-gap: 4px;\n  align-items: center;\n  max-width: 500px;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9Vc2Vycy9jaHJpc3RvcGhlbmdlbG1heWVyL0NvZGUvZmxvaG1hcmt0L2F1dG9raW5vdjItZmUtYmUvYW5ndWxhci1mcm9udGVuZC9zcmMvYXBwL2NvbXBvbmVudHMvcHJpY2UtYWRqdXN0L3ByaWNlLWFkanVzdC5jb21wb25lbnQuc2NzcyIsInNyYy9hcHAvY29tcG9uZW50cy9wcmljZS1hZGp1c3QvcHJpY2UtYWRqdXN0LmNvbXBvbmVudC5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBRUUsYUFBQTtBQ0FGO0FERUU7RUFFRSxhQUFBO0VBQ0EsOEJBQUE7RUFDQSxxQkFBQTtFQUNBLGlCQUFBO0VBQ0EsbUJBQUE7RUFDQSxnQkFBQTtBQ0RKIiwiZmlsZSI6InNyYy9hcHAvY29tcG9uZW50cy9wcmljZS1hZGp1c3QvcHJpY2UtYWRqdXN0LmNvbXBvbmVudC5zY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLndyYXBwZXJcbntcbiAgcGFkZGluZzogMzJweDtcblxuICAuZ3JpZFxuICB7XG4gICAgZGlzcGxheTogZ3JpZDtcbiAgICBncmlkLXRlbXBsYXRlLWNvbHVtbnM6IDJmciAxZnI7XG4gICAgZ3JpZC1jb2x1bW4tZ2FwOiAxNnB4O1xuICAgIGdyaWQtcm93LWdhcDogNHB4O1xuICAgIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gICAgbWF4LXdpZHRoOiA1MDBweDtcbiAgfVxufVxuIiwiLndyYXBwZXIge1xuICBwYWRkaW5nOiAzMnB4O1xufVxuLndyYXBwZXIgLmdyaWQge1xuICBkaXNwbGF5OiBncmlkO1xuICBncmlkLXRlbXBsYXRlLWNvbHVtbnM6IDJmciAxZnI7XG4gIGdyaWQtY29sdW1uLWdhcDogMTZweDtcbiAgZ3JpZC1yb3ctZ2FwOiA0cHg7XG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gIG1heC13aWR0aDogNTAwcHg7XG59Il19 */");

/***/ }),

/***/ "./src/app/components/price-adjust/price-adjust.component.ts":
/*!*******************************************************************!*\
  !*** ./src/app/components/price-adjust/price-adjust.component.ts ***!
  \*******************************************************************/
/*! exports provided: PriceAdjustComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PriceAdjustComponent", function() { return PriceAdjustComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _services_nav_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../services/nav.service */ "./src/app/services/nav.service.ts");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _constants_price__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../constants/price */ "./src/app/constants/price.ts");
/* harmony import */ var _services_price_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../services/price.service */ "./src/app/services/price.service.ts");
/* harmony import */ var _services_helper_service__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../services/helper.service */ "./src/app/services/helper.service.ts");
/* harmony import */ var _ngx_translate_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @ngx-translate/core */ "./node_modules/@ngx-translate/core/fesm2015/ngx-translate-core.js");








let PriceAdjustComponent = class PriceAdjustComponent {
    constructor(nav, fb, priceService, helper, i18n) {
        this.nav = nav;
        this.fb = fb;
        this.priceService = priceService;
        this.helper = helper;
        this.i18n = i18n;
        this.loading = false;
        this.prices = [];
    }
    ngOnInit() {
        this.loading = true;
        this.priceService.getPrices().subscribe(res => {
            console.log('Prices', res);
            this.priceService.setPrices(res);
            this.prices = res;
            this.createForm();
            this.loading = false;
        }, err => {
            console.log('Error getting prices', err);
            this.helper.errorNoti(this.i18n.instant('ERR.error_getting_prices'));
        });
    }
    createForm() {
        const regex = new RegExp(/^[1-9][0-9]*$/);
        this.form = this.fb.group({
            flea_market_ticket_price: [_constants_price__WEBPACK_IMPORTED_MODULE_4__["Price"].FLEA, _angular_forms__WEBPACK_IMPORTED_MODULE_3__["Validators"].compose([_angular_forms__WEBPACK_IMPORTED_MODULE_3__["Validators"].required, _angular_forms__WEBPACK_IMPORTED_MODULE_3__["Validators"].pattern(regex)])],
            flea_market_discount_ticket_price: [_constants_price__WEBPACK_IMPORTED_MODULE_4__["Price"].FLEA_DISCOUNT, _angular_forms__WEBPACK_IMPORTED_MODULE_3__["Validators"].compose([_angular_forms__WEBPACK_IMPORTED_MODULE_3__["Validators"].required, _angular_forms__WEBPACK_IMPORTED_MODULE_3__["Validators"].pattern(regex)])],
            car_market_ticket_price: [_constants_price__WEBPACK_IMPORTED_MODULE_4__["Price"].CAR, _angular_forms__WEBPACK_IMPORTED_MODULE_3__["Validators"].compose([_angular_forms__WEBPACK_IMPORTED_MODULE_3__["Validators"].required, _angular_forms__WEBPACK_IMPORTED_MODULE_3__["Validators"].pattern(regex)])],
            car_market_discount_ticket_price: [_constants_price__WEBPACK_IMPORTED_MODULE_4__["Price"].CAR_DISCOUNT, _angular_forms__WEBPACK_IMPORTED_MODULE_3__["Validators"].compose([_angular_forms__WEBPACK_IMPORTED_MODULE_3__["Validators"].required, _angular_forms__WEBPACK_IMPORTED_MODULE_3__["Validators"].pattern(regex)])]
        });
    }
    getControl(field) {
        return this.form.controls[field];
    }
    savePrice() {
        if (this.form.invalid) {
            return;
        }
        const price_model = [
            {
                id: this.prices.find(p => p.type === 'flea').id || 4,
                type: 'flea',
                price: this.getControl('flea_market_ticket_price').value,
                discount_price: this.getControl('flea_market_discount_ticket_price').value
            },
            {
                id: this.prices.find(p => p.type === 'car').id || 5,
                type: 'car',
                price: this.getControl('car_market_ticket_price').value,
                discount_price: this.getControl('car_market_discount_ticket_price').value
            },
            {
                id: this.prices.find(p => p.type === 'kino').id || 6,
                type: 'kino',
                price: _constants_price__WEBPACK_IMPORTED_MODULE_4__["Price"].KINO,
                discount_price: _constants_price__WEBPACK_IMPORTED_MODULE_4__["Price"].KINO_DISCOUNT
            }
        ];
        console.log('Price model: ', price_model);
        this.priceService.changePrices(price_model).subscribe(res => {
            console.log('Change price: ', res);
            this.priceService.setPrices(price_model);
            this.helper.successNoti(this.i18n.instant('NOTI.prices_changed'));
        }, err => {
            console.log('Error changing prices', err);
            this.helper.errorNoti(this.i18n.instant('ERR.error_changing_prices'));
        });
    }
};
PriceAdjustComponent.ctorParameters = () => [
    { type: _services_nav_service__WEBPACK_IMPORTED_MODULE_2__["NavService"] },
    { type: _angular_forms__WEBPACK_IMPORTED_MODULE_3__["FormBuilder"] },
    { type: _services_price_service__WEBPACK_IMPORTED_MODULE_5__["PriceService"] },
    { type: _services_helper_service__WEBPACK_IMPORTED_MODULE_6__["HelperService"] },
    { type: _ngx_translate_core__WEBPACK_IMPORTED_MODULE_7__["TranslateService"] }
];
PriceAdjustComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-price-adjust',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./price-adjust.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/price-adjust/price-adjust.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./price-adjust.component.scss */ "./src/app/components/price-adjust/price-adjust.component.scss")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_services_nav_service__WEBPACK_IMPORTED_MODULE_2__["NavService"],
        _angular_forms__WEBPACK_IMPORTED_MODULE_3__["FormBuilder"],
        _services_price_service__WEBPACK_IMPORTED_MODULE_5__["PriceService"],
        _services_helper_service__WEBPACK_IMPORTED_MODULE_6__["HelperService"],
        _ngx_translate_core__WEBPACK_IMPORTED_MODULE_7__["TranslateService"]])
], PriceAdjustComponent);



/***/ }),

/***/ "./src/app/components/schedule-view/booking-details-dialog/booking-details-dialog.component.scss":
/*!*******************************************************************************************************!*\
  !*** ./src/app/components/schedule-view/booking-details-dialog/booking-details-dialog.component.scss ***!
  \*******************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".options {\n  display: grid;\n  grid-template-columns: 1fr 3fr;\n  grid-column-gap: 16px;\n  align-items: start;\n  margin: 16px 0;\n}\n.options .actions {\n  display: grid;\n  grid-row-gap: 16px;\n  grid-template-columns: 1fr;\n}\nmat-form-field {\n  width: 100%;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9Vc2Vycy9jaHJpc3RvcGhlbmdlbG1heWVyL0NvZGUvZmxvaG1hcmt0L2F1dG9raW5vdjItZmUtYmUvYW5ndWxhci1mcm9udGVuZC9zcmMvYXBwL2NvbXBvbmVudHMvc2NoZWR1bGUtdmlldy9ib29raW5nLWRldGFpbHMtZGlhbG9nL2Jvb2tpbmctZGV0YWlscy1kaWFsb2cuY29tcG9uZW50LnNjc3MiLCJzcmMvYXBwL2NvbXBvbmVudHMvc2NoZWR1bGUtdmlldy9ib29raW5nLWRldGFpbHMtZGlhbG9nL2Jvb2tpbmctZGV0YWlscy1kaWFsb2cuY29tcG9uZW50LnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFFRSxhQUFBO0VBQ0EsOEJBQUE7RUFDQSxxQkFBQTtFQUNBLGtCQUFBO0VBQ0EsY0FBQTtBQ0FGO0FERUU7RUFFRSxhQUFBO0VBQ0Esa0JBQUE7RUFDQSwwQkFBQTtBQ0RKO0FES0E7RUFFRSxXQUFBO0FDSEYiLCJmaWxlIjoic3JjL2FwcC9jb21wb25lbnRzL3NjaGVkdWxlLXZpZXcvYm9va2luZy1kZXRhaWxzLWRpYWxvZy9ib29raW5nLWRldGFpbHMtZGlhbG9nLmNvbXBvbmVudC5zY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLm9wdGlvbnNcbntcbiAgZGlzcGxheTogZ3JpZDtcbiAgZ3JpZC10ZW1wbGF0ZS1jb2x1bW5zOiAxZnIgM2ZyO1xuICBncmlkLWNvbHVtbi1nYXA6IDE2cHg7XG4gIGFsaWduLWl0ZW1zOiBzdGFydDtcbiAgbWFyZ2luOiAxNnB4IDA7XG5cbiAgLmFjdGlvbnNcbiAge1xuICAgIGRpc3BsYXk6IGdyaWQ7XG4gICAgZ3JpZC1yb3ctZ2FwOiAxNnB4O1xuICAgIGdyaWQtdGVtcGxhdGUtY29sdW1uczogMWZyO1xuICB9XG59XG5cbm1hdC1mb3JtLWZpZWxkXG57XG4gIHdpZHRoOiAxMDAlO1xufVxuIiwiLm9wdGlvbnMge1xuICBkaXNwbGF5OiBncmlkO1xuICBncmlkLXRlbXBsYXRlLWNvbHVtbnM6IDFmciAzZnI7XG4gIGdyaWQtY29sdW1uLWdhcDogMTZweDtcbiAgYWxpZ24taXRlbXM6IHN0YXJ0O1xuICBtYXJnaW46IDE2cHggMDtcbn1cbi5vcHRpb25zIC5hY3Rpb25zIHtcbiAgZGlzcGxheTogZ3JpZDtcbiAgZ3JpZC1yb3ctZ2FwOiAxNnB4O1xuICBncmlkLXRlbXBsYXRlLWNvbHVtbnM6IDFmcjtcbn1cblxubWF0LWZvcm0tZmllbGQge1xuICB3aWR0aDogMTAwJTtcbn0iXX0= */");

/***/ }),

/***/ "./src/app/components/schedule-view/booking-details-dialog/booking-details-dialog.component.ts":
/*!*****************************************************************************************************!*\
  !*** ./src/app/components/schedule-view/booking-details-dialog/booking-details-dialog.component.ts ***!
  \*****************************************************************************************************/
/*! exports provided: BookingDetailsDialogComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BookingDetailsDialogComponent", function() { return BookingDetailsDialogComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _node_modules_angular_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../../node_modules/@angular/material */ "./node_modules/@angular/material/esm2015/material.js");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! moment */ "./node_modules/moment/moment.js");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _services_flea_market_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../services/flea-market.service */ "./src/app/services/flea-market.service.ts");
/* harmony import */ var _services_helper_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../services/helper.service */ "./src/app/services/helper.service.ts");
/* harmony import */ var _ngx_translate_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @ngx-translate/core */ "./node_modules/@ngx-translate/core/fesm2015/ngx-translate-core.js");







let BookingDetailsDialogComponent = class BookingDetailsDialogComponent {
    constructor(dialogRef, data, fleaMarket, helper, i18n) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.fleaMarket = fleaMarket;
        this.helper = helper;
        this.i18n = i18n;
        this.note = '';
        moment__WEBPACK_IMPORTED_MODULE_3__().locale('de');
    }
    ngOnInit() {
        console.log('Booking data', this.data);
        this.currentSpots = this.data.spots.map(s => s.name);
        this.currentDates = this.data.booking_dates.map(date => moment__WEBPACK_IMPORTED_MODULE_3__(date.date).format('DD.MM.YYYY.'));
        this.note = this.data.note;
    }
    printPlaceNumber() {
        const mywindow = window.open('', '_blank');
        mywindow.document.write('<html><head><title>' + document.title + '</title><style>*{font-size:22px;font-family:Arial}</style>');
        mywindow.document.write('</head><body>');
        mywindow.document.write('<p>Platznummer(n):</p>');
        mywindow.document.write(this.data.spots.map(x => x.name).toString());
        mywindow.document.write('<br>');
        mywindow.document.write('<p>Datum:</p>');
        this.data.booking_dates.forEach(date => {
            mywindow.document.write(`${moment__WEBPACK_IMPORTED_MODULE_3__(date.date).format('DD.MM.YYYY')}<br>`);
        });
        mywindow.document.write('</body></html>');
        mywindow.document.close(); // necessary for IE >= 10
        mywindow.focus(); // necessary for IE >= 10*/
        mywindow.print();
        mywindow.close();
    }
    saveNotes() {
        const booking = this.data;
        booking.note = this.note;
        this.fleaMarket.updateFleaMarketBooking(booking).subscribe(res => {
            console.log('Booking res', res);
            this.helper.successNoti(this.i18n.instant('NOTI.note_saved'));
        }, err => console.log('Booking error', err));
    }
};
BookingDetailsDialogComponent.ctorParameters = () => [
    { type: _node_modules_angular_material__WEBPACK_IMPORTED_MODULE_2__["MatDialogRef"] },
    { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"], args: [_node_modules_angular_material__WEBPACK_IMPORTED_MODULE_2__["MAT_DIALOG_DATA"],] }] },
    { type: _services_flea_market_service__WEBPACK_IMPORTED_MODULE_4__["FleaMarketService"] },
    { type: _services_helper_service__WEBPACK_IMPORTED_MODULE_5__["HelperService"] },
    { type: _ngx_translate_core__WEBPACK_IMPORTED_MODULE_6__["TranslateService"] }
];
BookingDetailsDialogComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-booking-details-dialog',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./booking-details-dialog.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/schedule-view/booking-details-dialog/booking-details-dialog.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./booking-details-dialog.component.scss */ "./src/app/components/schedule-view/booking-details-dialog/booking-details-dialog.component.scss")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__param"](1, Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"])(_node_modules_angular_material__WEBPACK_IMPORTED_MODULE_2__["MAT_DIALOG_DATA"])),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_node_modules_angular_material__WEBPACK_IMPORTED_MODULE_2__["MatDialogRef"], Object, _services_flea_market_service__WEBPACK_IMPORTED_MODULE_4__["FleaMarketService"],
        _services_helper_service__WEBPACK_IMPORTED_MODULE_5__["HelperService"],
        _ngx_translate_core__WEBPACK_IMPORTED_MODULE_6__["TranslateService"]])
], BookingDetailsDialogComponent);



/***/ }),

/***/ "./src/app/components/schedule-view/booking-details/booking-details.component.scss":
/*!*****************************************************************************************!*\
  !*** ./src/app/components/schedule-view/booking-details/booking-details.component.scss ***!
  \*****************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".wrapper {\n  margin: 2em auto;\n}\n.wrapper mat-form-field {\n  width: 100%;\n}\n.wrapper .action-stack div.date-action {\n  margin: 8px 0;\n}\n.wrapper .action-stack div.date-action button {\n  width: 100%;\n}\n.wrapper .discount {\n  margin: 16px 0;\n}\n.wrapper .discount .discount-radio-group {\n  display: inline-flex;\n  flex-direction: column;\n}\n.wrapper .discount .discount-radio-group .discount-button {\n  margin: 8px;\n}\n.wrapper .status-boxes {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  grid-column-gap: 16px;\n  margin-bottom: 32px;\n}\n.wrapper .status-boxes .box {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  border: 2px solid #ddd;\n  background-color: white;\n  padding: 10px;\n}\n.wrapper .status-boxes .box span {\n  text-align: center;\n}\n.wrapper .status-boxes .box span:nth-child(2) {\n  margin: 16px 0;\n  font-size: 2em;\n}\n.wrapper .status-boxes .box .status {\n  width: 50px;\n  height: 50px;\n}\n.wrapper .section-title {\n  font-weight: 500;\n  margin: 8px 0;\n}\n.wrapper .action-buttons {\n  min-width: 0;\n  margin: 0 3px;\n}\n.wrapper .save-button {\n  text-align: center;\n}\n.group-option {\n  color: grey;\n  font-weight: bold;\n}\n/*# sourceMappingURL=data:application/json;base64,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 */");

/***/ }),

/***/ "./src/app/components/schedule-view/booking-details/booking-details.component.ts":
/*!***************************************************************************************!*\
  !*** ./src/app/components/schedule-view/booking-details/booking-details.component.ts ***!
  \***************************************************************************************/
/*! exports provided: BookingDetailsComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BookingDetailsComponent", function() { return BookingDetailsComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! moment */ "./node_modules/moment/moment.js");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _constants_statuses__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../constants/statuses */ "./src/app/constants/statuses.ts");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _services_loading_service__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../services/loading.service */ "./src/app/services/loading.service.ts");
/* harmony import */ var _services_flea_market_service__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../services/flea-market.service */ "./src/app/services/flea-market.service.ts");
/* harmony import */ var _services_helper_service__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../services/helper.service */ "./src/app/services/helper.service.ts");
/* harmony import */ var _ngx_translate_core__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @ngx-translate/core */ "./node_modules/@ngx-translate/core/fesm2015/ngx-translate-core.js");
/* harmony import */ var _angular_material_dialog__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @angular/material/dialog */ "./node_modules/@angular/material/esm2015/dialog.js");
/* harmony import */ var _change_places_dialog_change_places_dialog_component__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../change-places-dialog/change-places-dialog.component */ "./src/app/components/schedule-view/change-places-dialog/change-places-dialog.component.ts");
/* harmony import */ var _constants_price__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../../constants/price */ "./src/app/constants/price.ts");
/* harmony import */ var _constants_categories__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../../constants/categories */ "./src/app/constants/categories.ts");
/* harmony import */ var _flea_invoice_print_flea_invoice_print_component__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../flea-invoice-print/flea-invoice-print.component */ "./src/app/components/flea-invoice-print/flea-invoice-print.component.ts");
/* harmony import */ var _changes_not_saved_dialog_changes_not_saved_dialog_component__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../../changes-not-saved-dialog/changes-not-saved-dialog.component */ "./src/app/components/changes-not-saved-dialog/changes-not-saved-dialog.component.ts");

















let BookingDetailsComponent = class BookingDetailsComponent {
    constructor(location, fb, route, ls, fleaMarket, helper, i18n, dialog, router) {
        this.location = location;
        this.fb = fb;
        this.route = route;
        this.ls = ls;
        this.fleaMarket = fleaMarket;
        this.helper = helper;
        this.i18n = i18n;
        this.dialog = dialog;
        this.router = router;
        this.loadingData = false;
        this.spotsChanged = false;
        this.dates = [];
        this.addAmountDropdown = [1, 2, 3, 4, 5, 10];
        this.categories = _constants_categories__WEBPACK_IMPORTED_MODULE_14__["CATEGORIES"];
        this.status_free = _constants_statuses__WEBPACK_IMPORTED_MODULE_5__["STATUS_FREE"];
        this.booking_notes = '';
        this.isReservation = false;
        this.abs = Math.abs;
    }
    get unitPrice() { return this.ticketPriceForm.controls.unit_price; }
    get sum() { return this.ticketPriceForm.controls.sum; }
    ngOnInit() {
        const yearAgo = moment__WEBPACK_IMPORTED_MODULE_3__().locale('de').endOf('week').subtract(52, 'week');
        for (let index = 0; index <= 156; index++) // Iterate over dates to get the 3 year range
         {
            this.dates.push(yearAgo.clone().add(index, 'week').format('dddd, DD.MM.YYYY')); // Push each sunday date to the array of dates
        }
        this.bookingID = this.route.snapshot.params.id;
        this.ls.loading = true;
        this.loadingData = true;
        if (this.bookingID) // If booking id exist, that means that we are editing an existing booking
         {
            this.getBooking();
        }
        else if (this.fleaMarket.selected_places) // Else a new booking is being made
         {
            this.createForm();
            this.calcBothPrices();
            this.loadingData = false;
            this.ls.loading = false;
        }
        else {
            this.location.back();
            this.helper.warningNoti(this.i18n.instant('NOTI.no_selected_places'));
        }
    }
    ngOnDestroy() {
        this.helper.clearNotifications();
    }
    /**
     * Calls the service to get booking details, and creates prefilled form with fetched data
     */
    getBooking() {
        this.fleaMarket.getBookingByID(this.bookingID).subscribe(res => {
            console.log('Booking details', res);
            this.booking = res;
            this.booking_notes = this.booking.note;
            this.status = this.getStatus(this.booking.status);
            this.createForm(res);
            this.fleaMarket.selected_places = this.booking.spots;
            this.calcBothPrices();
            this.ls.loading = false;
            this.loadingData = false;
        }, err => {
            console.log(err);
            this.ls.loading = false;
            this.helper.errorNoti(this.i18n.instant('NOTI.error_getting_booking'));
            this.goBack();
        });
    }
    createForm(booking) {
        if (booking) // If the booking is being edited
         {
            // Initialize date form
            this.datesForm = this.fb.group({
                dates: this.fb.array(this.createDatesFormGroupArray(booking.booking_dates))
            });
            // Initialize ticket price form
            this.ticketPriceForm = this.fb.group({
                price_type: [{ value: booking.discount ? true : false, disabled: true }, _angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].required],
                unit_price: [{ value: booking.price.toFixed(2), disabled: true },
                    _angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].compose([_angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].required, _angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].min(0)])],
                sum: [{ value: booking.total.toFixed(2), disabled: true }],
                place_number: [{ value: booking.spots.map(x => x.name).slice(0).toString(), disabled: true }, _angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].required]
            });
            if (booking.customer) // Initialize the form if customer info exists
             {
                this.userInfoForm = this.fb.group({
                    first_name: [booking.customer.first_name || ''],
                    last_name: [booking.customer.last_name || ''],
                    email: [booking.customer.email || '', [_angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].email]],
                    phone_number: [booking.customer.phone || ''],
                    company: [booking.customer.company || ''],
                    street: [booking.customer.streetname || ''],
                    street_number: [booking.customer.street_number || ''],
                    place: [booking.customer.city || ''],
                    post_code: [booking.customer.post_code || ''],
                    category: [booking.customer.goods || '']
                });
            }
            else // Else initialize with empty values
             {
                this.userInfoForm = this.fb.group({
                    first_name: [''],
                    last_name: [''],
                    email: ['', [_angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].email]],
                    phone_number: [''],
                    company: [''],
                    street: [''],
                    street_number: [''],
                    place: [''],
                    post_code: [''],
                    category: ['']
                });
            }
            if (booking.status === _constants_statuses__WEBPACK_IMPORTED_MODULE_5__["STATUS_RESERVED"]) {
                this.isReservation = true;
                this.ticketPriceForm.enable();
                this.ticketPriceForm.controls.place_number.disable();
                this.datesForm.enable();
            }
            this.topayControl = new _angular_forms__WEBPACK_IMPORTED_MODULE_4__["FormControl"]((booking.total - booking.payed_amount).toFixed(2), _angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].compose([
                _angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].required,
                _angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].min(0.01)
            ]));
        }
        else // If a new booking is being made
         {
            // Initialize date form
            this.datesForm = this.fb.group({
                dates: this.fb.array([
                    new _angular_forms__WEBPACK_IMPORTED_MODULE_4__["FormGroup"]({
                        date: new _angular_forms__WEBPACK_IMPORTED_MODULE_4__["FormControl"](moment__WEBPACK_IMPORTED_MODULE_3__().locale('de').endOf('week').format('dddd, DD.MM.YYYY'), _angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].required)
                    })
                ])
            });
            // Initialize ticket price form
            this.ticketPriceForm = this.fb.group({
                price_type: [false, _angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].required],
                unit_price: [_constants_price__WEBPACK_IMPORTED_MODULE_13__["Price"].FLEA, _angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].compose([_angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].required, _angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].min(0)])],
                sum: [_constants_price__WEBPACK_IMPORTED_MODULE_13__["Price"].FLEA, _angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].compose([_angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].required, _angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].min(0)])],
                place_number: [{ value: this.fleaMarket.selected_places.map(x => x.name).toString(), disabled: true }, _angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].required]
            });
            // Initialize user form
            this.userInfoForm = this.fb.group({
                first_name: [''],
                last_name: [''],
                email: ['', [_angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].email]],
                phone_number: [''],
                company: [''],
                street: [''],
                street_number: [''],
                place: [''],
                post_code: [''],
                category: ['']
            });
        }
        this.ticketPriceForm.controls.price_type.valueChanges.subscribe(value => {
            if (value === false) {
                this.unitPrice.setValue(_constants_price__WEBPACK_IMPORTED_MODULE_13__["Price"].FLEA);
            }
            else {
                this.unitPrice.setValue(_constants_price__WEBPACK_IMPORTED_MODULE_13__["Price"].FLEA_DISCOUNT);
            }
        });
        this.datesForm.valueChanges.subscribe(value => {
            this.calcBothPrices();
        });
        this.unitPrice.valueChanges.subscribe(v => {
            if (v < 0) {
                this.unitPrice.setValue(0, { emitEvent: false });
            }
            this.calculateSum();
        });
        this.sum.valueChanges.subscribe(v => {
            if (v < 0) {
                this.sum.setValue(0, { emitEvent: false });
            }
            this.calculateTicketPrice();
        });
        this.getUserinfoControl('category').valueChanges.subscribe(value => {
            const cat = this.categories.find(c => c.id === value);
            this.ticketPriceForm.controls.price_type.setValue(cat.dicounted);
        });
    }
    calculateSum() {
        this.sum.setValue((this.unitPrice.value * this.fleaMarket.selected_places.length * this.getDatesControls().length).toFixed(2), { emitEvent: false });
    }
    calculateTicketPrice() {
        this.unitPrice.setValue(this.helper.getTicketPriceBasedOnTotal(this.sum.value, this.fleaMarket.selected_places.length, this.getDatesControls().length).toFixed(2), { emitEvent: false });
    }
    calcBothPrices() {
        this.calculateSum();
        this.calculateTicketPrice();
    }
    /**
     * Returns a form group array with formatted dates
     * @param dates
     */
    createDatesFormGroupArray(dates) {
        const formGroupArray = [];
        dates.forEach((element, i) => {
            formGroupArray.push(new _angular_forms__WEBPACK_IMPORTED_MODULE_4__["FormGroup"]({
                date: new _angular_forms__WEBPACK_IMPORTED_MODULE_4__["FormControl"]({ value: moment__WEBPACK_IMPORTED_MODULE_3__(element.date, 'YYYY-MM-DD').locale('de').format('dddd, DD.MM.YYYY'), disabled: true }, _angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].required)
            }));
        });
        return formGroupArray;
    }
    /**
     * Gets the dates form groups
     */
    getDatesControls() {
        // @ts-ignore
        return this.datesForm.get('dates').controls;
    }
    getUserinfoControl(field) {
        return this.userInfoForm.controls[field];
    }
    goBack() {
        if (this.datesForm.touched || this.ticketPriceForm.touched || this.userInfoForm.touched || this.spotsChanged) {
            const dialogRef = this.dialog.open(_changes_not_saved_dialog_changes_not_saved_dialog_component__WEBPACK_IMPORTED_MODULE_16__["ChangesNotSavedDialogComponent"], { autoFocus: false, minWidth: 300 });
            dialogRef.afterClosed().subscribe(dialog_response => {
                console.log(dialog_response);
                if (dialog_response) {
                    this.router.navigate(['/schedule']);
                }
            });
        }
        else {
            this.router.navigate(['/schedule']);
        }
    }
    /**
     * Adds new date control to the formArray
     * @param amount The amount of dates to add
     */
    addNewDate(amount = 1) {
        // Iterate the amount of time specified
        for (let i = 0; i < amount; i++) {
            // Get the index of the last form group control in form array
            const len = this.getDatesControls().length;
            // Get the date value of the date control
            const last_date_value = this.getDatesControls()[len - 1].controls['date'].value;
            // Add a week to the found control
            const value = this.getMomentFromString(last_date_value).add(1, 'week');
            this.datesForm.get('dates').push(new _angular_forms__WEBPACK_IMPORTED_MODULE_4__["FormGroup"]({
                // Initialize the new form control with a date one week in advance
                date: new _angular_forms__WEBPACK_IMPORTED_MODULE_4__["FormControl"](this.getStringDateFromMoment(value), _angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].required)
            }));
        }
    }
    /**
     * Removes the date control from the formArray on the provided index
     * @param num Index of the form control
     */
    removeDate(num) {
        this.datesForm.get('dates').removeAt(num);
    }
    submitForm() {
        if (this.bookingID) // Edit booking
         {
            if (!this.userInfoForm.valid) {
                console.log('user valid', this.userInfoForm.valid);
                this.markControlsAsTouch();
                return;
            }
            this.ls.loading = true;
            const b = this.booking;
            b.price = this.ticketPriceForm.controls.unit_price.value;
            b.discount = this.ticketPriceForm.controls.price_type.value;
            b.customer = {
                id: this.booking.customer ? this.booking.customer.id : null,
                first_name: this.userInfoForm.controls.first_name.value,
                last_name: this.userInfoForm.controls.last_name.value,
                email: this.userInfoForm.controls.email.value,
                phone: this.userInfoForm.controls.phone_number.value,
                company: this.userInfoForm.controls.company.value,
                streetname: this.userInfoForm.controls.street.value,
                street_number: this.userInfoForm.controls.street_number.value,
                city: this.userInfoForm.controls.place.value,
                post_code: this.userInfoForm.controls.post_code.value,
                goods: this.userInfoForm.controls.category.value,
            };
            b.spots = this.fleaMarket.selected_places;
            b.note = this.booking_notes;
            this.fleaMarket.updateFleaMarketBooking(b).subscribe(res => {
                this.ls.loading = false;
                console.log('Update flea booking ', res);
                this.helper.successNoti(this.i18n.instant('NOTI.booking_saved'));
                this.router.navigate(['/booking/details/' + res.id]);
                this.spotsChanged = false;
            }, err => {
                console.log('Update booking error', err);
                this.helper.errorNoti(this.i18n.instant('NOTI.error_saving_booking'), err.error.message);
                this.ls.loading = false;
            });
        }
        else // New booking
         {
            console.log('dates valid', this.datesForm.valid);
            console.log('ticket valid', this.ticketPriceForm.valid);
            console.log('user valid', this.userInfoForm.valid);
            if (!this.areFormsValid()) {
                this.markControlsAsTouch();
                return;
            }
            this.ls.loading = true;
            const b = {
                booking_dates: this.getBookingDates(),
                price: this.ticketPriceForm.controls.unit_price.value,
                discount: this.ticketPriceForm.controls.price_type.value,
                customer: {
                    first_name: this.userInfoForm.controls.first_name.value,
                    last_name: this.userInfoForm.controls.last_name.value,
                    email: this.userInfoForm.controls.email.value,
                    phone: this.userInfoForm.controls.phone_number.value,
                    company: this.userInfoForm.controls.company.value,
                    streetname: this.userInfoForm.controls.street.value,
                    street_number: this.userInfoForm.controls.street_number.value,
                    city: this.userInfoForm.controls.place.value,
                    post_code: this.userInfoForm.controls.post_code.value,
                    goods: this.userInfoForm.controls.category.value,
                },
                spots: this.fleaMarket.selected_places,
                status: _constants_statuses__WEBPACK_IMPORTED_MODULE_5__["STATUS_NOT_PAID"]
            };
            this.fleaMarket.createFleaMarketBooking(b).subscribe(res => {
                this.ls.loading = false;
                console.log('Create flea booking ', res);
                this.helper.successNoti(this.i18n.instant('NOTI.booking_saved'));
                this.router.navigate(['/booking/details/' + res.id]);
                this.spotsChanged = false;
            }, err => {
                console.log('Create booking error', err);
                this.helper.errorNoti(this.i18n.instant('NOTI.error_saving_booking'), err.error.message);
                this.ls.loading = false;
            });
        }
    }
    areFormsValid() {
        return this.datesForm.valid && this.userInfoForm.valid && this.ticketPriceForm.valid;
    }
    markControlsAsTouch() {
        Object.keys(this.userInfoForm.controls).forEach(field => {
            const control = this.userInfoForm.get(field);
            control.markAsTouched({ onlySelf: true });
        });
        Object.keys(this.ticketPriceForm.controls).forEach(field => {
            const control = this.ticketPriceForm.get(field);
            control.markAsTouched({ onlySelf: true });
        });
    }
    /**
     * Converts the date in string format to a moment object
     * @param date
     * @param format
     */
    getMomentFromString(date, format = 'dddd, DD.MM.YYYY') {
        return moment__WEBPACK_IMPORTED_MODULE_3__(date, format, 'de', true);
    }
    /**
     * Converts the moment object to a string format
     * @param date
     * @param format
     */
    getStringDateFromMoment(date, format = 'dddd, DD.MM.YYYY') {
        return moment__WEBPACK_IMPORTED_MODULE_3__(date).locale('de').format(format);
    }
    addUntilEndOfMonth() {
        // Get current value
        const date = this.getDatesControls()[this.getDatesControls().length - 1].controls['date'].value;
        // Get current date's end of month
        const date_a = this.getMomentFromString(date).endOf('month');
        // Get current date to moment object
        const date_b = this.getMomentFromString(date);
        // Get the difference in weeks to the end of the month
        const diff = date_a.diff(date_b, 'week');
        // Add the amount of dates in difference
        this.addNewDate(diff);
    }
    addUntilEndOfYear() {
        // Get current value
        const date = this.getDatesControls()[this.getDatesControls().length - 1].controls['date'].value;
        // Get current date's end of month
        const date_a = this.getMomentFromString(date).endOf('year');
        // Get current date to moment object
        const date_b = this.getMomentFromString(date);
        // Get the difference in weeks to the end of the month
        const diff = date_a.diff(date_b, 'week');
        // Add the amount of dates in difference
        this.addNewDate(diff);
    }
    addOneYear() {
        this.addNewDate(52); // Add 52 weeks
    }
    /**
     * Calculate how many weeks are left in a booking
     */
    remainingWeeks() {
        let rem = 0;
        if (this.booking) {
            this.booking.booking_dates.forEach(element => {
                if (moment__WEBPACK_IMPORTED_MODULE_3__(element.date, 'YYYY-MM-DD').isAfter(moment__WEBPACK_IMPORTED_MODULE_3__())) {
                    rem++;
                }
            });
        }
        return rem || 0;
    }
    getStatus(status) {
        return _constants_statuses__WEBPACK_IMPORTED_MODULE_5__["STATUSES"].find(x => x.id === status);
    }
    /**
     * Get string array of booking dates to send to backend
     */
    getBookingDates() {
        const booking_dates = [];
        this.getDatesControls().forEach(date => {
            const mom_date = this.getMomentFromString(date.controls.date.value);
            booking_dates.push({ date: mom_date.format('YYYY-MM-DD') });
        });
        return booking_dates;
    }
    /**
     * Creates booking invoice
     */
    createInvoice() {
        if (this.booking && (this.booking.status === _constants_statuses__WEBPACK_IMPORTED_MODULE_5__["STATUS_PAID"] || this.booking.status === _constants_statuses__WEBPACK_IMPORTED_MODULE_5__["STATUS_STORNO"])) {
            this.fleaMarket.getFleaInvoice(this.booking.invoices[0].id).subscribe(res => {
                const dialogRef = this.dialog.open(_flea_invoice_print_flea_invoice_print_component__WEBPACK_IMPORTED_MODULE_15__["FleaInvoicePrintComponent"], { data: res, disableClose: true, autoFocus: false });
                dialogRef.afterClosed().subscribe(dialogResponse => {
                });
            });
        }
        else {
            this.ls.loading = true;
            this.fleaMarket.createFleaMarketInvoice(this.bookingID, this.topayControl.value).subscribe(res => {
                console.log('Invoice response: ', res);
                this.fleaMarket.getFleaInvoice(res.id).subscribe(res2 => {
                    this.ls.loading = false;
                    const dialogRef = this.dialog.open(_flea_invoice_print_flea_invoice_print_component__WEBPACK_IMPORTED_MODULE_15__["FleaInvoicePrintComponent"], { data: res2, disableClose: true, autoFocus: false });
                    dialogRef.afterClosed().subscribe(dialogResponse => {
                        this.getBooking();
                    });
                });
            }, err => {
                console.log('Invoice error', err);
                this.ls.loading = false;
            });
        }
    }
    stornoBooking() {
        this.ls.loading = true;
        this.fleaMarket.stornoFleaMarketBooking(this.bookingID).subscribe(storno_res => {
            console.log('Storno response: ', storno_res);
            this.fleaMarket.getFleaInvoice(storno_res.id).subscribe(res => {
                this.ls.loading = false;
                const dialogRef = this.dialog.open(_flea_invoice_print_flea_invoice_print_component__WEBPACK_IMPORTED_MODULE_15__["FleaInvoicePrintComponent"], { data: res, disableClose: true, autoFocus: false });
                dialogRef.afterClosed().subscribe(dialogResponse => {
                    this.getBooking();
                });
            }, err => {
                console.log('Invoice details error', err);
                this.helper.errorNoti(this.i18n.instant('NOTI.an_error_has_occurred'));
                this.getBooking();
            });
        }, err => {
            console.log('Storno error', err);
            this.helper.errorNoti(this.i18n.instant('NOTI.an_error_has_occurred'));
            this.ls.loading = false;
        });
    }
    /**
     * Opens the change places dialog
     */
    changePlaces() {
        let ref;
        if (this.booking) // If booking exists send spots from booking
         {
            ref = this.dialog.open(_change_places_dialog_change_places_dialog_component__WEBPACK_IMPORTED_MODULE_12__["ChangePlacesDialogComponent"], {
                autoFocus: false, data: {
                    spots: this.booking.spots, dates: this.getBookingDates()
                }, minWidth: 400
            });
        }
        else // If adding new booking, dont send spots data, which will select the spots from a service
         {
            ref = this.dialog.open(_change_places_dialog_change_places_dialog_component__WEBPACK_IMPORTED_MODULE_12__["ChangePlacesDialogComponent"], {
                autoFocus: false,
                minWidth: 400,
                data: {
                    dates: this.getBookingDates()
                }
            });
        }
        // Subscribe to the dialog response and if response returns ok true,
        // set new spots to the form and to booking object if exists
        ref.afterClosed().subscribe(res => {
            console.log('Dialog resp:', res);
            if (res && res.ok) {
                if (this.booking) {
                    this.booking.spots = res.places;
                }
                this.ticketPriceForm.controls.place_number.setValue(res.places.map(x => x.name).toString());
                this.fleaMarket.selected_places = res.places;
                this.spotsChanged = true;
            }
        });
    }
    printPlaceNumber() {
        const mywindow = window.open('', '_blank');
        mywindow.document.write('<html><head><title>' + document.title + '</title><style>*{font-size:22px}</style>');
        mywindow.document.write('</head><body>');
        mywindow.document.write('<p>Platznummer(n):</p>');
        mywindow.document.write(this.fleaMarket.selected_places.map(x => x.name).toString());
        mywindow.document.write('<br>');
        mywindow.document.write('<p>Datum:</p>');
        this.getDatesControls().forEach(control => {
            mywindow.document.write(`${this.helper.getMomentFromString(control.value.date).format('DD.MM.YYYY')}<br>`);
        });
        mywindow.document.write('</body></html>');
        mywindow.document.close(); // necessary for IE >= 10
        mywindow.focus(); // necessary for IE >= 10*/
        mywindow.print();
        mywindow.close();
    }
    /**
     * Prints the invoice
     * @param invoice_id
     */
    printInvoiceById(invoice_id) {
        this.fleaMarket.getFleaInvoice(invoice_id).subscribe(res => {
            const dialogRef = this.dialog.open(_flea_invoice_print_flea_invoice_print_component__WEBPACK_IMPORTED_MODULE_15__["FleaInvoicePrintComponent"], { data: res, disableClose: true, autoFocus: false });
        });
    }
};
BookingDetailsComponent.ctorParameters = () => [
    { type: _angular_common__WEBPACK_IMPORTED_MODULE_2__["Location"] },
    { type: _angular_forms__WEBPACK_IMPORTED_MODULE_4__["FormBuilder"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_6__["ActivatedRoute"] },
    { type: _services_loading_service__WEBPACK_IMPORTED_MODULE_7__["LoadingService"] },
    { type: _services_flea_market_service__WEBPACK_IMPORTED_MODULE_8__["FleaMarketService"] },
    { type: _services_helper_service__WEBPACK_IMPORTED_MODULE_9__["HelperService"] },
    { type: _ngx_translate_core__WEBPACK_IMPORTED_MODULE_10__["TranslateService"] },
    { type: _angular_material_dialog__WEBPACK_IMPORTED_MODULE_11__["MatDialog"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_6__["Router"] }
];
BookingDetailsComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-booking-details',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./booking-details.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/schedule-view/booking-details/booking-details.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./booking-details.component.scss */ "./src/app/components/schedule-view/booking-details/booking-details.component.scss")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_common__WEBPACK_IMPORTED_MODULE_2__["Location"],
        _angular_forms__WEBPACK_IMPORTED_MODULE_4__["FormBuilder"],
        _angular_router__WEBPACK_IMPORTED_MODULE_6__["ActivatedRoute"],
        _services_loading_service__WEBPACK_IMPORTED_MODULE_7__["LoadingService"],
        _services_flea_market_service__WEBPACK_IMPORTED_MODULE_8__["FleaMarketService"],
        _services_helper_service__WEBPACK_IMPORTED_MODULE_9__["HelperService"],
        _ngx_translate_core__WEBPACK_IMPORTED_MODULE_10__["TranslateService"],
        _angular_material_dialog__WEBPACK_IMPORTED_MODULE_11__["MatDialog"],
        _angular_router__WEBPACK_IMPORTED_MODULE_6__["Router"]])
], BookingDetailsComponent);



/***/ }),

/***/ "./src/app/components/schedule-view/change-booking-type-dialog/change-booking-type-dialog.component.scss":
/*!***************************************************************************************************************!*\
  !*** ./src/app/components/schedule-view/change-booking-type-dialog/change-booking-type-dialog.component.scss ***!
  \***************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".options {\n  display: grid;\n  grid-template-columns: 1fr 3fr;\n  grid-column-gap: 16px;\n  align-items: start;\n  margin: 16px 0;\n}\n.options .actions {\n  display: grid;\n  grid-row-gap: 16px;\n  grid-template-columns: 1fr;\n}\n.booking-type {\n  margin-bottom: 16px;\n}\n.booking-type button {\n  font-size: 1.3em;\n  padding: 12px 16px;\n}\n.charge {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  align-items: center;\n}\n.charge mat-form-field {\n  width: 150px;\n}\nmat-form-field {\n  width: 100%;\n}\n/*# sourceMappingURL=data:application/json;base64,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 */");

/***/ }),

/***/ "./src/app/components/schedule-view/change-booking-type-dialog/change-booking-type-dialog.component.ts":
/*!*************************************************************************************************************!*\
  !*** ./src/app/components/schedule-view/change-booking-type-dialog/change-booking-type-dialog.component.ts ***!
  \*************************************************************************************************************/
/*! exports provided: ChangeBookingTypeDialogComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ChangeBookingTypeDialogComponent", function() { return ChangeBookingTypeDialogComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _node_modules_angular_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../../node_modules/@angular/material */ "./node_modules/@angular/material/esm2015/material.js");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! moment */ "./node_modules/moment/moment.js");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _services_flea_market_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../services/flea-market.service */ "./src/app/services/flea-market.service.ts");
/* harmony import */ var _flea_invoice_print_flea_invoice_print_component__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../flea-invoice-print/flea-invoice-print.component */ "./src/app/components/flea-invoice-print/flea-invoice-print.component.ts");
/* harmony import */ var _constants_statuses__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../constants/statuses */ "./src/app/constants/statuses.ts");
/* harmony import */ var _services_helper_service__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../services/helper.service */ "./src/app/services/helper.service.ts");
/* harmony import */ var _ngx_translate_core__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @ngx-translate/core */ "./node_modules/@ngx-translate/core/fesm2015/ngx-translate-core.js");
/* harmony import */ var src_app_services_loading_service__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! src/app/services/loading.service */ "./src/app/services/loading.service.ts");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");











let ChangeBookingTypeDialogComponent = class ChangeBookingTypeDialogComponent {
    constructor(dialogRef, data, fleaMarket, dialog, helper, i18n, ls) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.fleaMarket = fleaMarket;
        this.dialog = dialog;
        this.helper = helper;
        this.i18n = i18n;
        this.ls = ls;
        this.status_not_paid = _constants_statuses__WEBPACK_IMPORTED_MODULE_6__["STATUS_NOT_PAID"];
        this.status_reserved = _constants_statuses__WEBPACK_IMPORTED_MODULE_6__["STATUS_RESERVED"];
        this.status_free = _constants_statuses__WEBPACK_IMPORTED_MODULE_6__["STATUS_FREE"];
        this.note = '';
    }
    ngOnInit() {
        console.log('Booking data: ', this.data);
        this.currentSpots = this.data.spots.map(s => s.name);
        this.currentDates = this.data.booking_dates.map(date => moment__WEBPACK_IMPORTED_MODULE_3__(date.date).format('DD.MM.YYYY.'));
        this.note = this.data.note;
        this.topayControl = new _angular_forms__WEBPACK_IMPORTED_MODULE_10__["FormControl"]((this.data.total - this.data.payed_amount).toFixed(2), _angular_forms__WEBPACK_IMPORTED_MODULE_10__["Validators"].compose([
            _angular_forms__WEBPACK_IMPORTED_MODULE_10__["Validators"].required,
            _angular_forms__WEBPACK_IMPORTED_MODULE_10__["Validators"].min(0.01)
        ]));
    }
    createInvoice() {
        if (this.topayControl.invalid) {
            return;
        }
        this.ls.loading = true;
        this.fleaMarket.createFleaMarketInvoice(this.data.id, this.topayControl.value).subscribe(res => {
            console.log('Invoice response: ', res);
            this.ls.loading = false;
            this.fleaMarket.getFleaInvoice(res.id).subscribe(invoice_res => {
                const dialogRef = this.dialog.open(_flea_invoice_print_flea_invoice_print_component__WEBPACK_IMPORTED_MODULE_5__["FleaInvoicePrintComponent"], { data: invoice_res, disableClose: true, autoFocus: false });
                dialogRef.afterClosed().subscribe(dialogResponse => {
                    this.dialogRef.close({ ok: true });
                });
            });
        }, err => {
            console.log('Invoice error', err);
            this.ls.loading = false;
        });
    }
    printPlaceNumber() {
        const mywindow = window.open('', '_blank');
        mywindow.document.write('<html><head><title>' + document.title + '</title><style>*{font-size:22px;font-family:Arial}</style>');
        mywindow.document.write('</head><body>');
        mywindow.document.write('<p>Platznummer(n):</p>');
        mywindow.document.write(this.data.spots.map(x => x.name).toString());
        mywindow.document.write('<br>');
        mywindow.document.write('<p>Datum:</p>');
        this.data.booking_dates.forEach(date => {
            mywindow.document.write(`${moment__WEBPACK_IMPORTED_MODULE_3__(date.date).format('DD.MM.YYYY')}<br>`);
        });
        mywindow.document.write('</body></html>');
        mywindow.document.close(); // necessary for IE >= 10
        mywindow.focus(); // necessary for IE >= 10*/
        mywindow.print();
        mywindow.close();
    }
    /**
     * Changes the current booking's status
     * @param status
     */
    changeBookingStatus(status) {
        if (status === -1) {
            this.fleaMarket.deleteBooking(this.data.id).subscribe(res => {
                console.log('Delete booking response', res);
                this.dialogRef.close({ ok: true });
            }, err => console.log('Delete booking error', err));
        }
        else {
            this.data.status = status;
            this.fleaMarket.updateFleaMarketBooking(this.data).subscribe(res => {
                console.log('Booking update response: ', res);
                this.dialogRef.close({ ok: true });
            }, err => {
                console.log('Booking update error:', err);
            });
        }
    }
    saveNote() {
        const booking = this.data;
        booking.note = this.note;
        this.fleaMarket.updateFleaMarketBooking(booking).subscribe(res => {
            console.log('Booking res', res);
            this.helper.successNoti(this.i18n.instant('NOTI.note_saved'));
        }, err => console.log('Booking error', err));
    }
};
ChangeBookingTypeDialogComponent.ctorParameters = () => [
    { type: _node_modules_angular_material__WEBPACK_IMPORTED_MODULE_2__["MatDialogRef"] },
    { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"], args: [_node_modules_angular_material__WEBPACK_IMPORTED_MODULE_2__["MAT_DIALOG_DATA"],] }] },
    { type: _services_flea_market_service__WEBPACK_IMPORTED_MODULE_4__["FleaMarketService"] },
    { type: _node_modules_angular_material__WEBPACK_IMPORTED_MODULE_2__["MatDialog"] },
    { type: _services_helper_service__WEBPACK_IMPORTED_MODULE_7__["HelperService"] },
    { type: _ngx_translate_core__WEBPACK_IMPORTED_MODULE_8__["TranslateService"] },
    { type: src_app_services_loading_service__WEBPACK_IMPORTED_MODULE_9__["LoadingService"] }
];
ChangeBookingTypeDialogComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-change-booking-type-dialog',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./change-booking-type-dialog.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/schedule-view/change-booking-type-dialog/change-booking-type-dialog.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./change-booking-type-dialog.component.scss */ "./src/app/components/schedule-view/change-booking-type-dialog/change-booking-type-dialog.component.scss")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__param"](1, Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"])(_node_modules_angular_material__WEBPACK_IMPORTED_MODULE_2__["MAT_DIALOG_DATA"])),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_node_modules_angular_material__WEBPACK_IMPORTED_MODULE_2__["MatDialogRef"], Object, _services_flea_market_service__WEBPACK_IMPORTED_MODULE_4__["FleaMarketService"],
        _node_modules_angular_material__WEBPACK_IMPORTED_MODULE_2__["MatDialog"],
        _services_helper_service__WEBPACK_IMPORTED_MODULE_7__["HelperService"],
        _ngx_translate_core__WEBPACK_IMPORTED_MODULE_8__["TranslateService"],
        src_app_services_loading_service__WEBPACK_IMPORTED_MODULE_9__["LoadingService"]])
], ChangeBookingTypeDialogComponent);



/***/ }),

/***/ "./src/app/components/schedule-view/change-places-dialog/change-places-dialog.component.scss":
/*!***************************************************************************************************!*\
  !*** ./src/app/components/schedule-view/change-places-dialog/change-places-dialog.component.scss ***!
  \***************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".spot-wrapper {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n}\n.spot-wrapper .place-dropdown {\n  max-width: 70px;\n  margin-right: 16px;\n}\n.spot-wrapper .place-dropdown mat-form-field {\n  width: 100%;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9Vc2Vycy9jaHJpc3RvcGhlbmdlbG1heWVyL0NvZGUvZmxvaG1hcmt0L2F1dG9raW5vdjItZmUtYmUvYW5ndWxhci1mcm9udGVuZC9zcmMvYXBwL2NvbXBvbmVudHMvc2NoZWR1bGUtdmlldy9jaGFuZ2UtcGxhY2VzLWRpYWxvZy9jaGFuZ2UtcGxhY2VzLWRpYWxvZy5jb21wb25lbnQuc2NzcyIsInNyYy9hcHAvY29tcG9uZW50cy9zY2hlZHVsZS12aWV3L2NoYW5nZS1wbGFjZXMtZGlhbG9nL2NoYW5nZS1wbGFjZXMtZGlhbG9nLmNvbXBvbmVudC5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBRUUsYUFBQTtFQUNBLG1CQUFBO0VBQ0EsZUFBQTtBQ0FGO0FERUU7RUFFRSxlQUFBO0VBQ0Esa0JBQUE7QUNESjtBREdJO0VBRUUsV0FBQTtBQ0ZOIiwiZmlsZSI6InNyYy9hcHAvY29tcG9uZW50cy9zY2hlZHVsZS12aWV3L2NoYW5nZS1wbGFjZXMtZGlhbG9nL2NoYW5nZS1wbGFjZXMtZGlhbG9nLmNvbXBvbmVudC5zY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLnNwb3Qtd3JhcHBlclxue1xuICBkaXNwbGF5OiBmbGV4O1xuICBmbGV4LWRpcmVjdGlvbjogcm93O1xuICBmbGV4LXdyYXA6IHdyYXA7XG5cbiAgLnBsYWNlLWRyb3Bkb3duXG4gIHtcbiAgICBtYXgtd2lkdGg6IDcwcHg7XG4gICAgbWFyZ2luLXJpZ2h0OiAxNnB4O1xuXG4gICAgbWF0LWZvcm0tZmllbGRcbiAgICB7XG4gICAgICB3aWR0aDogMTAwJTtcbiAgICB9XG4gIH1cbn1cbiIsIi5zcG90LXdyYXBwZXIge1xuICBkaXNwbGF5OiBmbGV4O1xuICBmbGV4LWRpcmVjdGlvbjogcm93O1xuICBmbGV4LXdyYXA6IHdyYXA7XG59XG4uc3BvdC13cmFwcGVyIC5wbGFjZS1kcm9wZG93biB7XG4gIG1heC13aWR0aDogNzBweDtcbiAgbWFyZ2luLXJpZ2h0OiAxNnB4O1xufVxuLnNwb3Qtd3JhcHBlciAucGxhY2UtZHJvcGRvd24gbWF0LWZvcm0tZmllbGQge1xuICB3aWR0aDogMTAwJTtcbn0iXX0= */");

/***/ }),

/***/ "./src/app/components/schedule-view/change-places-dialog/change-places-dialog.component.ts":
/*!*************************************************************************************************!*\
  !*** ./src/app/components/schedule-view/change-places-dialog/change-places-dialog.component.ts ***!
  \*************************************************************************************************/
/*! exports provided: ChangePlacesDialogComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ChangePlacesDialogComponent", function() { return ChangePlacesDialogComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_material_dialog__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/material/dialog */ "./node_modules/@angular/material/esm2015/dialog.js");
/* harmony import */ var _services_flea_market_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../services/flea-market.service */ "./src/app/services/flea-market.service.ts");
/* harmony import */ var _constants_spots__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../constants/spots */ "./src/app/constants/spots.ts");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _services_helper_service__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../services/helper.service */ "./src/app/services/helper.service.ts");
/* harmony import */ var _ngx_translate_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @ngx-translate/core */ "./node_modules/@ngx-translate/core/fesm2015/ngx-translate-core.js");








let ChangePlacesDialogComponent = class ChangePlacesDialogComponent {
    constructor(dialogRef, fleaMarket, data, fb, helper, i18n) {
        this.dialogRef = dialogRef;
        this.fleaMarket = fleaMarket;
        this.data = data;
        this.fb = fb;
        this.helper = helper;
        this.i18n = i18n;
        /**
         * All existing spots
         */
        this.spots = [];
        this.loading = false;
        this.createForm();
    }
    ngOnInit() {
        this.loading = true;
        if (this.data && this.data.spots) // If data exist, that means that booking is being edited
         {
            this.selected_spots = this.data.spots;
            console.log('Spots: ', this.data.spots);
        }
        else // Else a new booking is being added, and we use selected spots from the service
         {
            this.selected_spots = this.fleaMarket.selected_places;
        }
        _constants_spots__WEBPACK_IMPORTED_MODULE_4__["SPOTS"].forEach(row => {
            row.spots.forEach(s => {
                if (s.name !== 'X') {
                    this.spots.push(s.name);
                }
            });
        });
        this.addSpots();
    }
    ngOnDestroy() {
        this.helper.clearNotifications();
    }
    createForm() {
        this.form = this.fb.group({
            spots: this.fb.array([])
        });
    }
    /**
     * Pushes the selected spots to an array of form controls
     */
    addSpots() {
        this.selected_spots.forEach(s => {
            this.form.get('spots').push(new _angular_forms__WEBPACK_IMPORTED_MODULE_5__["FormGroup"]({
                spot: new _angular_forms__WEBPACK_IMPORTED_MODULE_5__["FormControl"](s.name)
            }));
        });
        this.loading = false;
    }
    getSpotsFormGroups() {
        // @ts-ignore
        return this.form.get('spots').controls;
    }
    save() {
        const places = [];
        this.getSpotsFormGroups().forEach((group, i) => {
            places.push({ id: this.selected_spots[i].id, name: group.controls.spot.value });
        });
        console.log('Places: ', places);
        console.log('Dates: ', this.data.dates.map(d => d.date));
        this.fleaMarket.checkSpotAvailability(places, this.data.dates.map(d => d.date)).subscribe(res => {
            console.log('Response', res);
            if (res.available) {
                this.dialogRef.close({ ok: true, places });
            }
            else {
                this.helper.errorNoti(this.i18n.instant('NOTI.spots_taken'));
            }
        });
    }
};
ChangePlacesDialogComponent.ctorParameters = () => [
    { type: _angular_material_dialog__WEBPACK_IMPORTED_MODULE_2__["MatDialogRef"] },
    { type: _services_flea_market_service__WEBPACK_IMPORTED_MODULE_3__["FleaMarketService"] },
    { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"], args: [_angular_material_dialog__WEBPACK_IMPORTED_MODULE_2__["MAT_DIALOG_DATA"],] }] },
    { type: _angular_forms__WEBPACK_IMPORTED_MODULE_5__["FormBuilder"] },
    { type: _services_helper_service__WEBPACK_IMPORTED_MODULE_6__["HelperService"] },
    { type: _ngx_translate_core__WEBPACK_IMPORTED_MODULE_7__["TranslateService"] }
];
ChangePlacesDialogComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-change-places-dialog',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./change-places-dialog.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/schedule-view/change-places-dialog/change-places-dialog.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./change-places-dialog.component.scss */ "./src/app/components/schedule-view/change-places-dialog/change-places-dialog.component.scss")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__param"](2, Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"])(_angular_material_dialog__WEBPACK_IMPORTED_MODULE_2__["MAT_DIALOG_DATA"])),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_material_dialog__WEBPACK_IMPORTED_MODULE_2__["MatDialogRef"],
        _services_flea_market_service__WEBPACK_IMPORTED_MODULE_3__["FleaMarketService"], Object, _angular_forms__WEBPACK_IMPORTED_MODULE_5__["FormBuilder"],
        _services_helper_service__WEBPACK_IMPORTED_MODULE_6__["HelperService"],
        _ngx_translate_core__WEBPACK_IMPORTED_MODULE_7__["TranslateService"]])
], ChangePlacesDialogComponent);



/***/ }),

/***/ "./src/app/components/schedule-view/informal-reservation-dialog/informal-reservation-dialog.component.scss":
/*!*****************************************************************************************************************!*\
  !*** ./src/app/components/schedule-view/informal-reservation-dialog/informal-reservation-dialog.component.scss ***!
  \*****************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("h5 {\n  margin: 0;\n}\n\n.spots-wrapper {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n}\n\n.spots-wrapper .spot {\n  width: 25px;\n  height: 43px;\n  border: 1px solid black;\n  border-radius: 5px;\n  margin: 3px;\n  text-align: center;\n  font-size: 12px;\n  font-weight: 500;\n  padding: 12px 0;\n}\n\n.date-controls-wrapper {\n  display: grid;\n  grid-template-columns: 2fr 2fr 1fr;\n  grid-column-gap: 16px;\n  margin: 16px 0;\n}\n\n.date-controls-wrapper .date-list {\n  display: flex;\n  flex-direction: column;\n}\n\n.date-controls-wrapper .date-list mat-form-field {\n  width: 100%;\n}\n\n.date-controls-wrapper .controls {\n  display: flex;\n  flex-direction: column;\n}\n\n.date-controls-wrapper .controls button {\n  margin: 3px 0;\n}\n\n.date-controls-wrapper .informal-colors .color-group {\n  display: flex;\n  flex-direction: column;\n}\n\n.date-controls-wrapper .informal-colors .color-group .color-buttons {\n  margin: 5px;\n}\n\n.date-controls-wrapper .informal-colors .color-group .color-box {\n  display: inline-block !important;\n  width: 20px !important;\n  height: 20px;\n  border: 1px solid black;\n}\n/*# sourceMappingURL=data:application/json;base64,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 */");

/***/ }),

/***/ "./src/app/components/schedule-view/informal-reservation-dialog/informal-reservation-dialog.component.ts":
/*!***************************************************************************************************************!*\
  !*** ./src/app/components/schedule-view/informal-reservation-dialog/informal-reservation-dialog.component.ts ***!
  \***************************************************************************************************************/
/*! exports provided: InformalReservationDialogComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InformalReservationDialogComponent", function() { return InformalReservationDialogComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! moment */ "./node_modules/moment/moment.js");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _services_helper_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../services/helper.service */ "./src/app/services/helper.service.ts");
/* harmony import */ var _angular_material_dialog__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/material/dialog */ "./node_modules/@angular/material/esm2015/dialog.js");
/* harmony import */ var _services_flea_market_service__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../services/flea-market.service */ "./src/app/services/flea-market.service.ts");
/* harmony import */ var _constants_statuses__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../constants/statuses */ "./src/app/constants/statuses.ts");
/* harmony import */ var _constants_price__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../constants/price */ "./src/app/constants/price.ts");









let InformalReservationDialogComponent = class InformalReservationDialogComponent {
    constructor(fb, helper, data, dialogRef, fleaMarket) {
        this.fb = fb;
        this.helper = helper;
        this.data = data;
        this.dialogRef = dialogRef;
        this.fleaMarket = fleaMarket;
        this.dates = [];
        this.informal_colors = [
            {
                color: '#cc6699',
                value: 'purple'
            },
            {
                color: '#ff6600',
                value: 'red'
            },
            {
                color: '#9999ff',
                value: 'blue'
            },
            {
                color: '#ffffff',
                value: 'white'
            },
        ];
        this.selected_color = new _angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormControl"]('purple');
        moment__WEBPACK_IMPORTED_MODULE_3__().locale('de');
    }
    ngOnInit() {
        const yearAgo = moment__WEBPACK_IMPORTED_MODULE_3__().locale('de').endOf('week').subtract(52, 'week');
        for (let index = 0; index <= 156; index++) // Iterate over dates to get the 3 year range
         {
            this.dates.push(yearAgo.clone().add(index, 'week').format('dddd, DD.MM.YYYY')); // Push each sunday date to the array of dates
        }
        console.log('Dialog data: ', this.data);
        this.createForm();
    }
    ngOnDestroy() {
        this.helper.clearNotifications();
    }
    createForm() {
        this.datesForm = this.fb.group({
            dates: this.fb.array([
                new _angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormGroup"]({
                    date: new _angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormControl"](this.data.date.locale('de').format('dddd, DD.MM.YYYY'), _angular_forms__WEBPACK_IMPORTED_MODULE_2__["Validators"].required)
                })
            ])
        });
    }
    /**
     * Gets the dates form groups
     */
    getDatesControls() {
        // @ts-ignore
        return this.datesForm.get('dates').controls;
    }
    /**
     * Removes the date control from the formArray on the provided index
     * @param num Index of the form control
     */
    removeDate(num) {
        this.datesForm.get('dates').removeAt(num);
    }
    /**
     * Adds new date control to the formArray
     * @param amount The amount of dates to add
     */
    addNewDate(amount = 1) {
        // Iterate the amount of time specified
        for (let i = 0; i < amount; i++) {
            // Get the index of the last form group control in form array
            const len = this.getDatesControls().length;
            // Get the date value of the date control
            const last_date_value = this.getDatesControls()[len - 1].controls['date'].value;
            // Add a week to the found control
            const value = this.helper.getMomentFromString(last_date_value).add(1, 'week');
            this.datesForm.get('dates').push(new _angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormGroup"]({
                // Initialize the new form control with a date one week in advance
                date: new _angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormControl"](this.helper.getStringDateFromMoment(value), _angular_forms__WEBPACK_IMPORTED_MODULE_2__["Validators"].required)
            }));
        }
    }
    addUntilEndOfMonth() {
        // Get current value
        const date = this.getDatesControls()[this.getDatesControls().length - 1].controls['date'].value;
        // Get current date's end of month
        const date_a = this.helper.getMomentFromString(date).endOf('month');
        // Get current date to moment object
        const date_b = this.helper.getMomentFromString(date);
        // Get the difference in weeks to the end of the month
        const diff = date_a.diff(date_b, 'week');
        // Add the amount of dates in difference
        this.addNewDate(diff);
    }
    addUntilEndOfYear() {
        // Get current value
        const date = this.getDatesControls()[this.getDatesControls().length - 1].controls['date'].value;
        // Get current date's end of month
        const date_a = this.helper.getMomentFromString(date).endOf('year');
        // Get current date to moment object
        const date_b = this.helper.getMomentFromString(date);
        // Get the difference in weeks to the end of the month
        const diff = date_a.diff(date_b, 'week');
        // Add the amount of dates in difference
        this.addNewDate(diff);
    }
    addOneYear() {
        this.addNewDate(52); // Add 52 weeks
    }
    save() {
        if (this.selected_color.value === 'white') {
            const spots = [];
            const booking_dates = this.helper.getBookingDates(this.getDatesControls());
            booking_dates.forEach(date => {
                this.data.spots.forEach(spot => {
                    spots.push({ name: spot, booking_date: date.date });
                });
            });
            console.log('spots: ', spots);
            this.fleaMarket.removeInformalSpot(spots).subscribe(res => {
                console.log('Remove informal spot response', res);
                this.dialogRef.close({ ok: true });
            }, err => console.log('Remove informal spot error', err));
        }
        else {
            const booking = {
                booking_dates: this.helper.getBookingDates(this.getDatesControls()),
                spots: this.data.spots.map(s => ({ name: s })),
                status: _constants_statuses__WEBPACK_IMPORTED_MODULE_7__["STATUS_INFORMAL_RESERVATION"],
                discount: false,
                price: _constants_price__WEBPACK_IMPORTED_MODULE_8__["Price"].FLEA,
                informal_color: this.selected_color.value
            };
            this.fleaMarket.createFleaMarketBooking(booking).subscribe(res => {
                console.log('Booking response', res);
                this.dialogRef.close({ ok: true });
            }, err => console.log('Booking error', err));
        }
    }
};
InformalReservationDialogComponent.ctorParameters = () => [
    { type: _angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormBuilder"] },
    { type: _services_helper_service__WEBPACK_IMPORTED_MODULE_4__["HelperService"] },
    { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"], args: [_angular_material_dialog__WEBPACK_IMPORTED_MODULE_5__["MAT_DIALOG_DATA"],] }] },
    { type: _angular_material_dialog__WEBPACK_IMPORTED_MODULE_5__["MatDialogRef"] },
    { type: _services_flea_market_service__WEBPACK_IMPORTED_MODULE_6__["FleaMarketService"] }
];
InformalReservationDialogComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-informal-reservation-dialog',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./informal-reservation-dialog.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/schedule-view/informal-reservation-dialog/informal-reservation-dialog.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./informal-reservation-dialog.component.scss */ "./src/app/components/schedule-view/informal-reservation-dialog/informal-reservation-dialog.component.scss")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__param"](2, Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"])(_angular_material_dialog__WEBPACK_IMPORTED_MODULE_5__["MAT_DIALOG_DATA"])),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormBuilder"],
        _services_helper_service__WEBPACK_IMPORTED_MODULE_4__["HelperService"], Object, _angular_material_dialog__WEBPACK_IMPORTED_MODULE_5__["MatDialogRef"],
        _services_flea_market_service__WEBPACK_IMPORTED_MODULE_6__["FleaMarketService"]])
], InformalReservationDialogComponent);



/***/ }),

/***/ "./src/app/components/schedule-view/quick-booking-dialog/quick-booking-dialog.component.scss":
/*!***************************************************************************************************!*\
  !*** ./src/app/components/schedule-view/quick-booking-dialog/quick-booking-dialog.component.scss ***!
  \***************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("h5 {\n  margin: 0;\n}\n\n.price-form {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  grid-column-gap: 16px;\n  grid-row-gap: 16px;\n}\n\n.price-form mat-form-field {\n  width: 100%;\n}\n\n.price-form .discount-radio-group {\n  display: inline-flex;\n  flex-direction: column;\n}\n\n.price-form .discount-radio-group .discount-button {\n  margin: 8px;\n}\n\n.spots-wrapper {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n}\n\n.spots-wrapper .spot {\n  width: 25px;\n  height: 43px;\n  border: 1px solid black;\n  border-radius: 5px;\n  margin: 3px;\n  text-align: center;\n  font-size: 12px;\n  font-weight: 500;\n  padding: 12px 0;\n}\n/*# sourceMappingURL=data:application/json;base64,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 */");

/***/ }),

/***/ "./src/app/components/schedule-view/quick-booking-dialog/quick-booking-dialog.component.ts":
/*!*************************************************************************************************!*\
  !*** ./src/app/components/schedule-view/quick-booking-dialog/quick-booking-dialog.component.ts ***!
  \*************************************************************************************************/
/*! exports provided: QuickBookingDialogComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "QuickBookingDialogComponent", function() { return QuickBookingDialogComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_material_dialog__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/material/dialog */ "./node_modules/@angular/material/esm2015/dialog.js");
/* harmony import */ var _services_flea_market_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../services/flea-market.service */ "./src/app/services/flea-market.service.ts");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _constants_statuses__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../constants/statuses */ "./src/app/constants/statuses.ts");
/* harmony import */ var _constants_price__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../constants/price */ "./src/app/constants/price.ts");
/* harmony import */ var _ngx_translate_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @ngx-translate/core */ "./node_modules/@ngx-translate/core/fesm2015/ngx-translate-core.js");
/* harmony import */ var _services_helper_service__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../services/helper.service */ "./src/app/services/helper.service.ts");
/* harmony import */ var _flea_invoice_print_flea_invoice_print_component__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../flea-invoice-print/flea-invoice-print.component */ "./src/app/components/flea-invoice-print/flea-invoice-print.component.ts");










let QuickBookingDialogComponent = class QuickBookingDialogComponent {
    constructor(dialogRef, fleaMarket, data, i18n, helper, dialog, fb) {
        this.dialogRef = dialogRef;
        this.fleaMarket = fleaMarket;
        this.data = data;
        this.i18n = i18n;
        this.helper = helper;
        this.dialog = dialog;
        this.fb = fb;
        this.processing = false;
    }
    get paid_amount_control() { return this.form.controls['paid']; }
    get total_control() { return this.form.controls['total']; }
    get discount_control() { return this.form.controls['discount']; }
    set total(value) { this.total_control.setValue(value); }
    get total() { return this.total_control.value; }
    ngOnInit() {
        this.form = this.fb.group({
            paid: [_constants_price__WEBPACK_IMPORTED_MODULE_6__["Price"].FLEA * this.data.spots.length, _angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].compose([_angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].required, _angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].min(0)])],
            total: [_constants_price__WEBPACK_IMPORTED_MODULE_6__["Price"].FLEA * this.data.spots.length, _angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].compose([_angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].required, _angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].min(0)])],
            discount: [false, _angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].required]
        });
        this.calcTotal();
        console.log('DATA: ', this.data);
        this.discount_control.valueChanges.subscribe(value => {
            this.calcTotal();
            this.checkIfPricePayedIsGreaterThanTotal();
        });
        this.paid_amount_control.valueChanges.subscribe(value => this.checkIfPricePayedIsGreaterThanTotal());
        this.total_control.valueChanges.subscribe(value => {
            this.paid_amount_control.setValue(value);
        });
    }
    ngOnDestroy() {
    }
    /**
     * Calculates the total price of the booking
     */
    calcTotal() {
        if (this.discount_control.value) {
            this.total = this.data.spots.length * _constants_price__WEBPACK_IMPORTED_MODULE_6__["Price"].FLEA_DISCOUNT;
        }
        else {
            this.total = this.data.spots.length * _constants_price__WEBPACK_IMPORTED_MODULE_6__["Price"].FLEA;
        }
    }
    checkIfPricePayedIsGreaterThanTotal() {
        if (this.paid_amount_control.value > this.total) {
            this.paid_amount_control.setValue(this.total, { emitEvent: false });
        }
    }
    getTicketPrice() {
        return this.helper.getTicketPriceBasedOnTotal(this.total, this.data.spots.length, 1);
    }
    saveBooking() {
        if (!this.form.valid) {
            return;
        }
        const booking = {
            price: this.getTicketPrice(),
            discount: this.discount_control.value,
            booking_dates: [{ date: this.data.date }],
            spots: this.data.spots.map(s => ({ name: s })),
            status: _constants_statuses__WEBPACK_IMPORTED_MODULE_5__["STATUS_NOT_PAID"]
        };
        console.log('Booking', booking);
        this.processing = true;
        this.fleaMarket.createFleaMarketQuickBooking(booking).subscribe(book_res => {
            console.log('Booking response: ', book_res);
            if (this.paid_amount_control.value > 0) {
                this.fleaMarket.createFleaMarketInvoice(book_res.id, this.paid_amount_control.value)
                    .subscribe(inv_res => {
                    console.log('Invoice response', inv_res);
                    this.fleaMarket.getFleaInvoice(inv_res.id).subscribe(res => {
                        const printDialog = this.dialog.open(_flea_invoice_print_flea_invoice_print_component__WEBPACK_IMPORTED_MODULE_9__["FleaInvoicePrintComponent"], { data: res, disableClose: true, autoFocus: false });
                        printDialog.afterClosed().subscribe(dialogResponse => {
                            this.helper.successNoti(this.i18n.instant('NOTI.booking_saved'));
                            this.dialogRef.close({ ok: true });
                        });
                    });
                }, err => {
                    console.log('Error with quick booking invoice: ', err);
                    this.processing = false;
                    this.helper.errorNoti(this.i18n.instant('NOTI.error_saving_booking'), err.error.message);
                });
            }
            else {
                this.helper.successNoti(this.i18n.instant('NOTI.booking_saved'));
                this.dialogRef.close({ ok: true });
            }
        }, err => {
            console.log('Error with quick booking: ', err);
            this.processing = false;
            this.helper.errorNoti(this.i18n.instant('NOTI.error_saving_booking'), err.error.message);
        });
    }
};
QuickBookingDialogComponent.ctorParameters = () => [
    { type: _angular_material_dialog__WEBPACK_IMPORTED_MODULE_2__["MatDialogRef"] },
    { type: _services_flea_market_service__WEBPACK_IMPORTED_MODULE_3__["FleaMarketService"] },
    { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"], args: [_angular_material_dialog__WEBPACK_IMPORTED_MODULE_2__["MAT_DIALOG_DATA"],] }] },
    { type: _ngx_translate_core__WEBPACK_IMPORTED_MODULE_7__["TranslateService"] },
    { type: _services_helper_service__WEBPACK_IMPORTED_MODULE_8__["HelperService"] },
    { type: _angular_material_dialog__WEBPACK_IMPORTED_MODULE_2__["MatDialog"] },
    { type: _angular_forms__WEBPACK_IMPORTED_MODULE_4__["FormBuilder"] }
];
QuickBookingDialogComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-quick-booking-dialog',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./quick-booking-dialog.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/schedule-view/quick-booking-dialog/quick-booking-dialog.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./quick-booking-dialog.component.scss */ "./src/app/components/schedule-view/quick-booking-dialog/quick-booking-dialog.component.scss")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__param"](2, Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"])(_angular_material_dialog__WEBPACK_IMPORTED_MODULE_2__["MAT_DIALOG_DATA"])),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_material_dialog__WEBPACK_IMPORTED_MODULE_2__["MatDialogRef"],
        _services_flea_market_service__WEBPACK_IMPORTED_MODULE_3__["FleaMarketService"], Object, _ngx_translate_core__WEBPACK_IMPORTED_MODULE_7__["TranslateService"],
        _services_helper_service__WEBPACK_IMPORTED_MODULE_8__["HelperService"],
        _angular_material_dialog__WEBPACK_IMPORTED_MODULE_2__["MatDialog"],
        _angular_forms__WEBPACK_IMPORTED_MODULE_4__["FormBuilder"]])
], QuickBookingDialogComponent);



/***/ }),

/***/ "./src/app/components/schedule-view/schedule-view.component.scss":
/*!***********************************************************************!*\
  !*** ./src/app/components/schedule-view/schedule-view.component.scss ***!
  \***********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (":host .print-button {\n  position: absolute;\n  top: 100px;\n  left: 0;\n  min-width: 0;\n}\n:host mat-toolbar {\n  overflow-x: auto;\n  overflow-y: hidden;\n}\n:host .spots-wrapper {\n  padding: 16px 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  min-width: 1200px;\n}\n:host .spots-wrapper .flea-row {\n  display: flex;\n  flex-direction: row;\n  margin: 2px 0;\n  position: relative;\n}\n:host .spots-wrapper .flea-row .spot, :host .spots-wrapper .flea-row .spot-hidden {\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  width: 32px;\n  height: 32px;\n  cursor: pointer;\n  border: 1px solid black;\n  border-radius: 5px;\n  margin: 3px;\n  text-align: center;\n  font-size: 12px;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n:host .spots-wrapper .flea-row .auto-spot-horiz {\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  width: 100px;\n  border: 1px solid black;\n  border-radius: 5px;\n  cursor: pointer;\n  margin: 3px;\n  text-align: center;\n  font-size: 12px;\n  font-weight: 500;\n  padding: 4px 0;\n}\n:host .spots-wrapper .flea-row .auto-spot {\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  border: 1px solid black;\n  border-radius: 5px;\n  cursor: pointer;\n  margin: 7px;\n  text-align: center;\n  font-size: 12px;\n  font-weight: 500;\n  position: absolute;\n  left: -45px;\n  top: -100%;\n}\n:host .spots-wrapper .flea-row .spot-hidden {\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  visibility: hidden;\n}\n:host .spots-wrapper .flea-row .spot-aisle {\n  height: 13px;\n}\n:host .spots-wrapper .flea-row .container-spot {\n  background-color: #60829F;\n  color: #fff;\n}\n:host .spots-wrapper .flea-row .container-spot.informal1 {\n  outline: #cc6699 solid 4px;\n}\n:host .spots-wrapper .flea-row .container-spot.informal2 {\n  outline: #ff6600 solid 4px;\n}\n:host .spots-wrapper .flea-row .container-spot.informal3 {\n  outline: #9999ff solid 4px;\n}\n:host .spots-wrapper .flea-row .move-up {\n  transform: translateY(-50%);\n}\n:host .spots-wrapper .flea-row .move-down {\n  transform: translateY(50%);\n}\n:host .spots-wrapper .not-paid {\n  background-color: #bd0007;\n  color: #ffffff;\n  border: 1px solid #ddd;\n}\n:host .spots-wrapper .not-paid-discount {\n  background-color: #ff575d;\n  color: #ffffff;\n  border: 1px solid #ddd;\n}\n:host .spots-wrapper .paid {\n  background-color: #68b828;\n  color: white;\n}\n:host .spots-wrapper .paid-discount {\n  background-color: #adff6b;\n}\n:host .spots-wrapper .paid-partly {\n  background-color: #F98709;\n}\n:host .spots-wrapper .paid-partly-discount {\n  background-color: #ffce99;\n}\n:host .spots-wrapper .canceled {\n  background-color: #CCCCCC;\n}\n:host .spots-wrapper .free {\n  background-color: #ffffff;\n  color: #000000;\n}\n:host .spots-wrapper .reserved {\n  background-color: #60829F;\n  color: white;\n}\n:host .spots-wrapper .reserved-discount {\n  background-color: #60829F;\n  color: white;\n}\n:host .spots-wrapper .free-spot {\n  background-color: #FFFF00;\n  color: #000000;\n}\n:host .spots-wrapper .free-spot-discount {\n  background-color: #FFFF00;\n  color: #000000;\n}\n:host .spots-wrapper .storno {\n  background-color: #000000;\n  color: #000000;\n}\n:host .spots-wrapper .selected {\n  background-color: #0e62c7 !important;\n  color: white;\n}\n:host .spots-wrapper .informal1 {\n  background-color: #cc6699;\n  color: white;\n}\n:host .spots-wrapper .informal2 {\n  background-color: #ff6600;\n  color: white;\n}\n:host .spots-wrapper .informal3 {\n  background-color: #9999ff;\n  color: white;\n}\n:host .nav-item .quick-reservation {\n  background-color: #60829F;\n  color: white;\n}\n:host .nav-item .quick-reservation:disabled {\n  background-color: rgba(96, 130, 159, 0.664);\n  color: #c5c5c5;\n}\n:host .nav-item .quick-booking {\n  background-color: #ffba00;\n}\n:host .nav-item .quick-booking:disabled {\n  background-color: rgba(255, 187, 0, 0.664);\n}\n:host .nav-item .booking {\n  background-color: #8dc63f;\n}\n:host .nav-item .booking:disabled {\n  background-color: rgba(142, 198, 63, 0.664);\n}\n:host .nav-item .informal-booking {\n  background-color: #40bbea;\n}\n:host .nav-item .informal-booking:disabled {\n  background-color: rgba(64, 186, 234, 0.664);\n}\n:host .spiner {\n  margin-top: 15%;\n  display: flex;\n  justify-content: center;\n}\n@media print {\n  button {\n    display: none;\n  }\n\n  mat-form-field {\n    display: none;\n  }\n\n  mat-toolbar {\n    display: none;\n  }\n\n  .container-fluid {\n    overflow: visible !important;\n    margin: 0;\n    padding: 0;\n  }\n\n  .spots-wrapper {\n    margin: 0;\n    padding: 0;\n  }\n}\n/*# sourceMappingURL=data:application/json;base64,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 */");

/***/ }),

/***/ "./src/app/components/schedule-view/schedule-view.component.ts":
/*!*********************************************************************!*\
  !*** ./src/app/components/schedule-view/schedule-view.component.ts ***!
  \*********************************************************************/
/*! exports provided: ScheduleViewComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ScheduleViewComponent", function() { return ScheduleViewComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _services_nav_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../services/nav.service */ "./src/app/services/nav.service.ts");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _services_flea_market_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../services/flea-market.service */ "./src/app/services/flea-market.service.ts");
/* harmony import */ var _constants_spots__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../constants/spots */ "./src/app/constants/spots.ts");
/* harmony import */ var _services_helper_service__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../services/helper.service */ "./src/app/services/helper.service.ts");
/* harmony import */ var _ngx_translate_core__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @ngx-translate/core */ "./node_modules/@ngx-translate/core/fesm2015/ngx-translate-core.js");
/* harmony import */ var _constants_statuses__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../constants/statuses */ "./src/app/constants/statuses.ts");
/* harmony import */ var _angular_material_dialog__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @angular/material/dialog */ "./node_modules/@angular/material/esm2015/dialog.js");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! moment */ "./node_modules/moment/moment.js");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _quick_booking_dialog_quick_booking_dialog_component__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./quick-booking-dialog/quick-booking-dialog.component */ "./src/app/components/schedule-view/quick-booking-dialog/quick-booking-dialog.component.ts");
/* harmony import */ var _informal_reservation_dialog_informal_reservation_dialog_component__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./informal-reservation-dialog/informal-reservation-dialog.component */ "./src/app/components/schedule-view/informal-reservation-dialog/informal-reservation-dialog.component.ts");
/* harmony import */ var _booking_details_dialog_booking_details_dialog_component__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./booking-details-dialog/booking-details-dialog.component */ "./src/app/components/schedule-view/booking-details-dialog/booking-details-dialog.component.ts");
/* harmony import */ var _services_loading_service__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../services/loading.service */ "./src/app/services/loading.service.ts");
/* harmony import */ var _change_booking_type_dialog_change_booking_type_dialog_component__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./change-booking-type-dialog/change-booking-type-dialog.component */ "./src/app/components/schedule-view/change-booking-type-dialog/change-booking-type-dialog.component.ts");
/* harmony import */ var _constants_price__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../../constants/price */ "./src/app/constants/price.ts");


















let ScheduleViewComponent = class ScheduleViewComponent {
    constructor(nav, router, fleaMarket, helper, i18n, dialog, ls) {
        this.nav = nav;
        this.router = router;
        this.fleaMarket = fleaMarket;
        this.helper = helper;
        this.i18n = i18n;
        this.dialog = dialog;
        this.ls = ls;
        this.loadingData = false;
        this.spots = JSON.parse(JSON.stringify(_constants_spots__WEBPACK_IMPORTED_MODULE_6__["SPOTS"]));
        this.selectedSpots = [];
        /**
         * Filters out all other days except sundays
         */
        this.dateFilter = (d) => {
            const day = d.day();
            return day === 0; // Only enable sundays
        };
        if (moment__WEBPACK_IMPORTED_MODULE_11__().day() === 0) // Check if it is sunday
         {
            this.date_Control = new _angular_forms__WEBPACK_IMPORTED_MODULE_3__["FormControl"](moment__WEBPACK_IMPORTED_MODULE_11__());
        }
        else // If not set date to next sunday
         {
            this.date_Control = new _angular_forms__WEBPACK_IMPORTED_MODULE_3__["FormControl"](moment__WEBPACK_IMPORTED_MODULE_11__().day(0 + 7));
        }
    }
    ngOnInit() {
        this.fleaMarket.selected_places = [];
        this.getSpots();
        this.date_Control.valueChanges.subscribe(() => {
            this.getSpots();
        });
    }
    ngOnDestroy() {
        this.helper.clearNotifications();
    }
    getSpots() {
        this.loadingData = true;
        this.fleaMarket.selected_places = [];
        this.selectedSpots = [];
        this.resetSpots();
        this.fleaMarket.getSpotsForDate(this.helper.convertDateToBackendFormat(this.date_Control.value))
            .subscribe(res => {
            console.log('Spots response: ', res.reverse());
            this.spots.forEach(row => {
                row.spots.forEach(spot => {
                    const found_spot = res.find(x => x.name === spot.name);
                    if (found_spot) {
                        spot.status = found_spot.status;
                        spot.discount = found_spot.discount;
                        spot.booking_id = found_spot.booking_id;
                        spot.informalColor = found_spot.informalColor;
                    }
                });
            });
            this.loadingData = false;
        }, err => {
            console.log('Error gettings spots', err);
            this.helper.errorNoti(this.i18n.instant('ERR.error_getting_spots'));
            this.loadingData = false;
        });
    }
    /**
     * Resets the main spots view to the empty values
     */
    resetSpots() {
        this.spots = null;
        this.spots = JSON.parse(JSON.stringify(_constants_spots__WEBPACK_IMPORTED_MODULE_6__["SPOTS"])); // Reset the spots
    }
    /**
     * Opens the detailed booking page with the selected spots
     */
    addBooking() {
        this.fleaMarket.selected_places = this.selectedSpots.map(s => ({ name: s }));
        console.log('Selected', this.fleaMarket.selected_places);
        this.router.navigate(['/booking/add']);
    }
    /**
     * Adds clicked spot name to the selectedSpots array
     * @param spot
     */
    selectSpot(spot) {
        if (spot.status !== undefined && (spot.status === _constants_statuses__WEBPACK_IMPORTED_MODULE_9__["STATUS_PAID"] || spot.status === _constants_statuses__WEBPACK_IMPORTED_MODULE_9__["STATUS_PARTIALLY_PAID"])) {
            this.ls.loading = true;
            this.fleaMarket.getBookingByID(Number.parseInt(spot.booking_id, 10)).subscribe(res => {
                setTimeout(() => {
                    this.ls.loading = false;
                }, 0);
                const dialogRef = this.dialog.open(_booking_details_dialog_booking_details_dialog_component__WEBPACK_IMPORTED_MODULE_14__["BookingDetailsDialogComponent"], { data: res, autoFocus: false });
                dialogRef.afterClosed().subscribe(dialog_res => {
                    if (dialog_res && dialog_res.ok) {
                        this.getSpots();
                    }
                });
            });
        }
        else if (spot.status !== undefined &&
            (spot.status === _constants_statuses__WEBPACK_IMPORTED_MODULE_9__["STATUS_RESERVED"] || spot.status === _constants_statuses__WEBPACK_IMPORTED_MODULE_9__["STATUS_NOT_PAID"] || spot.status === _constants_statuses__WEBPACK_IMPORTED_MODULE_9__["STATUS_FREE"])) {
            this.ls.loading = true;
            this.fleaMarket.getBookingByID(Number.parseInt(spot.booking_id, 10)).subscribe(res => {
                setTimeout(() => {
                    this.ls.loading = false;
                }, 0);
                const dialogRef = this.dialog.open(_change_booking_type_dialog_change_booking_type_dialog_component__WEBPACK_IMPORTED_MODULE_16__["ChangeBookingTypeDialogComponent"], { data: res, autoFocus: false });
                dialogRef.afterClosed().subscribe(dialog_res => {
                    if (dialog_res && dialog_res.ok) {
                        this.getSpots();
                    }
                });
            });
        }
        else // Spot is not reserved or booked, mark it as selected
         {
            if (this.selectedSpots.includes(spot.name)) {
                this.selectedSpots = this.selectedSpots.filter(s => !(s === spot.name));
            }
            else {
                this.selectedSpots.push(spot.name);
            }
        }
    }
    quickBooking() {
        const data = {
            spots: this.selectedSpots,
            date: this.helper.convertDateToBackendFormat(this.date_Control.value)
        };
        const ref = this.dialog.open(_quick_booking_dialog_quick_booking_dialog_component__WEBPACK_IMPORTED_MODULE_12__["QuickBookingDialogComponent"], { autoFocus: false, data, minWidth: 600 });
        ref.afterClosed().subscribe(res => {
            console.log('Quick booking dialog res', res);
            if (res && res.ok) {
                this.selectedSpots = [];
                this.getSpots();
            }
        });
    }
    /**
     * Adds a quick reservation by passing the selected spots to the api
     * with full ticket price and RESERVED status
     */
    quickReservation() {
        const booking = {
            price: _constants_price__WEBPACK_IMPORTED_MODULE_17__["Price"].FLEA,
            discount: false,
            status: _constants_statuses__WEBPACK_IMPORTED_MODULE_9__["STATUS_RESERVED"],
            booking_dates: [{ date: this.helper.convertDateToBackendFormat(this.date_Control.value) }],
            spots: this.selectedSpots.map(s => ({ name: s }))
        };
        this.fleaMarket.createFleaMarketQuickReservation(booking).subscribe(res => {
            console.log('Successful quick reservation', res);
            this.helper.successNoti(this.i18n.instant('NOTI.reservations_added'));
            this.selectedSpots = [];
            this.getSpots();
        }, err => {
            console.log('Error with quick reservation: ', err);
            this.helper.errorNoti(this.i18n.instant('NOTI.error_saving_reservation'), err.error.message);
        });
    }
    informalReservation() {
        const data = {
            spots: this.selectedSpots,
            date: this.date_Control.value
        };
        const ref = this.dialog.open(_informal_reservation_dialog_informal_reservation_dialog_component__WEBPACK_IMPORTED_MODULE_13__["InformalReservationDialogComponent"], { data, autoFocus: false, minWidth: 400 });
        ref.afterClosed().subscribe(res => {
            console.log('Informal reservation dialog response: ', res);
            if (res && res.ok) {
                this.selectedSpots = [];
                this.getSpots();
            }
        });
    }
    print() {
        window.print();
    }
};
ScheduleViewComponent.ctorParameters = () => [
    { type: _services_nav_service__WEBPACK_IMPORTED_MODULE_2__["NavService"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_4__["Router"] },
    { type: _services_flea_market_service__WEBPACK_IMPORTED_MODULE_5__["FleaMarketService"] },
    { type: _services_helper_service__WEBPACK_IMPORTED_MODULE_7__["HelperService"] },
    { type: _ngx_translate_core__WEBPACK_IMPORTED_MODULE_8__["TranslateService"] },
    { type: _angular_material_dialog__WEBPACK_IMPORTED_MODULE_10__["MatDialog"] },
    { type: _services_loading_service__WEBPACK_IMPORTED_MODULE_15__["LoadingService"] }
];
ScheduleViewComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-schedule-view',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./schedule-view.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/schedule-view/schedule-view.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./schedule-view.component.scss */ "./src/app/components/schedule-view/schedule-view.component.scss")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_services_nav_service__WEBPACK_IMPORTED_MODULE_2__["NavService"],
        _angular_router__WEBPACK_IMPORTED_MODULE_4__["Router"],
        _services_flea_market_service__WEBPACK_IMPORTED_MODULE_5__["FleaMarketService"],
        _services_helper_service__WEBPACK_IMPORTED_MODULE_7__["HelperService"],
        _ngx_translate_core__WEBPACK_IMPORTED_MODULE_8__["TranslateService"],
        _angular_material_dialog__WEBPACK_IMPORTED_MODULE_10__["MatDialog"],
        _services_loading_service__WEBPACK_IMPORTED_MODULE_15__["LoadingService"]])
], ScheduleViewComponent);



/***/ }),

/***/ "./src/app/components/table-view/table-view.component.scss":
/*!*****************************************************************!*\
  !*** ./src/app/components/table-view/table-view.component.scss ***!
  \*****************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".wrapper {\n  margin: 16px auto;\n}\n.wrapper .filter-row {\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n}\n.wrapper .filter-row .date-filter {\n  width: 135px;\n}\n.wrapper .filter-row .status-filter {\n  width: 350px;\n}\n.wrapper .filter-row mat-form-field {\n  width: 100%;\n}\n.wrapper .table-wrapper table {\n  width: 100%;\n}\n.wrapper .table-wrapper table .paid-status {\n  display: block;\n  content: \" \";\n  width: 25px;\n  height: 25px;\n}\n.wrapper .table-wrapper table .paid {\n  background-color: green;\n}\n.wrapper .table-wrapper table .partially-paid {\n  background-color: orange;\n}\n.wrapper .table-wrapper table .not-paid {\n  background-color: red;\n}\n.wrapper .table-wrapper table .cancellation {\n  background-color: darkgray;\n}\n.wrapper .sum-report {\n  margin-top: 2em;\n}\n.wrapper .sum-report .sum-row {\n  display: flex;\n  justify-content: space-between;\n  margin: 8px 0;\n}\n.wrapper .sum-report .sum-actions {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  align-items: center;\n}\n.wrapper .sum-report .sum-actions button:not(:first-child) {\n  margin-left: 16px;\n}\n.wrapper .spiner {\n  display: flex;\n  justify-content: center;\n}\n@media print {\n  button {\n    display: none;\n  }\n\n  mat-form-field {\n    display: none;\n  }\n\n  mat-toolbar {\n    display: none;\n  }\n}\n/*# sourceMappingURL=data:application/json;base64,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 */");

/***/ }),

/***/ "./src/app/components/table-view/table-view.component.ts":
/*!***************************************************************!*\
  !*** ./src/app/components/table-view/table-view.component.ts ***!
  \***************************************************************/
/*! exports provided: TableViewComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TableViewComponent", function() { return TableViewComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _services_nav_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../services/nav.service */ "./src/app/services/nav.service.ts");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! moment */ "./node_modules/moment/moment.js");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _constants_statuses__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../constants/statuses */ "./src/app/constants/statuses.ts");
/* harmony import */ var _constants_origins__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../constants/origins */ "./src/app/constants/origins.ts");
/* harmony import */ var _angular_material_sort__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @angular/material/sort */ "./node_modules/@angular/material/esm2015/sort.js");
/* harmony import */ var _angular_material_table__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @angular/material/table */ "./node_modules/@angular/material/esm2015/table.js");
/* harmony import */ var _services_flea_market_service__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../services/flea-market.service */ "./src/app/services/flea-market.service.ts");
/* harmony import */ var _services_download_file_service__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../services/download-file.service */ "./src/app/services/download-file.service.ts");
/* harmony import */ var _services_helper_service__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../services/helper.service */ "./src/app/services/helper.service.ts");
/* harmony import */ var _ngx_translate_core__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @ngx-translate/core */ "./node_modules/@ngx-translate/core/fesm2015/ngx-translate-core.js");













let TableViewComponent = class TableViewComponent {
    constructor(nav, fleaService, downloadService, helper, i18n) {
        this.nav = nav;
        this.fleaService = fleaService;
        this.downloadService = downloadService;
        this.helper = helper;
        this.i18n = i18n;
        this.loading = false;
        this.statuses = _constants_statuses__WEBPACK_IMPORTED_MODULE_5__["STATUSES"].filter(s => s.id !== _constants_statuses__WEBPACK_IMPORTED_MODULE_5__["STATUS_INFORMAL_RESERVATION"] /*  && s.id !== STATUS_FREE */);
        this.origins = _constants_origins__WEBPACK_IMPORTED_MODULE_6__["ORIGINS"];
        this.tableData = [];
        this.numberOfPaid = 0;
        this.numberOfNotPaid = 0;
        this.numberOfPartiallyPaid = 0;
        this.numberOfStornos = 0;
        // Table
        this.dataSource = new _angular_material_table__WEBPACK_IMPORTED_MODULE_8__["MatTableDataSource"]();
        this.displayedColumns = ['id', 'spots', 'date', 'invoice', 'storno', 'status', 'total', 'customer', 'edit'];
    }
    ngOnInit() {
        this.createFormControls();
    }
    ngOnDestroy() {
        this.helper.clearNotifications();
    }
    createFormControls() {
        if (moment__WEBPACK_IMPORTED_MODULE_4__().day() === 0) // Check if it is sunday
         {
            this.date_from_Control = new _angular_forms__WEBPACK_IMPORTED_MODULE_3__["FormControl"](moment__WEBPACK_IMPORTED_MODULE_4__());
            this.date_to_Control = new _angular_forms__WEBPACK_IMPORTED_MODULE_3__["FormControl"](moment__WEBPACK_IMPORTED_MODULE_4__());
        }
        else // If not, set date to next sunday
         {
            this.date_from_Control = new _angular_forms__WEBPACK_IMPORTED_MODULE_3__["FormControl"](moment__WEBPACK_IMPORTED_MODULE_4__().day(0 + 7));
            this.date_to_Control = new _angular_forms__WEBPACK_IMPORTED_MODULE_3__["FormControl"](moment__WEBPACK_IMPORTED_MODULE_4__().day(0 + 7));
        }
        this.status_Control = new _angular_forms__WEBPACK_IMPORTED_MODULE_3__["FormControl"]([-1], [_angular_forms__WEBPACK_IMPORTED_MODULE_3__["Validators"].required]);
        this.origin_Control = new _angular_forms__WEBPACK_IMPORTED_MODULE_3__["FormControl"](this.origins[0].id, [_angular_forms__WEBPACK_IMPORTED_MODULE_3__["Validators"].required]);
        this.getData();
    }
    /**
     * Resets the filters
     */
    resetFilters() {
        this.createFormControls();
    }
    fillSource() {
        this.dataSource.data = this.tableData;
    }
    getData() {
        this.loading = true;
        this.fleaService.getTableData(this.date_from_Control.value.format('YYYY-MM-DD'), this.date_to_Control.value.format('YYYY-MM-DD'))
            .subscribe((res) => {
            console.log('Flea table:', res);
            this.data = res;
            // Filter out all informal status bookings
            this.tableData = res.data.filter((row) => !(row.status === _constants_statuses__WEBPACK_IMPORTED_MODULE_5__["STATUS_INFORMAL_RESERVATION"]));
            this.fillSource();
            this.loading = false;
            setTimeout(() => {
                this.dataSource.sort = this.sort;
            }, 0);
            this.data.data.forEach(d => {
                switch (d.status) {
                    case _constants_statuses__WEBPACK_IMPORTED_MODULE_5__["STATUS_PAID"]:
                        this.numberOfPaid++;
                        break;
                    case _constants_statuses__WEBPACK_IMPORTED_MODULE_5__["STATUS_NOT_PAID"]:
                        this.numberOfNotPaid++;
                        break;
                    case _constants_statuses__WEBPACK_IMPORTED_MODULE_5__["STATUS_PARTIALLY_PAID"]:
                        this.numberOfPartiallyPaid++;
                        break;
                    case _constants_statuses__WEBPACK_IMPORTED_MODULE_5__["STATUS_STORNO"]:
                        this.numberOfStornos++;
                        break;
                    default:
                        break;
                }
            });
        }, (err) => {
            this.helper.infoNoti(this.i18n.instant('NOTI.no_booking_in_date_range'));
            this.tableData = [];
            this.dataSource.data = [];
            this.loading = false;
            console.log(err);
        });
    }
    /**
     * Results filter for table
     */
    filterResults() {
        let selectedValue = this.status_Control.value;
        if (selectedValue.length >= 1) {
            if (selectedValue.includes(-1)) {
                // If All is selected, filter it out
                this.status_Control.setValue(selectedValue.filter(x => x !== -1));
                selectedValue = this.status_Control.value;
            }
            console.log('Selected', selectedValue);
            console.log('Table data:', this.tableData);
            this.dataSource.data = this.tableData.filter(row => selectedValue.includes(row.status));
        }
        else if (selectedValue.length < 1 && !selectedValue.includes(-1)) {
            this.status_Control.setValue([-1]);
            this.dataSource.data = this.tableData;
        }
    }
    resetStatusSelection() {
        this.status_Control.setValue([-1]);
        this.dataSource.data = this.tableData;
    }
    pdf() {
        this.fleaService.getPDF(this.date_from_Control.value.format('YYYY-MM-DD'), this.date_to_Control.value.format('YYYY-MM-DD'))
            .subscribe((res) => {
            const title = 'Flohmarket report ' + this.date_from_Control.value.format('YYYY-MM-DD') + ' ' + this.date_to_Control.value.format('YYYY-MM-DD');
            this.downloadService.download(res, title, '.pdf');
        }, (err) => {
            console.log(err);
        });
    }
    excel() {
        this.fleaService.getExcel(this.date_from_Control.value.format('YYYY-MM-DD'), this.date_to_Control.value.format('YYYY-MM-DD'))
            .subscribe((res) => {
            const title = 'Flohmarket report ' + this.date_from_Control.value.format('YYYY-MM-DD') + ' ' + this.date_to_Control.value.format('YYYY-MM-DD');
            this.downloadService.download(res, title, '.xlsx');
        }, (err) => {
            console.log(err);
        });
    }
    /**
     * print table with printer
     */
    print() {
        window.print();
    }
    getStatusColor(element) {
        const found = _constants_statuses__WEBPACK_IMPORTED_MODULE_5__["STATUSES"].find(x => x.id === element.status);
        return found ? found.color : '';
    }
    getStatusTooltip(element) {
        const found = _constants_statuses__WEBPACK_IMPORTED_MODULE_5__["STATUSES"].find(x => x.id === element.status);
        return found ? found.name : '';
    }
};
TableViewComponent.ctorParameters = () => [
    { type: _services_nav_service__WEBPACK_IMPORTED_MODULE_2__["NavService"] },
    { type: _services_flea_market_service__WEBPACK_IMPORTED_MODULE_9__["FleaMarketService"] },
    { type: _services_download_file_service__WEBPACK_IMPORTED_MODULE_10__["DownloadFileService"] },
    { type: _services_helper_service__WEBPACK_IMPORTED_MODULE_11__["HelperService"] },
    { type: _ngx_translate_core__WEBPACK_IMPORTED_MODULE_12__["TranslateService"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"])(_angular_material_sort__WEBPACK_IMPORTED_MODULE_7__["MatSort"], { static: false }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", _angular_material_sort__WEBPACK_IMPORTED_MODULE_7__["MatSort"])
], TableViewComponent.prototype, "sort", void 0);
TableViewComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-table-view',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./table-view.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/table-view/table-view.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./table-view.component.scss */ "./src/app/components/table-view/table-view.component.scss")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_services_nav_service__WEBPACK_IMPORTED_MODULE_2__["NavService"],
        _services_flea_market_service__WEBPACK_IMPORTED_MODULE_9__["FleaMarketService"],
        _services_download_file_service__WEBPACK_IMPORTED_MODULE_10__["DownloadFileService"],
        _services_helper_service__WEBPACK_IMPORTED_MODULE_11__["HelperService"],
        _ngx_translate_core__WEBPACK_IMPORTED_MODULE_12__["TranslateService"]])
], TableViewComponent);



/***/ }),

/***/ "./src/app/constants/api.def.ts":
/*!**************************************!*\
  !*** ./src/app/constants/api.def.ts ***!
  \**************************************/
/*! exports provided: ApiDefinition */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ApiDefinition", function() { return ApiDefinition; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _environments_environment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../environments/environment */ "./src/environments/environment.ts");


class ApiDefinition {
    constructor(api_domain = _environments_environment__WEBPACK_IMPORTED_MODULE_1__["environment"].apiUrl) {
        this.domain = api_domain;
        this.kino_booking = this.domain + 'booking/kino';
        this.flea_booking = this.domain + 'booking/flea';
        this.car_booking = this.domain + 'booking/car';
        this.prices = this.domain + 'prices';
        this.invoice = this.domain + 'invoice';
        this.maintenance = this.domain + 'maintenance';
    }
}
// http://autokinov2-api.q-tests.com
// https://autokinov2.q-tests.com/api/


/***/ }),

/***/ "./src/app/constants/categories.ts":
/*!*****************************************!*\
  !*** ./src/app/constants/categories.ts ***!
  \*****************************************/
/*! exports provided: CATEGORIES */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CATEGORIES", function() { return CATEGORIES; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");

const CATEGORIES = [
    { id: 1, name: 'Neuware', dicounted: false, isGroup: true },
    { id: 2, name: 'diverser Hausrat', dicounted: false },
    { id: 3, name: 'Antiquitäten', dicounted: false },
    { id: 4, name: 'Uhren', dicounted: false },
    { id: 5, name: 'Handys, Elektronik, elektronische Spiele', dicounted: false },
    { id: 6, name: 'Textil', dicounted: false },
    { id: 7, name: 'Haushalt', dicounted: false },
    { id: 8, name: 'Kosmetik', dicounted: false },
    { id: 9, name: 'Werkzeug', dicounted: false },
    { id: 10, name: 'Spielzeug', dicounted: false },
    { id: 11, name: 'Sport', dicounted: false },
    { id: 12, name: 'Automotiv', dicounted: false },
    { id: 13, name: 'Gebrauchtware', dicounted: true, isGroup: true },
    { id: 14, name: 'diverser Hausrat', dicounted: true },
    { id: 15, name: 'Antiquitäten', dicounted: true },
    { id: 16, name: 'Uhren', dicounted: true },
    { id: 17, name: 'Handys, Elektronik, elektronische Spiele', dicounted: true },
    { id: 18, name: 'Textil', dicounted: true },
    { id: 19, name: 'Haushalt', dicounted: true },
    { id: 20, name: 'Kosmetik', dicounted: true },
    { id: 21, name: 'Werkzeug', dicounted: true },
    { id: 22, name: 'Spielzeug', dicounted: true },
    { id: 23, name: 'Sport', dicounted: true },
    { id: 24, name: 'Automotiv', dicounted: true },
];
/* export const CATEGORIES = [
  {
    group_name: 'Neuware',
    items: [
      { id: 1, name: 'diverser Hausrat' },
      { id: 2, name: 'Antiquitäten' },
      { id: 3, name: 'Uhren' },
      { id: 4, name: 'Handys, Elektronik, elektronische Spiele' },
      { id: 5, name: 'Textil' },
      { id: 6, name: 'Haushalt' },
      { id: 7, name: 'Kosmetik' },
      { id: 8, name: 'Werkzeug' },
      { id: 9, name: 'Spielzeug' },
      { id: 10, name: 'Sport' },
      { id: 11, name: 'Automotiv' }
    ]
  },
  {
    group_name: 'Gebrauchtware',
    items: [
      { id: 12, name: 'diverser Hausrat' },
      { id: 13, name: 'Antiquitäten' },
      { id: 14, name: 'Uhren' },
      { id: 15, name: 'Handys, Elektronik, elektronische Spiele' },
      { id: 16, name: 'Textil' },
      { id: 17, name: 'Haushalt' },
      { id: 18, name: 'Kosmetik' },
      { id: 19, name: 'Werkzeug' },
      { id: 20, name: 'Spielzeug' },
      { id: 21, name: 'Sport' },
      { id: 22, name: 'Automotiv' }
    ]
  }
]; */


/***/ }),

/***/ "./src/app/constants/origins.ts":
/*!**************************************!*\
  !*** ./src/app/constants/origins.ts ***!
  \**************************************/
/*! exports provided: ORIGINS */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ORIGINS", function() { return ORIGINS; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");

const ORIGINS = [
    { id: 0, name: 'ORIGIN.all' },
    { id: 1, name: 'ORIGIN.internet' },
    { id: 2, name: 'ORIGIN.local' }
];


/***/ }),

/***/ "./src/app/constants/price.ts":
/*!************************************!*\
  !*** ./src/app/constants/price.ts ***!
  \************************************/
/*! exports provided: Price */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Price", function() { return Price; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");

/**
 * Class that holds the ticket price values
 */
class Price {
}
Price.FLEA = 37;
Price.FLEA_DISCOUNT = 27;
Price.CAR = 25;
Price.CAR_DISCOUNT = 15;
Price.KINO = 8;
Price.KINO_DISCOUNT = 5;


/***/ }),

/***/ "./src/app/constants/spots.ts":
/*!************************************!*\
  !*** ./src/app/constants/spots.ts ***!
  \************************************/
/*! exports provided: SPOTS */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SPOTS", function() { return SPOTS; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");

const SPOTS = [
    {
        spots: [
            { name: 'CA1', class: 'spot container-spot' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'M1', class: 'spot' },
            { name: 'M2', class: 'spot' },
            { name: 'M3', class: 'spot' },
            { name: 'M4', class: 'spot' },
            { name: 'M5', class: 'spot' },
            { name: 'M6', class: 'spot' },
            { name: 'M7', class: 'spot' },
            { name: 'M8', class: 'spot' },
            { name: 'M9', class: 'spot' },
            { name: 'M10', class: 'spot' },
            { name: 'M11', class: 'spot' },
            { name: 'M12', class: 'spot' },
            { name: 'M13', class: 'spot' },
            { name: 'M14', class: 'spot' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
        ]
    },
    {
        spots: [
            { name: 'X', class: 'spot-hidden spot-aisle' },
        ]
    },
    {
        spots: [
            { name: 'CA2', class: 'spot container-spot' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'L1', class: 'spot' },
            { name: 'L2', class: 'spot' },
            { name: 'L3', class: 'spot' },
            { name: 'L4', class: 'spot' },
            { name: 'L5', class: 'spot' },
            { name: 'L6', class: 'spot' },
            { name: 'L7', class: 'spot' },
            { name: 'L8', class: 'spot' },
            { name: 'L9', class: 'spot' },
            { name: 'L10', class: 'spot' },
            { name: 'L11', class: 'spot' },
            { name: 'L12', class: 'spot' },
            { name: 'L13', class: 'spot' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
        ]
    },
    {
        spots: [
            // { name: 'CA2', class: 'spot container-spot' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'K1', class: 'spot' },
            { name: 'K2', class: 'spot' },
            { name: 'K3', class: 'spot' },
            { name: 'K4', class: 'spot' },
            { name: 'K5', class: 'spot' },
            { name: 'K6', class: 'spot' },
            { name: 'K7', class: 'spot' },
            { name: 'K8', class: 'spot' },
            { name: 'K9', class: 'spot' },
            { name: 'K10', class: 'spot' },
            { name: 'K11', class: 'spot' },
            { name: 'K12', class: 'spot' },
            { name: 'K13', class: 'spot' },
            { name: 'K14', class: 'spot' },
            { name: 'K15', class: 'spot' },
            { name: 'K16', class: 'spot' },
            { name: 'K17', class: 'spot' },
            { name: 'K18', class: 'spot' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
        ]
    },
    {
        spots: [
            { name: 'CA3', class: 'spot container-spot move-up' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
        ]
    },
    {
        spots: [
            { name: 'CA4', class: 'spot container-spot move-up' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'J1', class: 'spot' },
            { name: 'J2', class: 'spot' },
            { name: 'J3', class: 'spot' },
            { name: 'J4', class: 'spot' },
            { name: 'J5', class: 'spot' },
            { name: 'J6', class: 'spot' },
            { name: 'J7', class: 'spot' },
            { name: 'J8', class: 'spot' },
            { name: 'J9', class: 'spot' },
            { name: 'J10', class: 'spot' },
            { name: 'J11', class: 'spot' },
            { name: 'J12', class: 'spot' },
            { name: 'W1', class: 'spot' },
            { name: 'W2', class: 'spot' },
            { name: 'W3', class: 'spot' },
            { name: 'W4', class: 'spot' },
            { name: 'W5', class: 'spot' },
            { name: 'W6', class: 'spot' },
            { name: 'W7', class: 'spot' },
            { name: 'W8', class: 'spot' },
            { name: 'W9', class: 'spot' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
        ]
    },
    {
        spots: [
            { name: 'CA5  ', class: 'spot container-spot move-down' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'I1', class: 'spot' },
            { name: 'I2', class: 'spot' },
            { name: 'I3', class: 'spot' },
            { name: 'I4', class: 'spot' },
            { name: 'I5', class: 'spot' },
            { name: 'I6', class: 'spot' },
            { name: 'I7', class: 'spot' },
            { name: 'I8', class: 'spot' },
            { name: 'I9', class: 'spot' },
            { name: 'I10', class: 'spot' },
            { name: 'I11', class: 'spot' },
            { name: 'I12', class: 'spot' },
            { name: 'I13', class: 'spot' },
            { name: 'V1', class: 'spot' },
            { name: 'V2', class: 'spot' },
            { name: 'V3', class: 'spot' },
            { name: 'V4', class: 'spot' },
            { name: 'V5', class: 'spot' },
            { name: 'V6', class: 'spot' },
            { name: 'V7', class: 'spot' },
            { name: 'V8', class: 'spot' },
            { name: 'V9', class: 'spot' },
            { name: 'V10', class: 'spot' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
        ]
    },
    {
        spots: [
            { name: 'CA6', class: 'spot container-spot move-down' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
        ]
    },
    {
        spots: [
            // { name: 'CA7', class: 'spot container-spot' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'H1', class: 'spot' },
            { name: 'H2', class: 'spot' },
            { name: 'H3', class: 'spot' },
            { name: 'H4', class: 'spot' },
            { name: 'H5', class: 'spot' },
            { name: 'H6', class: 'spot' },
            { name: 'H7', class: 'spot' },
            { name: 'H8', class: 'spot' },
            { name: 'H9', class: 'spot' },
            { name: 'H10', class: 'spot' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'U1', class: 'spot' },
            { name: 'U2', class: 'spot' },
            { name: 'U3', class: 'spot' },
            { name: 'U4', class: 'spot' },
            { name: 'U5', class: 'spot' },
            { name: 'U6', class: 'spot' },
            { name: 'U7', class: 'spot' },
            { name: 'U8', class: 'spot' },
            { name: 'U9', class: 'spot' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
        ]
    },
    {
        spots: [
            { name: 'CA7', class: 'spot container-spot' },
            // { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'G1', class: 'spot' },
            { name: 'G2', class: 'spot' },
            { name: 'G3', class: 'spot' },
            { name: 'G4', class: 'spot' },
            { name: 'G5', class: 'spot' },
            { name: 'G6', class: 'spot' },
            { name: 'G7', class: 'spot' },
            { name: 'G8', class: 'spot' },
            { name: 'G9', class: 'spot' },
            { name: 'G10', class: 'spot' },
            { name: 'G11', class: 'spot' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'T1', class: 'spot' },
            { name: 'T2', class: 'spot' },
            { name: 'T3', class: 'spot' },
            { name: 'T4', class: 'spot' },
            { name: 'T5', class: 'spot' },
            { name: 'T6', class: 'spot' },
            { name: 'T7', class: 'spot' },
            { name: 'T8', class: 'spot' },
            { name: 'T9', class: 'spot' },
            { name: 'T10', class: 'spot' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
        ]
    },
    {
        spots: [
            { name: 'CA8', class: 'spot container-spot' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
        ]
    },
    {
        spots: [
            { name: 'Z4', class: 'spot' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'F1', class: 'spot' },
            { name: 'F2', class: 'spot' },
            { name: 'F3', class: 'spot' },
            { name: 'F4', class: 'spot' },
            { name: 'F5', class: 'spot' },
            { name: 'F6', class: 'spot' },
            { name: 'F7', class: 'spot' },
            { name: 'F8', class: 'spot' },
            { name: 'F9', class: 'spot' },
            { name: 'F10', class: 'spot' },
            { name: 'F11', class: 'spot' },
            { name: 'F12', class: 'spot' },
            { name: 'F13', class: 'spot' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'S1', class: 'spot' },
            { name: 'S2', class: 'spot' },
            { name: 'S3', class: 'spot' },
            { name: 'S4', class: 'spot' },
            { name: 'S5', class: 'spot' },
            { name: 'S6', class: 'spot' },
            { name: 'S7', class: 'spot' },
            { name: 'S8', class: 'spot' },
            { name: 'S9', class: 'spot' },
            { name: 'S10', class: 'spot' },
            { name: 'S11', class: 'spot' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
        ]
    },
    {
        spots: [
            { name: 'Z3', class: 'spot' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'E1', class: 'spot' },
            { name: 'E2', class: 'spot' },
            { name: 'E3', class: 'spot' },
            { name: 'E4', class: 'spot' },
            { name: 'E5', class: 'spot' },
            { name: 'E6', class: 'spot' },
            { name: 'E7', class: 'spot' },
            { name: 'E8', class: 'spot' },
            { name: 'E9', class: 'spot' },
            { name: 'E10', class: 'spot' },
            { name: 'E11', class: 'spot' },
            { name: 'E12', class: 'spot' },
            { name: 'E13', class: 'spot' },
            { name: 'E14', class: 'spot' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'R1', class: 'spot' },
            { name: 'R2', class: 'spot' },
            { name: 'R3', class: 'spot' },
            { name: 'R4', class: 'spot' },
            { name: 'R5', class: 'spot' },
            { name: 'R6', class: 'spot' },
            { name: 'R7', class: 'spot' },
            { name: 'R8', class: 'spot' },
            { name: 'R9', class: 'spot' },
            { name: 'R10', class: 'spot' },
            { name: 'R11', class: 'spot' },
            { name: 'R12', class: 'spot' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
        ]
    },
    {
        spots: [
            { name: 'Z2', class: 'spot' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
        ]
    },
    {
        spots: [
            { name: 'Z1', class: 'spot' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'D1', class: 'spot' },
            { name: 'D2', class: 'spot' },
            { name: 'D3', class: 'spot' },
            { name: 'D4', class: 'spot' },
            { name: 'D5', class: 'spot' },
            { name: 'D6', class: 'spot' },
            { name: 'D7', class: 'spot' },
            { name: 'D8', class: 'spot' },
            { name: 'D9', class: 'spot' },
            { name: 'D10', class: 'spot' },
            { name: 'D11', class: 'spot' },
            { name: 'D12', class: 'spot' },
            { name: 'D13', class: 'spot' },
            { name: 'D14', class: 'spot' },
            { name: 'D15', class: 'spot' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'Q1', class: 'spot' },
            { name: 'Q2', class: 'spot' },
            { name: 'Q3', class: 'spot' },
            { name: 'Q4', class: 'spot' },
            { name: 'Q5', class: 'spot' },
            { name: 'Q6', class: 'spot' },
            { name: 'Q7', class: 'spot' },
            { name: 'Q8', class: 'spot' },
            { name: 'Q9', class: 'spot' },
            { name: 'Q10', class: 'spot' },
            { name: 'Q11', class: 'spot' },
            { name: 'Q12', class: 'spot' },
            { name: 'Q13', class: 'spot' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
        ]
    },
    {
        spots: [
            { name: 'CA9', class: 'spot container-spot' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'C1', class: 'spot' },
            { name: 'C2', class: 'spot' },
            { name: 'C3', class: 'spot' },
            { name: 'C4', class: 'spot' },
            { name: 'C5', class: 'spot' },
            { name: 'C6', class: 'spot' },
            { name: 'C7', class: 'spot' },
            { name: 'C8', class: 'spot' },
            { name: 'C9', class: 'spot' },
            { name: 'C10', class: 'spot' },
            { name: 'C11', class: 'spot' },
            { name: 'C12', class: 'spot' },
            { name: 'C13', class: 'spot' },
            { name: 'C14', class: 'spot' },
            { name: 'C15', class: 'spot' },
            { name: 'C16', class: 'spot' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'P1', class: 'spot' },
            { name: 'P2', class: 'spot' },
            { name: 'P3', class: 'spot' },
            { name: 'P4', class: 'spot' },
            { name: 'P5', class: 'spot' },
            { name: 'P6', class: 'spot' },
            { name: 'P7', class: 'spot' },
            { name: 'P8', class: 'spot' },
            { name: 'P9', class: 'spot' },
            { name: 'P10', class: 'spot' },
            { name: 'P11', class: 'spot' },
            { name: 'P12', class: 'spot' },
            { name: 'P13', class: 'spot' },
            { name: 'P14', class: 'spot' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
        ]
    },
    {
        spots: [
            { name: 'X', class: 'spot-hidden spot-aisle' },
        ]
    },
    {
        spots: [
            { name: 'B1', class: 'spot' },
            { name: 'B2', class: 'spot' },
            { name: 'B3', class: 'spot' },
            { name: 'B4', class: 'spot' },
            { name: 'B5', class: 'spot' },
            { name: 'B6', class: 'spot' },
            { name: 'B7', class: 'spot' },
            { name: 'B8', class: 'spot' },
            { name: 'B9', class: 'spot' },
            { name: 'B10', class: 'spot' },
            { name: 'B11', class: 'spot' },
            { name: 'B12', class: 'spot' },
            { name: 'B13', class: 'spot' },
            { name: 'B14', class: 'spot' },
            { name: 'B15', class: 'spot' },
            { name: 'B16', class: 'spot' },
            { name: 'B17', class: 'spot' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'O1', class: 'spot' },
            { name: 'O2', class: 'spot' },
            { name: 'O3', class: 'spot' },
            { name: 'O4', class: 'spot' },
            { name: 'O5', class: 'spot' },
            { name: 'O6', class: 'spot' },
            { name: 'O7', class: 'spot' },
            { name: 'O8', class: 'spot' },
            { name: 'O9', class: 'spot' },
            { name: 'O10', class: 'spot' },
            { name: 'O11', class: 'spot' },
            { name: 'O12', class: 'spot' },
            { name: 'O13', class: 'spot' },
            { name: 'O14', class: 'spot' },
            { name: 'O15', class: 'spot' },
        ]
    },
    {
        spots: [
            { name: 'A1', class: 'spot' },
            { name: 'A2', class: 'spot' },
            { name: 'A3', class: 'spot' },
            { name: 'A4', class: 'spot' },
            { name: 'A5', class: 'spot' },
            { name: 'A6', class: 'spot' },
            { name: 'A7', class: 'spot' },
            { name: 'A8', class: 'spot' },
            { name: 'A9', class: 'spot' },
            { name: 'A10', class: 'spot' },
            { name: 'A11', class: 'spot' },
            { name: 'A12', class: 'spot' },
            { name: 'A13', class: 'spot' },
            { name: 'A14', class: 'spot' },
            { name: 'A15', class: 'spot' },
            { name: 'A16', class: 'spot' },
            { name: 'A17', class: 'spot' },
            { name: 'A18', class: 'spot' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'N1', class: 'spot' },
            { name: 'N2', class: 'spot' },
            { name: 'N3', class: 'spot' },
            { name: 'N4', class: 'spot' },
            { name: 'N5', class: 'spot' },
            { name: 'N6', class: 'spot' },
            { name: 'N7', class: 'spot' },
            { name: 'N8', class: 'spot' },
            { name: 'N9', class: 'spot' },
            { name: 'N10', class: 'spot' },
            { name: 'N11', class: 'spot' },
            { name: 'N12', class: 'spot' },
            { name: 'N13', class: 'spot' },
            { name: 'N14', class: 'spot' },
            { name: 'N15', class: 'spot' },
            { name: 'N16', class: 'spot' },
        ]
    },
    {
        spots: [
            { name: 'X', class: 'spot-hidden spot-aisle' },
        ]
    },
    {
        spots: [
            { name: 'X1', class: 'spot' },
            { name: 'X2', class: 'spot' },
            { name: 'X3', class: 'spot' },
            { name: 'X4', class: 'spot' },
            { name: 'X5', class: 'spot' },
            { name: 'X6', class: 'spot' },
            { name: 'X7', class: 'spot' },
            { name: 'X8', class: 'spot' },
            { name: 'X9', class: 'spot' },
            { name: 'X10', class: 'spot' },
            { name: 'X11', class: 'spot' },
            { name: 'X12', class: 'spot' },
            { name: 'X13', class: 'spot' },
            { name: 'X14', class: 'spot' },
            { name: 'X15', class: 'spot' },
            { name: 'X16', class: 'spot' },
            { name: 'X17', class: 'spot' },
            { name: 'X18', class: 'spot' },
            { name: 'X19', class: 'spot' },
            { name: 'X20', class: 'spot' },
            { name: 'X21', class: 'spot' },
            { name: 'X22', class: 'spot' },
            { name: 'X23', class: 'spot' },
            { name: 'X24', class: 'spot' },
            { name: 'X25', class: 'spot' },
            { name: 'X26', class: 'spot' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'Y1', class: 'spot' },
            { name: 'Y2', class: 'spot' },
            { name: 'Y3', class: 'spot' },
            { name: 'Y4', class: 'spot' },
            { name: 'Y5', class: 'spot' },
            { name: 'Y6', class: 'spot' },
            { name: 'Y7', class: 'spot' },
            { name: 'Y8', class: 'spot' },
            { name: 'Y9', class: 'spot' },
            { name: 'Y10', class: 'spot' },
            { name: 'Y11', class: 'spot' },
            { name: 'Y12', class: 'spot' },
            { name: 'Y13', class: 'spot' },
            { name: 'Y14', class: 'spot' },
            { name: 'Y15', class: 'spot' },
            { name: 'Y16', class: 'spot' },
            { name: 'Y17', class: 'spot' },
        ]
    },
    {
        spots: [
            { name: 'X', class: 'spot-hidden spot-aisle' },
        ]
    },
    {
        spots: [
            { name: 'X', class: 'spot-hidden spot-aisle' },
        ]
    },
    {
        spots: [
            { name: 'CC10', class: 'spot container-spot' },
            { name: 'CC9', class: 'spot container-spot' },
            { name: 'CC8', class: 'spot container-spot' },
            { name: 'CC7', class: 'spot container-spot' },
            { name: 'CC6', class: 'spot container-spot' },
            { name: 'CC5', class: 'spot container-spot' },
            { name: 'CC4', class: 'spot container-spot' },
            { name: 'CC3', class: 'spot container-spot' },
            { name: 'CC2', class: 'spot container-spot' },
            { name: 'CC1', class: 'spot container-spot' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
        ]
    },
    {
        spots: [
            { name: 'X', class: 'spot-hidden spot-aisle' },
        ]
    },
    {
        spots: [
            { name: 'CA10', class: 'spot container-spot' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'CA11', class: 'spot container-spot' },
            { name: 'CA12', class: 'spot container-spot' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
            { name: 'X', class: 'spot-hidden' },
        ]
    }
];


/***/ }),

/***/ "./src/app/constants/statuses.ts":
/*!***************************************!*\
  !*** ./src/app/constants/statuses.ts ***!
  \***************************************/
/*! exports provided: STATUS_RESERVED, STATUS_NOT_PAID, STATUS_PARTIALLY_PAID, STATUS_PAID, STATUS_INFORMAL_RESERVATION, STATUS_STORNO, STATUS_PENDING, STATUS_FREE, STATUS_ALL, STATUSES */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STATUS_RESERVED", function() { return STATUS_RESERVED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STATUS_NOT_PAID", function() { return STATUS_NOT_PAID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STATUS_PARTIALLY_PAID", function() { return STATUS_PARTIALLY_PAID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STATUS_PAID", function() { return STATUS_PAID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STATUS_INFORMAL_RESERVATION", function() { return STATUS_INFORMAL_RESERVATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STATUS_STORNO", function() { return STATUS_STORNO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STATUS_PENDING", function() { return STATUS_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STATUS_FREE", function() { return STATUS_FREE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STATUS_ALL", function() { return STATUS_ALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STATUSES", function() { return STATUSES; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");

const STATUS_RESERVED = 0;
const STATUS_NOT_PAID = 1;
const STATUS_PARTIALLY_PAID = 2;
const STATUS_PAID = 3;
const STATUS_INFORMAL_RESERVATION = 4;
const STATUS_STORNO = 5;
const STATUS_PENDING = 6;
const STATUS_FREE = 7;
const STATUS_ALL = -1;
const STATUSES = [
    { id: STATUS_PAID, name: 'STATUS.paid', color: 'green' },
    { id: STATUS_PARTIALLY_PAID, name: 'STATUS.partially_paid', color: 'orange' },
    { id: STATUS_NOT_PAID, name: 'STATUS.not_paid', color: 'red' },
    { id: STATUS_STORNO, name: 'STATUS.cancellation', color: 'black' },
    { id: STATUS_INFORMAL_RESERVATION, name: 'STATUS.informal_reservation', color: '#cc6699' },
    { id: STATUS_RESERVED, name: 'STATUS.reserved', color: 'darkgray' },
    { id: STATUS_FREE, name: 'STATUS.free', color: 'yellow' }
];


/***/ }),

/***/ "./src/app/guards/auth.guard.ts":
/*!**************************************!*\
  !*** ./src/app/guards/auth.guard.ts ***!
  \**************************************/
/*! exports provided: AuthGuard */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AuthGuard", function() { return AuthGuard; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _services_auth_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../services/auth.service */ "./src/app/services/auth.service.ts");




let AuthGuard = class AuthGuard {
    constructor(router, auth) {
        this.router = router;
        this.auth = auth;
    }
    canActivate(next, state) {
        if (this.auth.isLoggedIn()) {
            return true;
        }
        else {
            this.redirectURL = state.url;
            this.router.navigate(['/login']);
            return false;
        }
    }
};
AuthGuard.ctorParameters = () => [
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"] },
    { type: _services_auth_service__WEBPACK_IMPORTED_MODULE_3__["AuthService"] }
];
AuthGuard = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"],
        _services_auth_service__WEBPACK_IMPORTED_MODULE_3__["AuthService"]])
], AuthGuard);



/***/ }),

/***/ "./src/app/services/auth.service.ts":
/*!******************************************!*\
  !*** ./src/app/services/auth.service.ts ***!
  \******************************************/
/*! exports provided: AuthService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AuthService", function() { return AuthService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var _constants_api_def__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../constants/api.def */ "./src/app/constants/api.def.ts");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");





let AuthService = class AuthService {
    constructor(http, router) {
        this.http = http;
        this.router = router;
        this.api = new _constants_api_def__WEBPACK_IMPORTED_MODULE_3__["ApiDefinition"]();
        this.getData();
    }
    isLoggedIn() {
        return this.user ? true : false;
    }
    login(username, password) {
        return this.http.post(this.api.domain + 'login', JSON.stringify({ username, password }));
    }
    logout() {
        this.user = null;
        this.router.navigate(['/login']);
    }
    setData(user) {
        this.user = user;
        // localStorage.setItem('autokino_user', JSON.stringify(this.user));
    }
    getData() {
        // this.user = JSON.parse(localStorage.getItem('autokino_user'));
    }
};
AuthService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpClient"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_4__["Router"] }
];
AuthService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpClient"],
        _angular_router__WEBPACK_IMPORTED_MODULE_4__["Router"]])
], AuthService);



/***/ }),

/***/ "./src/app/services/car-market.service.ts":
/*!************************************************!*\
  !*** ./src/app/services/car-market.service.ts ***!
  \************************************************/
/*! exports provided: CarMarketService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CarMarketService", function() { return CarMarketService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _constants_api_def__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../constants/api.def */ "./src/app/constants/api.def.ts");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");




let CarMarketService = class CarMarketService {
    constructor(http) {
        this.http = http;
        this.api = new _constants_api_def__WEBPACK_IMPORTED_MODULE_2__["ApiDefinition"]();
    }
    /**
     * Get car market table data
     * /booking/car
     * @param fromDate Start date YYYY-MM-DD format
     * @param toDate End date YYYY-MM-DD format
     */
    getTableData(fromDate, toDate) {
        const params = { fromDate, toDate };
        return this.http.get(this.api.car_booking + '/table', { params });
    }
    /**
     * GET /booking/car/pdf
     * gets a pdf file
     * @param fromDate Start date YYYY-MM-DD format
     * @param toDate End date YYYY-MM-DD format
     * @returns pdf file
     */
    getPDF(fromDate, toDate) {
        const params = { fromDate, toDate };
        return this.http.get(this.api.car_booking + '/pdf', { params, responseType: 'blob' });
    }
    /**
     * GET /booking/car/excel
     * gets a excel file
     * @param fromDate Start date YYYY-MM-DD format
     * @param toDate End date YYYY-MM-DD format
     * @returns excel file
     */
    getExcel(fromDate, toDate) {
        const params = { fromDate, toDate };
        return this.http.get(this.api.car_booking + '/excel', { params, responseType: 'blob' });
    }
    /**
     * Create a new Carmarket Booking
     * @param body CarMarketBookingModel
     */
    createCarMarketBooking(body) {
        return this.http.post(this.api.car_booking, body);
    }
    /**
     * Get booking details
     *
     * /booking/car/{id}/details
     * @param id
     */
    getBookingByID(id) {
        return this.http.get(this.api.car_booking + `/${id}/details`);
    }
    /**
     * Update car market booking
     *
     * PUT /booking/car
     * @param booking
     */
    updateCarMarketBooking(booking) {
        return this.http.put(this.api.car_booking, booking);
    }
    /**
     * Uploads an image
     * @param img
     */
    uploadImage(img) {
        return this.http.post(this.api.car_booking + '/image', { img });
    }
    /**
     * Create car market invoice
     * @param booking_id
     * @param amount_given
     */
    createCarMarketInvoice(booking_id, amount_given) {
        return this.http.post(this.api.car_booking + `/${booking_id}/invoice`, { amount_given });
    }
    stornoCarMarketBooking(booking_id) {
        return this.http.post(this.api.car_booking + `/${booking_id}/storno`, { booking_id });
    }
    /**
     * Gets the invoice details
     * @param invoice_id
     */
    getCarInvoice(invoice_id) {
        return this.http.get(this.api.invoice + `/${invoice_id}/details`);
    }
};
CarMarketService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"] }
];
CarMarketService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"]])
], CarMarketService);



/***/ }),

/***/ "./src/app/services/download-file.service.ts":
/*!***************************************************!*\
  !*** ./src/app/services/download-file.service.ts ***!
  \***************************************************/
/*! exports provided: DownloadFileService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DownloadFileService", function() { return DownloadFileService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let DownloadFileService = class DownloadFileService {
    constructor() { }
    /**
     * Function to download a file
     * @param file Blob
     * @param title 'example'
     * @param extension '.pdf'
     */
    download(file, title, extension) {
        // It is necessary to create a new blob object with mime-type explicitly set
        // otherwise only Chrome works like it should
        const newBlob = new Blob([file], { type: file.type });
        // IE doesn't allow using a blob object directly as link href
        // instead it is necessary to use msSaveOrOpenBlob
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(newBlob);
            return;
        }
        // For other browsers:
        // Create a link pointing to the ObjectURL containing the blob.
        const data = window.URL.createObjectURL(newBlob);
        const link = document.createElement('a');
        link.href = data;
        link.download = title + extension;
        link.click();
        setTimeout(() => {
            // For Firefox it is necessary to delay revoking the ObjectURL
            window.URL.revokeObjectURL(data);
        }, 100);
    }
};
DownloadFileService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [])
], DownloadFileService);



/***/ }),

/***/ "./src/app/services/flea-market.service.ts":
/*!*************************************************!*\
  !*** ./src/app/services/flea-market.service.ts ***!
  \*************************************************/
/*! exports provided: FleaMarketService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FleaMarketService", function() { return FleaMarketService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _constants_api_def__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../constants/api.def */ "./src/app/constants/api.def.ts");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");




let FleaMarketService = class FleaMarketService {
    constructor(http) {
        this.http = http;
        this.api = new _constants_api_def__WEBPACK_IMPORTED_MODULE_2__["ApiDefinition"]();
    }
    /**
     * Get flea market table data
     * /booking/flea
     * @param fromDate Start date YYYY-MM-DD format
     * @param toDate End date YYYY-MM-DD format
     */
    getTableData(fromDate, toDate) {
        const params = { fromDate, toDate };
        return this.http.get(this.api.flea_booking + '/table', { params });
    }
    /**
     * GET /booking/flea/pdf
     * gets a pdf file
     * @param fromDate Start date YYYY-MM-DD format
     * @param toDate End date YYYY-MM-DD format
     * @returns pdf file
     */
    getPDF(fromDate, toDate) {
        const params = { fromDate, toDate };
        return this.http.get(this.api.flea_booking + '/pdf', { params, responseType: 'blob' });
    }
    /**
     * GET /booking/flea/excel
     * gets a excel file
     * @param fromDate Start date YYYY-MM-DD format
     * @param toDate End date YYYY-MM-DD format
     * @returns excel file
     */
    getExcel(fromDate, toDate) {
        const params = { fromDate, toDate };
        return this.http.get(this.api.flea_booking + '/excel', { params, responseType: 'blob' });
    }
    /**
     * Get booking details
     *
     * GET /booking/flea/{id}/details
     * @param id
     */
    getBookingByID(id) {
        return this.http.get(this.api.flea_booking + `/${id}/details`);
    }
    /**
     * Create a new new invoice for FleaMarketBooking Booking
     * @param id Booking id
     * @param amount_given
     */
    createFleaMarketInvoice(id, amount_given) {
        return this.http.post(this.api.flea_booking + `/${id}/invoice`, { amount_given });
    }
    /**
     * Storno a FleaMarketBooking Booking and create storno invoice
     * @param id Booking id
     */
    stornoFleaMarketBooking(id) {
        return this.http.post(this.api.flea_booking + `/${id}/storno`, {});
    }
    /**
     * Create a new Fleamarket Booking
     * @param booking
     */
    createFleaMarketBooking(booking) {
        return this.http.post(this.api.flea_booking, booking);
    }
    /**
     * Create quick Booking
     * @param body
     */
    createFleaMarketQuickBooking(booking) {
        return this.http.post(this.api.flea_booking, booking);
    }
    /**
     * Create quick reservation
     * @param body
     */
    createFleaMarketQuickReservation(booking) {
        booking.discount = false;
        return this.http.post(this.api.flea_booking, booking);
    }
    /**
     * Update Fleamarket Booking
     * @param booking
     */
    updateFleaMarketBooking(booking) {
        return this.http.put(this.api.flea_booking, booking);
    }
    /**
     * Check if spots are available for given dates
     * @param spots
     * @param date Format YYYY-MM-DD
     */
    checkSpotAvailability(spots, dates) {
        return this.http.post(this.api.flea_booking + '/spots/available', { spot_names: spots, booking_dates: dates });
    }
    /**
     * Gets the spots for a given date and their statuses
     * @param date Format YYYY-MM-DD
     */
    getSpotsForDate(date) {
        return this.http.get(this.api.flea_booking + `/${date}/spots`);
    }
    /**
     * Gets the invoice details
     * @param invoice_id
     */
    getFleaInvoice(invoice_id) {
        return this.http.get(this.api.invoice + `/${invoice_id}/details`);
    }
    /**
     * Deletes flea market booking
     *
     * /booking/flea/{id}/booking
     * @param booking_id
     */
    deleteBooking(booking_id) {
        return this.http.delete(this.api.flea_booking + `/${booking_id}/booking`);
    }
    /**
     * Removes the selected spots from the informal booking
     * @param spots
     */
    removeInformalSpot(spots) {
        return this.http.put(this.api.flea_booking + '/informal', { spots: spots });
    }
};
FleaMarketService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"] }
];
FleaMarketService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"]])
], FleaMarketService);



/***/ }),

/***/ "./src/app/services/helper.service.ts":
/*!********************************************!*\
  !*** ./src/app/services/helper.service.ts ***!
  \********************************************/
/*! exports provided: HelperService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HelperService", function() { return HelperService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var angular2_notifications__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! angular2-notifications */ "./node_modules/angular2-notifications/angular2-notifications.umd.js");
/* harmony import */ var angular2_notifications__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(angular2_notifications__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! moment */ "./node_modules/moment/moment.js");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_3__);




let HelperService = class HelperService {
    constructor(notify) {
        this.notify = notify;
        moment__WEBPACK_IMPORTED_MODULE_3__["locale"]('de');
    }
    clearNotifications() {
        this.notify.remove();
    }
    /**
     * Creates a succes notification
     * @param title Title of the notification
     * @param content Content of the notification
     * @param override Settings to override default values
     */
    successNoti(title, content, override) {
        this.notify.success(title, content, override);
    }
    /**
     * Creates an error notification
     * @param title Title of the notification
     * @param content Content of the notification
     * @param override Settings to override default values
     */
    errorNoti(title, content, override) {
        this.notify.error(title, content, override);
    }
    /**
     * Creates a warning notification
     * @param title Title of the notification
     * @param content Content of the notification
     * @param override Settings to override default values
     */
    warningNoti(title, content, override) {
        this.notify.warn(title, content, override);
    }
    /**
     * Creates a informational notification
     * @param title Title of the notification
     * @param content Content of the notification
     * @param override Settings to override default values
     */
    infoNoti(title, content, override) {
        this.notify.info(title, content, override);
    }
    /**
     * Converts a date to backend format
     * @param date
     * @returns string in YYYY-MM-DD format
     */
    convertDateToBackendFormat(date) {
        return moment__WEBPACK_IMPORTED_MODULE_3__(date).format('YYYY-MM-DD');
    }
    /**
     * Converts the date in string format to a moment object
     * @param date
     * @param format dddd, DD.MM.YYYY
     */
    getMomentFromString(date, format = 'dddd, DD.MM.YYYY') {
        return moment__WEBPACK_IMPORTED_MODULE_3__(date, format, 'de', true);
    }
    /**
     * Converts the moment object to a string format
     * @param date
     * @param format dddd, DD.MM.YYYY
     */
    getStringDateFromMoment(date, format = 'dddd, DD.MM.YYYY') {
        return moment__WEBPACK_IMPORTED_MODULE_3__(date).locale('de').format(format);
    }
    /**
     * Get string array of booking dates to send to backend
     *
     * @param formGroupArray
     */
    getBookingDates(formGroupArray) {
        const booking_dates = [];
        formGroupArray.forEach(date => {
            const mom_date = this.getMomentFromString(date.controls.date.value);
            booking_dates.push({ date: mom_date.format('YYYY-MM-DD') });
        });
        return booking_dates;
    }
    /**
     * Returns a base64 image from provided url
     * @param imageUrl
     * @returns Promise
     */
    getBase64ImageFromUrl(imageUrl) {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            const res = yield fetch(imageUrl);
            const blob = yield res.blob();
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.addEventListener('load', function () {
                    resolve(reader.result);
                }, false);
                reader.onerror = () => {
                    return reject(this);
                };
                reader.readAsDataURL(blob);
            });
        });
    }
    /**
     * Get ticket price based on total amount of price and number of spots and weeks reserved
     *
     * example: 10€ total for 2 spots and 1 week = 5€ per ticket
     *
     * @param total
     * @param totalSpots
     * @param totalWeeks
     */
    getTicketPriceBasedOnTotal(total, totalSpots, totalWeeks) {
        return Number.parseFloat((total / (totalSpots * totalWeeks)).toFixed(2));
    }
};
HelperService.ctorParameters = () => [
    { type: angular2_notifications__WEBPACK_IMPORTED_MODULE_2__["NotificationsService"] }
];
HelperService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [angular2_notifications__WEBPACK_IMPORTED_MODULE_2__["NotificationsService"]])
], HelperService);



/***/ }),

/***/ "./src/app/services/kino-booking.service.ts":
/*!**************************************************!*\
  !*** ./src/app/services/kino-booking.service.ts ***!
  \**************************************************/
/*! exports provided: KinoBookingService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "KinoBookingService", function() { return KinoBookingService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _constants_api_def__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../constants/api.def */ "./src/app/constants/api.def.ts");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");




let KinoBookingService = class KinoBookingService {
    constructor(http) {
        this.http = http;
        this.api = new _constants_api_def__WEBPACK_IMPORTED_MODULE_2__["ApiDefinition"]();
    }
    /**
     * Update kino booking
     * PUT /booking/kino
     * @param body
     */
    updateKinoBooking(body) {
        return this.http.put(this.api.kino_booking, body);
    }
    /**
     * Create new kino booking
     * POST /booking/kino
     * @param body
     */
    createNewKinoBooking(body) {
        return this.http.post(this.api.kino_booking, body);
    }
    /**
     * Get booking details
     * GET /booking/kino/{id}/details
     * @param id date id
     */
    getBookingDetails(id) {
        return this.http.get(this.api.kino_booking + `/${id}/details`);
    }
    /**
     * Get kino table data
     * /booking/kino
     * @param fromDate Start date YYYY-MM-DD format
     * @param toDate End date YYYY-MM-DD format
     */
    getTableData(fromDate, toDate) {
        const params = { fromDate, toDate };
        return this.http.get(this.api.kino_booking + '/table', { params });
    }
    /**
     * Create a new new invoice for Kino Booking
     * /booking/kino/{id}/invoice
     * @param id booking id
     * @param amount_given
     */
    createKinoInvoice(id, amount_given) {
        return this.http.post(this.api.kino_booking + `/${id}/invoice`, { amount_given });
    }
    /**
     * Storno a Kino Booking and create storno invoice
     * /booking/kino/{id}/storno
     * @param id booking id
     */
    stornoKinoBooking(id) {
        return this.http.post(this.api.kino_booking + `/${id}/storno`, null);
    }
    /**
     * GET /booking/kino/pdf
     * gets a pdf file
     * @param fromDate Start date YYYY-MM-DD format
     * @param toDate End date YYYY-MM-DD format
     * @returns pdf file
     */
    getPDF(fromDate, toDate) {
        const params = { fromDate, toDate };
        return this.http.get(this.api.kino_booking + '/pdf', { params, responseType: 'blob' });
    }
    /**
     * GET /booking/kino/excel
     * gets a excel file
     * @param fromDate Start date YYYY-MM-DD format
     * @param toDate End date YYYY-MM-DD format
     * @returns excel file
     */
    getExcel(fromDate, toDate) {
        const params = { fromDate, toDate };
        return this.http.get(this.api.kino_booking + '/excel', { params, responseType: 'blob' });
    }
    /**
     * Get the invoice details
     * @param invoice_id
     */
    getKinoInvoice(invoice_id) {
        return this.http.get(this.api.invoice + `/${invoice_id}/details`);
    }
};
KinoBookingService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"] }
];
KinoBookingService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"]])
], KinoBookingService);



/***/ }),

/***/ "./src/app/services/loading.service.ts":
/*!*********************************************!*\
  !*** ./src/app/services/loading.service.ts ***!
  \*********************************************/
/*! exports provided: LoadingService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LoadingService", function() { return LoadingService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let LoadingService = class LoadingService {
    constructor() {
        this.loading = false;
    }
};
LoadingService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [])
], LoadingService);



/***/ }),

/***/ "./src/app/services/nav.service.ts":
/*!*****************************************!*\
  !*** ./src/app/services/nav.service.ts ***!
  \*****************************************/
/*! exports provided: NavService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NavService", function() { return NavService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let NavService = class NavService {
    constructor() {
        this.navLinks = {
            schedule_view: {
                url: '/schedule',
                name: 'NAV.schedule_view'
            },
            table_view: {
                url: '/table-view',
                name: 'NAV.table_view'
            },
            car_market: {
                url: '/car-market',
                name: 'NAV.car_market'
            },
            kino: {
                url: '/kino',
                name: 'NAV.movie_teather'
            }
        };
    }
};
NavService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [])
], NavService);



/***/ }),

/***/ "./src/app/services/price.service.ts":
/*!*******************************************!*\
  !*** ./src/app/services/price.service.ts ***!
  \*******************************************/
/*! exports provided: PriceService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PriceService", function() { return PriceService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var _constants_api_def__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../constants/api.def */ "./src/app/constants/api.def.ts");
/* harmony import */ var _constants_price__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../constants/price */ "./src/app/constants/price.ts");





let PriceService = class PriceService {
    constructor(http) {
        this.http = http;
        this.api = new _constants_api_def__WEBPACK_IMPORTED_MODULE_3__["ApiDefinition"]();
    }
    /**
     * Returns all the prices for each type of ticket
     */
    getPrices() {
        return this.http.get(this.api.prices);
    }
    /**
     * Changes the price values
     * @param prices
     */
    changePrices(prices) {
        return this.http.put(this.api.prices, prices);
    }
    /**
     * Sets the prices localy
     * @param prices
     */
    setPrices(prices) {
        _constants_price__WEBPACK_IMPORTED_MODULE_4__["Price"].FLEA = prices.find(x => x.type === 'flea').price;
        _constants_price__WEBPACK_IMPORTED_MODULE_4__["Price"].FLEA_DISCOUNT = prices.find(x => x.type === 'flea').discount_price;
        _constants_price__WEBPACK_IMPORTED_MODULE_4__["Price"].CAR = prices.find(x => x.type === 'car').price;
        _constants_price__WEBPACK_IMPORTED_MODULE_4__["Price"].CAR_DISCOUNT = prices.find(x => x.type === 'car').discount_price;
        _constants_price__WEBPACK_IMPORTED_MODULE_4__["Price"].KINO = prices.find(x => x.type === 'kino').price;
        _constants_price__WEBPACK_IMPORTED_MODULE_4__["Price"].KINO_DISCOUNT = prices.find(x => x.type === 'kino').discount_price;
    }
};
PriceService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpClient"] }
];
PriceService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpClient"]])
], PriceService);



/***/ }),

/***/ "./src/app/shared/material/material.module.ts":
/*!****************************************************!*\
  !*** ./src/app/shared/material/material.module.ts ***!
  \****************************************************/
/*! exports provided: MaterialModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MaterialModule", function() { return MaterialModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_material_autocomplete__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/material/autocomplete */ "./node_modules/@angular/material/esm2015/autocomplete.js");
/* harmony import */ var _angular_material_badge__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/material/badge */ "./node_modules/@angular/material/esm2015/badge.js");
/* harmony import */ var _angular_material_bottom_sheet__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/material/bottom-sheet */ "./node_modules/@angular/material/esm2015/bottom-sheet.js");
/* harmony import */ var _angular_material_button__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/material/button */ "./node_modules/@angular/material/esm2015/button.js");
/* harmony import */ var _angular_material_button_toggle__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/material/button-toggle */ "./node_modules/@angular/material/esm2015/button-toggle.js");
/* harmony import */ var _angular_material_card__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @angular/material/card */ "./node_modules/@angular/material/esm2015/card.js");
/* harmony import */ var _angular_material_checkbox__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @angular/material/checkbox */ "./node_modules/@angular/material/esm2015/checkbox.js");
/* harmony import */ var _angular_material_chips__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @angular/material/chips */ "./node_modules/@angular/material/esm2015/chips.js");
/* harmony import */ var _angular_material_core__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @angular/material/core */ "./node_modules/@angular/material/esm2015/core.js");
/* harmony import */ var _angular_material_datepicker__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @angular/material/datepicker */ "./node_modules/@angular/material/esm2015/datepicker.js");
/* harmony import */ var _angular_material_dialog__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @angular/material/dialog */ "./node_modules/@angular/material/esm2015/dialog.js");
/* harmony import */ var _angular_material_divider__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @angular/material/divider */ "./node_modules/@angular/material/esm2015/divider.js");
/* harmony import */ var _angular_material_expansion__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! @angular/material/expansion */ "./node_modules/@angular/material/esm2015/expansion.js");
/* harmony import */ var _angular_material_grid_list__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! @angular/material/grid-list */ "./node_modules/@angular/material/esm2015/grid-list.js");
/* harmony import */ var _angular_material_icon__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! @angular/material/icon */ "./node_modules/@angular/material/esm2015/icon.js");
/* harmony import */ var _angular_material_input__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! @angular/material/input */ "./node_modules/@angular/material/esm2015/input.js");
/* harmony import */ var _angular_material_list__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! @angular/material/list */ "./node_modules/@angular/material/esm2015/list.js");
/* harmony import */ var _angular_material_menu__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! @angular/material/menu */ "./node_modules/@angular/material/esm2015/menu.js");
/* harmony import */ var _angular_material_paginator__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! @angular/material/paginator */ "./node_modules/@angular/material/esm2015/paginator.js");
/* harmony import */ var _angular_material_progress_bar__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! @angular/material/progress-bar */ "./node_modules/@angular/material/esm2015/progress-bar.js");
/* harmony import */ var _angular_material_progress_spinner__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! @angular/material/progress-spinner */ "./node_modules/@angular/material/esm2015/progress-spinner.js");
/* harmony import */ var _angular_material_radio__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! @angular/material/radio */ "./node_modules/@angular/material/esm2015/radio.js");
/* harmony import */ var _angular_material_select__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! @angular/material/select */ "./node_modules/@angular/material/esm2015/select.js");
/* harmony import */ var _angular_material_sidenav__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! @angular/material/sidenav */ "./node_modules/@angular/material/esm2015/sidenav.js");
/* harmony import */ var _angular_material_slide_toggle__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! @angular/material/slide-toggle */ "./node_modules/@angular/material/esm2015/slide-toggle.js");
/* harmony import */ var _angular_material_slider__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! @angular/material/slider */ "./node_modules/@angular/material/esm2015/slider.js");
/* harmony import */ var _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! @angular/material/snack-bar */ "./node_modules/@angular/material/esm2015/snack-bar.js");
/* harmony import */ var _angular_material_sort__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! @angular/material/sort */ "./node_modules/@angular/material/esm2015/sort.js");
/* harmony import */ var _angular_material_stepper__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! @angular/material/stepper */ "./node_modules/@angular/material/esm2015/stepper.js");
/* harmony import */ var _angular_material_table__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! @angular/material/table */ "./node_modules/@angular/material/esm2015/table.js");
/* harmony import */ var _angular_material_tabs__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! @angular/material/tabs */ "./node_modules/@angular/material/esm2015/tabs.js");
/* harmony import */ var _angular_material_toolbar__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! @angular/material/toolbar */ "./node_modules/@angular/material/esm2015/toolbar.js");
/* harmony import */ var _angular_material_tooltip__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! @angular/material/tooltip */ "./node_modules/@angular/material/esm2015/tooltip.js");
/* harmony import */ var _angular_material_tree__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! @angular/material/tree */ "./node_modules/@angular/material/esm2015/tree.js");
/* harmony import */ var _angular_cdk_table__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! @angular/cdk/table */ "./node_modules/@angular/cdk/esm2015/table.js");
/* harmony import */ var _angular_material_moment_adapter__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! @angular/material-moment-adapter */ "./node_modules/@angular/material-moment-adapter/esm2015/material-moment-adapter.js");






































const modules = [
    _angular_cdk_table__WEBPACK_IMPORTED_MODULE_36__["CdkTableModule"],
    _angular_material_autocomplete__WEBPACK_IMPORTED_MODULE_2__["MatAutocompleteModule"],
    _angular_material_badge__WEBPACK_IMPORTED_MODULE_3__["MatBadgeModule"],
    _angular_material_bottom_sheet__WEBPACK_IMPORTED_MODULE_4__["MatBottomSheetModule"],
    _angular_material_button__WEBPACK_IMPORTED_MODULE_5__["MatButtonModule"],
    _angular_material_button_toggle__WEBPACK_IMPORTED_MODULE_6__["MatButtonToggleModule"],
    _angular_material_card__WEBPACK_IMPORTED_MODULE_7__["MatCardModule"],
    _angular_material_checkbox__WEBPACK_IMPORTED_MODULE_8__["MatCheckboxModule"],
    _angular_material_chips__WEBPACK_IMPORTED_MODULE_9__["MatChipsModule"],
    _angular_material_stepper__WEBPACK_IMPORTED_MODULE_30__["MatStepperModule"],
    _angular_material_datepicker__WEBPACK_IMPORTED_MODULE_11__["MatDatepickerModule"],
    _angular_material_dialog__WEBPACK_IMPORTED_MODULE_12__["MatDialogModule"],
    _angular_material_divider__WEBPACK_IMPORTED_MODULE_13__["MatDividerModule"],
    _angular_material_expansion__WEBPACK_IMPORTED_MODULE_14__["MatExpansionModule"],
    _angular_material_grid_list__WEBPACK_IMPORTED_MODULE_15__["MatGridListModule"],
    _angular_material_icon__WEBPACK_IMPORTED_MODULE_16__["MatIconModule"],
    _angular_material_input__WEBPACK_IMPORTED_MODULE_17__["MatInputModule"],
    _angular_material_list__WEBPACK_IMPORTED_MODULE_18__["MatListModule"],
    _angular_material_menu__WEBPACK_IMPORTED_MODULE_19__["MatMenuModule"],
    _angular_material_moment_adapter__WEBPACK_IMPORTED_MODULE_37__["MatMomentDateModule"],
    _angular_material_paginator__WEBPACK_IMPORTED_MODULE_20__["MatPaginatorModule"],
    _angular_material_progress_bar__WEBPACK_IMPORTED_MODULE_21__["MatProgressBarModule"],
    _angular_material_progress_spinner__WEBPACK_IMPORTED_MODULE_22__["MatProgressSpinnerModule"],
    _angular_material_radio__WEBPACK_IMPORTED_MODULE_23__["MatRadioModule"],
    _angular_material_core__WEBPACK_IMPORTED_MODULE_10__["MatRippleModule"],
    _angular_material_select__WEBPACK_IMPORTED_MODULE_24__["MatSelectModule"],
    _angular_material_sidenav__WEBPACK_IMPORTED_MODULE_25__["MatSidenavModule"],
    _angular_material_slider__WEBPACK_IMPORTED_MODULE_27__["MatSliderModule"],
    _angular_material_slide_toggle__WEBPACK_IMPORTED_MODULE_26__["MatSlideToggleModule"],
    _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_28__["MatSnackBarModule"],
    _angular_material_table__WEBPACK_IMPORTED_MODULE_31__["MatTableModule"],
    _angular_material_sort__WEBPACK_IMPORTED_MODULE_29__["MatSortModule"],
    _angular_material_tabs__WEBPACK_IMPORTED_MODULE_32__["MatTabsModule"],
    _angular_material_toolbar__WEBPACK_IMPORTED_MODULE_33__["MatToolbarModule"],
    _angular_material_tooltip__WEBPACK_IMPORTED_MODULE_34__["MatTooltipModule"],
    _angular_material_tree__WEBPACK_IMPORTED_MODULE_35__["MatTreeModule"],
];
let MaterialModule = class MaterialModule {
};
MaterialModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"])({
        imports: [...modules],
        exports: [...modules],
        declarations: [],
    })
], MaterialModule);



/***/ }),

/***/ "./src/app/shared/shared.module.ts":
/*!*****************************************!*\
  !*** ./src/app/shared/shared.module.ts ***!
  \*****************************************/
/*! exports provided: SharedModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SharedModule", function() { return SharedModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
/* harmony import */ var _material_material_module__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./material/material.module */ "./src/app/shared/material/material.module.ts");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _ngx_translate_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @ngx-translate/core */ "./node_modules/@ngx-translate/core/fesm2015/ngx-translate-core.js");






const modules = [
    _angular_common__WEBPACK_IMPORTED_MODULE_2__["CommonModule"],
    _angular_forms__WEBPACK_IMPORTED_MODULE_4__["FormsModule"],
    _angular_forms__WEBPACK_IMPORTED_MODULE_4__["ReactiveFormsModule"],
    _material_material_module__WEBPACK_IMPORTED_MODULE_3__["MaterialModule"],
    _ngx_translate_core__WEBPACK_IMPORTED_MODULE_5__["TranslateModule"]
];
let SharedModule = class SharedModule {
};
SharedModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"])({
        imports: [...modules],
        exports: [...modules],
        declarations: [],
    })
], SharedModule);



/***/ }),

/***/ "./src/environments/environment.ts":
/*!*****************************************!*\
  !*** ./src/environments/environment.ts ***!
  \*****************************************/
/*! exports provided: environment */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "environment", function() { return environment; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

const environment = {
    production: false,
    // apiUrl: 'https://autokinov2.q-tests.com/api/'
    apiUrl: 'https://api.standplan.autokino.at/'
};
/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.


/***/ }),

/***/ "./src/main.ts":
/*!*********************!*\
  !*** ./src/main.ts ***!
  \*********************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_platform_browser_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/platform-browser-dynamic */ "./node_modules/@angular/platform-browser-dynamic/fesm2015/platform-browser-dynamic.js");
/* harmony import */ var _app_app_module__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./app/app.module */ "./src/app/app.module.ts");
/* harmony import */ var _environments_environment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./environments/environment */ "./src/environments/environment.ts");
/* harmony import */ var hammerjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! hammerjs */ "./node_modules/hammerjs/hammer.js");
/* harmony import */ var hammerjs__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(hammerjs__WEBPACK_IMPORTED_MODULE_5__);






if (_environments_environment__WEBPACK_IMPORTED_MODULE_4__["environment"].production) {
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["enableProdMode"])();
}
Object(_angular_platform_browser_dynamic__WEBPACK_IMPORTED_MODULE_2__["platformBrowserDynamic"])().bootstrapModule(_app_app_module__WEBPACK_IMPORTED_MODULE_3__["AppModule"])
    .catch(err => console.log(err));


/***/ }),

/***/ 0:
/*!***************************!*\
  !*** multi ./src/main.ts ***!
  \***************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! /Users/christophengelmayer/Code/flohmarkt/autokinov2-fe-be/angular-frontend/src/main.ts */"./src/main.ts");


/***/ })

},[[0,"runtime","vendor"]]]);
//# sourceMappingURL=main-es2015.js.map